import { DatePipe, JsonPipe, Location, LowerCasePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
// import { NgxExtendedPdfViewerComponent, NgxExtendedPdfViewerModule, NgxExtendedPdfViewerService, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { ChangeDetectorRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { waitForAsync } from '@angular/core/testing';
// import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { Observable } from 'rxjs';
import config from '../../../assets/config.json';
import { devOnlyGuardedExpression } from '@angular/compiler';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { DomSanitizer } from '@angular/platform-browser';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

const enum Status {
  OFF = 0,
  RESIZE = 1,
  MOVE = 2,
}

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css'],
})
export class TransactionComponent implements OnInit {

  attachmentName: string = "";
  attachmentFile: File | null = null;
  frmTransaction: FormGroup;
  submitted: boolean = false;
  transactionDetail: any;
  transactionFieldList = [];
  processQueue = [];
  transactionHistoryList = [];
  activeHistoryId: number = 0;
  fileAttachmentHistoryList = [];
  doaHistory: any = [];
  attachmentMailContent: string = ''
  dynamicTabs: any[];
  lineLevelItemList = [];
  deletedLineItems = [];
  editedLineItemIndex = 0;
  attachmentList = [];
  rejectReasonList = [];
  rejectReasonIds = [];
  checklist: any = [];
  chkSelectAllCheckList: boolean = false;
  doaApproverList: any = [];
  doaFields: any = [];
  doaMatrix: any = {};
  IsAllChecked: boolean = false;
  lineItemExcelData = [];
  invalidLineItemNo = [];
  poLineItemList: any = [];
  poPullDataMode: string = '';
  selectedPOList: any = [];
  poFieldsConfig: any = [];
  invalidPoLineItemsMasterCheck: any = [];
  poFirstGridFieldsConfig: any = [];
  poDefaultFieldsConfig: any = [];
  selectAllPOItem: boolean = false;
  totalSelectedPoQty: number = 0;
  totalSelectedPoAmount: number = 0;
  totalPOLineItemQty: number = 0;
  totalPOLineItemAmount: number = 0;
  lineItemTotalAmount: number = 0;
  invoiceAmount: number = 0;
  poQtyFieldName = '';
  poAmtFieldName = '';
  poGrandTotalFields = '';
  poLineItemErrorRemarkField = '';
  poLineItemValidateClientAPI: string = '';
  realtimePoPullAPI: string = '';
  fetchSesLineitemAPI: string = '';
  sesLineitemList: any = [];
  isPOLineItemsValid: boolean = false;
  isSESValidationRequired: boolean = false;
  isSESValidated: boolean = false;
  invalidPOLineItemNo: any = {};
  invalidPOLineItemFields: any = [];
  db_columns_values_list = {};//prakash
  dependant_dropdown_list = [];// prakash
  isEnableExcelUploadPOItemOption: boolean = true;
  poExcelUploadFileName: string = '';
  poExcelUploadBase64String: string = '';
  poTabId: number = 0;
  poItemsErrorList: any = [];

  lineItemExcelUploadFileName: string = '';
  isValidLineItemExcelData: boolean = false;
  poExcelData: any = [];
  supportDocValidFileExtensions = [];
  supportDocFileSize = {};

  isRaisedquery: boolean = false;
  strRQTO: string = '';
  strRQCC: string = '';
  emailTemplateList: any = [];
  selectedEmailTemplate: any;
  emailTypeList: any = [];
  selectedEmailType: any;
  lstRQAttachment: any = [];
  lstRQAttachment1: any = [];
  lstRQAttachment2: any = [];

  changeTypeColumnsToHide: any = ['ATTACHMENT_ID']
  strQCSubject: string = '';
  strQCSubjectPost: string = '';
  lstDomainValues: any = [];
  isDomainRequire: boolean = false;
  lstRQUserList: any = []
  RQUserColumnsToHide: any = ['USER_ID']
  isRQOpenSearchBox: number = 0;
  strQCBODY: string = '';
  //Chaya 20-July-2022 Duplicate Soft/Hard stop -- Start
  IsSoftStop: boolean = false;
  IsContinueWithoutDuplicate: boolean = false;
  //Chaya 20-July-2022 Duplicate Soft/Hard stop -- end
  IsSkipApprovalForDuplicate: boolean = false;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize'],
      ['insertImage', 'insertVideo']
    ]
  };

  //public initiator_Role: string = config.initiator_Role;
  public editenabled: boolean = false;

  activeTab: any;
  priority: any;
  documentDetailId = 0;
  nextDocumentDetailIDs = [];

  activeFieldList: [
    { tab_header_id: number; tab_header_name: string; field_details: any[] }
  ];
  invoicePrimaryDetails: any = {
    urn: '',
    docType: '',
    currentStatus: '',
    country: '',
    urnCreatedDate: '',
    source: '',
    aging: '',
    assigned_to_user: ''
  };

  fileControlType = 'file'; //for SSA fixing (we have checked upload file type)
  fileName = 'Choose File';

  transactionComment = 'transactionComment';
  nextQueue = 'nextQueue';
  uploadFileName = 'uploadFileName';
  selectedDOAApprover: number = 0;
  selectedQueueName: string = '';
  selectedApproverNameOrLevel: string = '';
  isDoaForQuery: boolean = false;

  fileBase64FileString: string = '';
  dropDownSearchText: string = '';

  showHistory: boolean = false;
  isLineLevelTab: boolean = false;
  isShowPriorityButton: boolean = true;
  isShowOpenImageButton: boolean = false;
  isShowCheckListButton: boolean = true;
  isShowHistoryButton: boolean = true;
  isDisplayPDFViewer = false;
  hasInvoiceFile: boolean = true;
  isFlipViewer: boolean = false;
  isLoadedTranHistory: boolean = false;
  isLoadedProgressHistory: boolean = false;
  isEdit: boolean = false;
  isDisplayAddButton: boolean = false;
  isDOAExists: boolean = false;
  isDOAParallel: boolean = false;
  hasRejectReasonInHistory: boolean = false;
  hasChecklistInHistory: boolean = false;
  isPOLineLevelTab: boolean = false;
  isAllowSplitInvoice: boolean = true;

  splitFileBy: string = 'INTERVAL';
  splitFromText: string = '';
  splitToText: string = '';
  splitIntervalCount: number = 2;
  splitStartIndex: number = 1;
  splitEndIndex: number = 2;
  splitExtractPageNumbers: string = '';
  splittedFiles: any = [];

  isCommentExpand: boolean = false;
  isCommentExpand_changeDocumentTypeModel: boolean = false;
  isBright: boolean = true;
  sub_doc_type_id: number = 0;
  dateFormat = new DatePipe('en-US');
  restrictedKeywords: any = [];
  ocrFieldList: any = {};
  isShowUploadedDocs: boolean = false;

  base64_bigdata: any;

  private mouse: { x: number; y: number };
  private dragStatus: Status = Status.OFF;
  public pdfViewerWidth: number;
  public FieldViewerWidth: number;
  public separatorHeight: number;
  invoiceOpenFromPage: string = '';

  public pdfViewerPosition: { left: number; top: number };
  isDuplicate: boolean = false;
  lstDuplicateData: any = []
  isShownDuplicateAlert: boolean = true;
  isShownDuplicateIcon: boolean = false;
  changeDuplicateColumnsToHide: any = ['DOCUMENT_DETAIL_ID', 'REF_DOCUMENT_DETAIL_ID', 'CLIENT_CONDITION', 'DB_COLUMN_NAMES', 'FIELD_NAME']
  duplicateDataKeys: any = [];
  searchDoaApprover: string = '';

  //added on 23-mar-2022
  isValidationRequired: boolean = true;
  next_queue_pre_validation_actions: any;
  isDuplicateCheckRequired: boolean = true;
  isRejectReasonRequired: boolean = false;
  companyType: string = "";
  ui_field_which_is_not_available = [];
  queue_movement_validation_response: any;

  isEditLineItems: boolean = true;
  isEditHeaderItems: boolean = true;

  lstDocumentType = [];
  lstProjectList = [];
  selectedProject: number = 0;
  selectedDocument: any = { documentTypeId: 0, documentTypeName: '' };
  isAllowDocumentTypeChange = false;
  changeDocumentComment = "";
  isSubDocumentTypeExist: boolean = false;
  selectedSubDocument: any = { subDocumentTypeId: 0, subDocumentTypeName: '' };
  lstSubDocumentType = [];

  processStartTime: Date;

  //Xerox Specific changes start
  lstPOMaster = [];
  advanceSeachSelectedRecord: any = {};
  advanceSearchColumnsToHide: any = [];
  strponumber: string = '1111dff';
  IsRealtimePOmodel: boolean = false;

  //Xerox Specific changes end

  // dataTranslation: string = '';
  transalatedData: string = '';
  @ViewChild('fileUpload') fileInput: ElementRef;
  @ViewChild('urnsection') public URN_Section: ElementRef;
  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;
  @ViewChild('duplicateInvoiceSubmittedModal') duplicateInvoiceSubmittedModal: ElementRef;
  @ViewChild('poExcelUploadFileControl') poExcelUploadFileControl: ElementRef;
  @ViewChild('changeDocumentTypeModal') changeDocumentTypeModal: TemplateRef<any>;
  @ViewChild('raiseQuerySearchModal') raiseQuerySearchModal: ElementRef;
  @ViewChild('lineItemExcelUploadFileControl') lineItemExcelUploadFileControl: ElementRef;

  @ViewChildren("dynamic_auto_complete") dynamic_auto_complete: QueryList<AutocompleteComponent>
  @ViewChild('sesLineitemModal') sesLineitemModal: ElementRef;
  @ViewChild('lineItemModal') lineItemModal: ElementRef;
  //Xerox Specific changes start
  @ViewChild('RealtimeDataModal') RealtimeDataModal: ElementRef;
  //Xerox Specific changes end

  // Prakash added for this field queue and role based convert UI field as readonly.
  // added on 18-May-2022.
  role_access_mst_ui_is_editable: any;
  role_access_mst_ui_is_lineitems_editable: any;

  isOpenHistory: boolean = false;

  modalReference: any;
  modalReference_ChangeDocumentType: any;

  @ViewChild('widgetsContent', { read: ElementRef })
  public widgetsContent!: ElementRef<any>;
  loadcount: number = 0;
  datatest: any;
  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mouse = {
      x: event.clientX,
      y: event.clientY,
    };
    if (this.dragStatus == Status.RESIZE) {
      this.resize();
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.dragStatus = 0;
  }
  displayStyle = "none";

  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }
  // @HostListener('document:click', ['$event'])
  // public documentOnClick(e: any) {
  //   e.stopPropagation();
  //   $('#tooltipLocal').hide();
  // }
  // @HostListener('window:beforeunload', ['$event'])
  // onBeforeUnload(e) {
  //   if (!e) e = window.event;
  //   e.cancelBubble = true;
  //   e.returnValue = 'You sure you want to leave?';
  //   if (e.stopPropagation) {
  //     e.stopPropagation();
  //     e.preventDefault();
  //   }
  // }


  //-------------------Ng2-pdf-viewer--------------------
  // @ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;
  //@ViewChild('pdfViewer') pdfComponent: PdfJsViewerComponent;
  PDFSource: any;
  renderText = true;
  originalSize = true;
  fitToPage = false;
  showAll = true;
  autoresize = false;
  showBorders = true;
  renderTextModes = [0, 1, 2];
  renderTextMode = 1;
  rotation = 0;
  zoom: any = 1;
  //zoom: any = 100;
  zoomScale: any = 'page-width';
  zoomScales = ['page-width', 'page-fit', 'page-height'];

  newPDFElement = document.createElement('div');
  //-------------------Ng2-pdf-viewer--------------------
  current_page: string = "";
  //---Ram- Start
  toleranceLimitValue: number;
  toleranceType: string;
  isSubmitEnabled: boolean = true;
  //--Ram - End

  tolerance_limit_obj = [{
    document_type_id: 0,
    tolerance_type: "",
    lower_limit_percentage: 0,
    upper_limit_percentage: 0,
    lower_limit_fixed: 0,
    upper_limit_fixed: 0
  }];
  is_required_tolerance_check: number = 0;
  is_tolerance_applicable: boolean = false;
  header_tolerance_amount_field_Name = "Amount";
  tolerance_calculated_Range: number = 0;
  splitter_enable: boolean = config.SplitEnable;
  Autoloadfilelimit: number = config.Autoloadfilelimit;
  Is_mandatory_to_check_ocr_confidence_level: boolean = true;
  //Added for bulk FileUpload 
  isLoadProgress: boolean = false;
  file: File;
  fileSize: any;
  fileSizeInWords: any;
  //end
  constructor(
    route: Router,
    private location: Location,
    public commonService: CommonService,
    private dataService: DataService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    public element: ElementRef,
    private cd: ChangeDetectorRef,
    // private pdfService: NgxExtendedPdfViewerService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {

    //this.documentDetailId = this.commonService.getUserInfoFromLocalStorage('documentDetailId');

    // if (this.commonService.getUserInfoFromLocalStorage('nextDocumentDetailIDs') != '' && this.commonService.getUserInfoFromLocalStorage('nextDocumentDetailIDs') != null && this.commonService.getUserInfoFromLocalStorage('nextDocumentDetailIDs') != undefined) {
    //   this.nextDocumentDetailIDs = this.commonService.getUserInfoFromLocalStorage('nextDocumentDetailIDs').split(',');
    // }
    if (this.memorystore.getItem('nextDocumentDetailIDs') != '' && this.memorystore.getItem('nextDocumentDetailIDs') != null && this.memorystore.getItem('nextDocumentDetailIDs') != undefined) {
      this.nextDocumentDetailIDs = this.memorystore.getItem('nextDocumentDetailIDs').split(',');
    }
    debugger;
    // this.invoiceOpenFromPage = this.commonService.getUserInfoFromLocalStorage('invoiceOpenFromPage');
    this.invoiceOpenFromPage = this.memorystore.getItem('invoiceOpenFromPage');
    // pdfDefaultOptions.assetsFolder = 'bleeding-edge';

    if (route.getCurrentNavigation().extras.state != undefined) {
      this.documentDetailId = route.getCurrentNavigation().extras.state.documentDetailId;
      this.invoiceOpenFromPage = route.getCurrentNavigation().extras.state.sourcePage;
    }

    // this.documentDetailId = this.commonService.getUserInfoFromLocalStorage('documentDetailId');
    // this.current_page = this.commonService.getUserInfoFromLocalStorage('currentpage');
    this.documentDetailId = this.memorystore.getItem('documentDetailId');
    this.current_page = this.memorystore.getItem('currentpage');
    EmmiterService.get('DayNightClick').subscribe((res) => {
      this.isBright = res;
    });
    debugger;
    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.processStartTime = new Date();
    // this.isOpenHistory = JSON.parse(this.commonService.getUserInfoFromLocalStorage('isOpenHistory'));
    this.isOpenHistory = JSON.parse(this.memorystore.getItem('isOpenHistory'));
  }

  workItemFieldChildList = [];
  workItemFieldChildList_upload = []

  async getWorkItemAllFields() {

    //("inside getWorkItemAllFields");
    this.workItemFieldChildList = [];
    let params = {
      project_id: this.transactionDetail.project_id,
      document_type_id: this.transactionDetail.document_type_id,
    };

    this.dataService.getData('child_fields', params).subscribe((res) => {

      if (res != null)
        this.workItemFieldChildList = res.data;

      this.workItemFieldChildList_upload = this.workItemFieldChildList.filter(f => f.is_coding_template_upload == 1);

      this.workItemFieldChildList_upload.forEach(async field => {
        if (field.control_type == "DROPDOWN") {
          let dropdown_dependant_parameter = {};
          field.dropdown_dependant_parameter = dropdown_dependant_parameter;
          field.options = await this.commonService.getDropdownData_Excel(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
          field.searchText = '';
        }
      });

    }, err => {
    });
  }

  getProcessAccessForRole() {

    let params = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      role_id: this.commonService.selectedRole,
      process_id: this.transactionDetail.process_id.toString(),
      document_type_id: this.transactionDetail.document_type_id.toString(),
    };
    let bodydata = {
      //  project_id: this.commonService.selectedProject,
      //   subgroup_id: this.commonService.selectedSubgroup,
      //   role_id: this.commonService.selectedRole,
      //   process_id: this.transactionDetail.process_id.toString(),
      //   document_type_id: this.transactionDetail.document_type_id.toString(),
      project_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      subgroup_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup),
      role_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      process_id: this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.process_id.toString()),
      document_type_id: this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.document_type_id.toString()),
    };
    //changed getData to postData
    this.dataService.postData('process-access-role', bodydata).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.isEditHeaderItems = (res.data[0] ?.editable == '0' ? false : true);
          this.isEditLineItems = (res.data[0] ?.edit_lineitems == '0' ? false : true);
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },  error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    })
  }

  downloadExcelTemplate() {
    let lstFile = [];
    let obj = {};
    let master_data = [];

    if (this.workItemFieldChildList != null) {
      this.workItemFieldChildList.forEach(field => {
        if (field.control_type != "FILE") {
          obj[field.field_name] = '';
        }
      });
      //populate master data in excel sheet
      //   var master_data_length = 0;
      //   this.workItemFieldChildList.forEach(field => {
      //     if (field.control_type == "DROPDOWN") {
      //       if (field.options.length > master_data_length) {
      //         master_data_length = field.options.length;
      //       }
      //     }
      //   });

      //   for (var i = 0; i < master_data_length; i++) {
      //     let obj1 = {};
      //     this.workItemFieldChildList.forEach(field => {
      //       if (field.control_type == "DROPDOWN") {
      //         if (field.options.length <= master_data_length && field.options.length >= i) {
      //           obj1[field.field_name] = field.options.map((d) => d.id)[i];
      //         }
      //       }
      //    });

      //  master_data.push(obj1);
      //}
    }

    lstFile.push(obj);

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(lstFile);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');

    //const ws_master: XLSX.WorkSheet = XLSX.utils.json_to_sheet(master_data); //master data
    //ws_master['!protect'] = { selectLockedCells: false, autoFilter: false, formatColumns: false }; //master data
    //XLSX.utils.book_append_sheet(wb, ws_master, 'MasterData'); //master data

    XLSX.writeFile(wb, this.transactionDetail.document_type_name + '_' + new Date().getTime() + '.xlsx');

  }

  // word count var start
  wordsTotal: any = 1000;
  strComments: string = '';
  showUploadcontroll: boolean = true;
  // uploadFlag: any[] = [1, 2, 3, 4, 5,26];
  projectIdForUploadFlag: number;

  // word count ver end

  ngOnInit(): void {
    //added by venkat for Enabling/disabling upload functionality based on Project -03062024
    this.projectIdForUploadFlag = this.commonService.selectedProject;
    var selected_id = config.not_require_upload_project.filter(x => x == this.projectIdForUploadFlag);
    if (selected_id != undefined && selected_id != null && selected_id.length != 0) {
      this.showUploadcontroll = false;
    } else {
      this.showUploadcontroll = true;
    }
    //ends here
    this.getTransactionDetail();
  }

  // add word count function start
  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }
  // add word count function end

  ngAfterViewInit(): void {

  }
  ngAfterViewChecked() {
    if ((document.querySelector('.unverified-signature-warning') as HTMLElement) !== null) {
      (document.querySelector('.unverified-signature-warning') as HTMLElement).style.display = 'none';
    }
  }
  getTransactionDetail() {
    if (this.documentDetailId == 0 || this.documentDetailId == null) return;
    debugger;
    let params = new HttpParams();
    // this.editRoleId = this.commonService.selectedRole;
    params = params.append('document_detail_id', this.documentDetailId.toString());
    params = params.append('role_id', this.commonService.selectedRole);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    // params = params.append("document_detail_id", this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId.toString()));
    // params = params.append("role_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole))
    // params = params.append("subgroup_id", this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup))
    params = params.append('module_name', 'PI');
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));//Added by imran on 01-04-26

    this.dataService.getData('transaction', params).subscribe(
      (res) => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res != undefined) {
            this.transactionDetail = res.data;
          }
          if ((res.data.process_name == "Draft Idea" || res.data.process_name == "Sent back for Review")) {
            // if (res.data.created_by == this.commonService.getUserInfoFromLocalStorage('userName')) {
            if (res.data.created_by == this.memorystore.getItem('userName')) {
              this.isSubmitEnabled = true;
            } else {
              this.isSubmitEnabled = false;
            }
          } else {
            this.isSubmitEnabled = true;
          }
          if (this.transactionDetail != null) {

            //Nilesh-- (20 July,2022)--Start
            // if (this.transactionDetail.lock_user_id > 0 && this.transactionDetail.lock_user_id != this.commonService.getUserInfoFromLocalStorage('userId')) {
            if (this.transactionDetail.lock_user_id > 0 && this.transactionDetail.lock_user_id != this.memorystore.getItem('userId')) {
              const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                disableClose: true,
                data: {
                  title: "Work Item Locked",
                  messageBoxType: 'ok',
                  message: 'This work item has been locked by the user ' + this.transactionDetail.lock_user_name + '.',
                },
              });
              dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                  this.onBackButtonClick(false)
                }
              });
            }
            else {
              if (this.transactionDetail.lock_user_id <= 0) {
                // let params = new HttpParams;
                // params = params.append("document_detail_id", this.documentDetailId.toString());
                // // params = params.append("user_id", this.commonService.getUserInfoFromLocalStorage('userId'));
                // params = params.append("user_id", this.memorystore.getItem('userId'));
                let bodydata = {
                  documentdetailid: (this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId.toString())),
                  encuserid: (this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')))
                }
                // this.dataService.getData('setlock', params).subscribe((res) => {
                this.dataService.postData('setlock', bodydata).subscribe((res) => {
                  if (res != null && (res.errorMessage == null || res.errorMessage == "")) { }
                  else {
                    if (res.errorCode != 0 && res.errorCode == 4000) {
                      this.router.navigateByUrl('/unauthorized');
                      return;
                    }
                    if (res.errorCode != 0 && res.errorCode == 3000) {
                      this.commonService.showMessageBox("Internal error")
                    }
                  }
                },
                error => {
                  if (error.includes("401")) {
                    this.router.navigateByUrl('/unauthorized');
                    return;
                  }
                });
              }
            }
            //Nilesh-- (20 July,2022)--End

            this.getSupportingDocuments();

            this.sub_doc_type_id = this.transactionDetail.sub_document_type_id;
            this.processQueue = this.transactionDetail.next_processes.sort(
              function (a, b) {
                if (a.process_name < b.process_name) {
                  return -1;
                }
                if (a.process_name > b.process_name) {
                  return 1;
                }
                return 0;
              }
            );

            this.dynamicTabs = this.transactionDetail.tabs;

            let assigned_to_user_det = this.transactionDetail.assigned_to_user_display_name;
            if (assigned_to_user_det != "" && assigned_to_user_det != null && assigned_to_user_det != undefined) {
              assigned_to_user_det = this.transactionDetail.assigned_to_user_display_name + "( " + this.transactionDetail.assigned_to_user_email + " )";
            }
            else {
              assigned_to_user_det = "";
            }
            // Prakash added for this field queue and role based convert UI field as readonly.
            // added on 18-May-2022.
            this.role_access_mst_ui_is_lineitems_editable = (this.transactionDetail.edit_lineitems == 1);
            this.role_access_mst_ui_is_editable = (this.transactionDetail.is_editable == 1);

            this.invoicePrimaryDetails = {
              urn: this.transactionDetail.urn,
              docType: this.transactionDetail.document_type_name,
              currentStatus: this.transactionDetail.process_name,
              country: this.transactionDetail.hasOwnProperty('subgroup_name')
                ? this.transactionDetail.subgroup_name
                : '',
              urnCreatedDate: this.dateFormat.transform(
                new Date(this.transactionDetail.created_date.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                'dd-MMM-yyyy'
              ),
              source: this.transactionDetail.source,
              aging: '',
              assigned_to_user: assigned_to_user_det
            };

            this.priority = this.transactionDetail.priority;
            this.isAllowDocumentTypeChange = this.transactionDetail.is_allow_document_type_change;
            this.isShowHistoryButton =
              this.transactionDetail.options[0].history == '1' ? true : false;
            this.checklist = this.transactionDetail.checklist;
            this.checklist.forEach((element) => {
              element['checked'] = false;
            });

            this.isShowCheckListButton = this.checklist.length > 0;



            if (this.transactionDetail.invoice_file[0].invoice_file_encoded == null || this.transactionDetail.invoice_file[0].invoice_file_encoded == '' || this.transactionDetail.invoice_file[0].invoice_file_encoded == undefined) {
              this.hasInvoiceFile = false;
              this.isDisplayPDFViewer = false;
            }
            else {
              if (this.transactionDetail.pdf_file_size < Number(this.Autoloadfilelimit)) {
                this.isDisplayPDFViewer = true;
                if (this.transactionDetail.is_allow_manual_data_extraction_from_file) {
                  this.base64ToBlob()
                }
                this.loadcount = 1;
              }
            }


            if (!config.isDisplayPDFViewer) {
              this.hasInvoiceFile = false;
              this.isDisplayPDFViewer = false;
            }

            if (this.isDisplayPDFViewer) {
              var col_1_size = Number(this.URN_Section.nativeElement.offsetWidth) / 12;
              this.pdfViewerWidth = (col_1_size * 7) - 10;
              this.FieldViewerWidth = (col_1_size * 5) - 10;
            }

            this.tolerance_limit_obj = this.transactionDetail.tolerance_limitObj;
            this.is_tolerance_applicable = this.transactionDetail.is_tolerance_applicable;

            this.getTransactionFields();

            if (this.isOpenHistory)
              this.getHistory()

            this.isDOAExists = res.data.has_doa == 1;
            if (this.isDOAExists) {
              if (res.data.doa_fields != null) {
                res.data.doa_fields.forEach(element => {
                  element.doa_rule = JSON.parse(element.doa_rule);
                });
                this.doaFields = res.data.doa_fields;
              }
              else {
                this.doaFields = [];
              }
            }
            this.get_ocr_process_status(this.transactionDetail.process_id, this.transactionDetail.document_type_id);
            if (this.transactionDetail.process_name.toUpperCase() == "POTENTIAL DUPLICATE") {
              this.isShownDuplicateIcon = true;
            }
            else {
              this.isShownDuplicateIcon = false;
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  ocrFocus(field) {
    if (field.is_ocr) {
      field.confidence_level = 100;
      //field.ocr_confidence_level_cssclass = 'ocr-blue';
      field.ocr_confidence_level_cssclass = 'ocr-green';
    }
    if (this.transactionDetail.is_allow_manual_data_extraction_from_file == true) {
      // this.getCoordinates(field);
    }
  }

  async getOcrFields() {
    let params = new HttpParams();
    params = params.append('document_detail_id', this.documentDetailId);
    params = params.append('document_type_id', this.transactionDetail.document_type_id);
    params = params.append('project_id', this.transactionDetail.project_id);
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    // params = params.append('document_detail_id', this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId));
    // params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.document_type_id));
    // params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.project_id));
    let arr = []

    await this.dataService.getDataPromise('ocr/get_ocr_fields_data', params).then((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        arr = res.data;
        arr ?.forEach(a => {
          this.ocrFieldList[a.db_column_name] = {
            ocr_confidance_level: parseInt(a.ocr_confidance_level),
            ocr_confidance_level_cssclass: a.ocr_confidance_level_cssclass,
            ocr_coordinate: a.ocr_coordinate.toString()
          }
        });
      }
      else {
        if (res.errorCode != 0 && res.errorCodes == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });

  }

  getTransactionFields() {
    this.getSupportingDocuments();
    this.getOcrFields();
    this.getProcessAccessForRole();
    this.transactionFieldList = [];
    const formControls: any = {};
    formControls[this.nextQueue] = new FormControl(
      this.processQueue.length == 1 ? this.processQueue[0].process_id : '',
      []
    );
    if (this.transactionDetail.is_comment_mandatory == true) {
      formControls[this.transactionComment] = new FormControl('', [Validators.required,]);
    } else {
      formControls[this.transactionComment] = new FormControl('', []);
    }

    formControls[this.uploadFileName] = new FormControl('', []);

    let index = 0;
    this.dynamicTabs.forEach(async (tab) => {

      let params = new HttpParams();
      params = params.append('document_detail_id',this.documentDetailId.toString());
      params = params.append('document_type_id',this.transactionDetail.document_type_id.toString());
      params = params.append('role_id', this.commonService.selectedRole);
      params = params.append('project_id', this.commonService.selectedProject);
      params = params.append('tab_id', tab.tab_id.toString());
      params = params.append('process_id',this.transactionDetail.process_id.toString());
      params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));//Added by imran on 01-04-26
      // params = params.append('document_detail_id', this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId.toString()));
      // params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.document_type_id.toString()));
      // params = params.append('role_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
      // params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
      // params = params.append('tab_id', this.encryptDecryptservice.encryptUsingAES256(tab.tab_id.toString()));
      // params = params.append('process_id', this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.process_id.toString()));
      await this.dataService.getDataPromise('transaction-tabs', params).then((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          index++;
          if (res == null || res == undefined) {
            return;
          }
          if (this.processQueue.length == 1) {
            setTimeout(() => {
              this.changeQueue();
            }, 2000);
          }

          this.transactionFieldList[tab.tab_id] = res.data;

          if (tab.tab_field_type == 'LINEITEM' || tab.tab_field_type == "POLINEITEM") {
            if (tab.tab_field_type == "POLINEITEM") {
              this.poTabId = tab.tab_id;
            }
            res.data.forEach((row) => {
              this.lineLevelItemList[tab.tab_id] = row.field_value_details;
              if (tab.tab_field_type == 'LINEITEM') {
                this.getNonPoLineItemAmountTotal(tab.tab_id);
              }
              let i = 0;
              this.lineLevelItemList[tab.tab_id].forEach((line) => {
                if (tab.tab_field_type == "POLINEITEM" || tab.tab_field_type == 'LINEITEM') {
                  line['isSelected'] = false;
                }
                line['rowIndex'] = i;
                i++;
              });
            });
          }

          if (this.dynamicTabs.length == index) {
            let dropdown_dependant_index = 0;
            this.transactionFieldList.forEach((section) => {
              section.forEach(a => {
                a.field_details.forEach(async (field) => {

                  field.is_mandatory_db = field.is_mandatory;
                  this.db_columns_values_list[field.db_column_name] = field.field_value;
                  field["confidence_level"] = 0;
                  field["is_ocr"] = false;
                  field["ocr_confidence_level_cssclass"] = "";

                  if (this.ocrFieldList.hasOwnProperty(field.db_column_name)) {
                    field.is_ocr = true;
                    field.confidence_level = this.ocrFieldList[field.db_column_name].ocr_confidance_level;
                    if (field.is_editable == 1) {
                      field.ocr_confidence_level_cssclass = this.ocrFieldList[field.db_column_name].ocr_confidance_level_cssclass;
                    }
                    else {
                      field.ocr_confidence_level_cssclass = '';
                    }
                  }
                  if (field.actions != null) {
                    field.actions = JSON.parse(field.actions);
                  }
                  let fieldValidators = [];
                  if (field.is_mandatory == 1 && field.field_type != 'CHILD')
                    fieldValidators.push(Validators.required);

                  if (field.is_po_match_amount_column && field.field_type == "PARENT") {
                    this.header_tolerance_amount_field_Name = field.field_name;
                  }

                  if (field.control_type == 'DROPDOWN') {
                    let magnify_dependant_fields = {};
                    let dropdown_dependant_parameter = {};

                    if (field.magnify_dependant_fields != null && field.magnify_dependant_fields != undefined) {
                      magnify_dependant_fields = JSON.parse(field.magnify_dependant_fields);
                      Object.keys(magnify_dependant_fields).forEach(x => {

                        let field_value = this.db_columns_values_list[magnify_dependant_fields[x]];
                        if (field_value != null && field_value != '' && field_value != undefined) {
                          // let depend_optionlist = this.db_columns_values_list[magnify_dependant_fields[x] + "_option"];
                          // if (depend_optionlist != undefined && depend_optionlist != null) {

                          //   let depend_selection = depend_optionlist.filter((item) => {
                          //     item.id == Number(field_value);
                          //   });
                          //   if (depend_selection.length > 0) {
                          //     field_value = depend_selection[0].name;
                          //   }
                          // }
                          dropdown_dependant_parameter[x] = field_value.toString();
                        }
                      });
                    }
                    field.dropdown_dependant_parameter = dropdown_dependant_parameter;

                    if (field.is_autocomplete == 0 && field.is_readonly == 0) {
                      field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
                      //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
                    }
                    else if (field.is_autocomplete == 0 && field.is_readonly == 1) {
                      if (field.field_value == "" || field.field_value == undefined)
                        field.field_value = 0;

                      field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
                    }
                    else {
                      if (field.field_value == "" || field.field_value == undefined)
                        field.field_value = "";

                      field.options = await this.commonService.getAutocomplete_dropdowndata(field.field_mapping_detail_id, field.field_value, 'id')
                      //this.db_columns_values_list[field.db_column_name + "_option"] = field.options
                    }
                    field.searchText = '';
                    //Gabriel start
                    //dependant field event called for page load if fields readonly
                    if (field.is_dependant == 1 && field.field_value != null) {
                      // this.getDependantFields(field.field_mapping_detail_id, fieldVal);                    
                      this.getDependantFields(
                        field.field_mapping_detail_id, field.field_value
                      );
                      //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, 0, dropdown_dependant_parameter);
                      //field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value, dropdown_dependant_parameter);
                    }
                    //Gabriel end

                  }

                  if (formControls.hasOwnProperty(field.db_column_name)) {
                    field.field_value = formControls[field.db_column_name].value;
                  }

                  formControls[field.db_column_name] = new FormControl(
                    {
                      value:
                        field.control_type == 'DROPDOWN'
                          ? Number.isNaN(field.field_value) || field.field_value == '' || field.field_value == null
                            ? field.field_value
                            : +field.field_value
                          : field.control_type == 'CHECKBOX'
                            ? field.field_value == null ? false : (field.field_value.toLowerCase() == 'true' || field.field_value == 1)
                            : field.control_type == 'DATE' ? (field.field_value == null || field.field_value == '' ? '' : new Date(field.field_value))
                              : field.validation_type == 'AMOUNT' ? this.commonService.convertToAmountFormat(field.field_value)
                                : field.field_value,
                      disabled: field.is_readonly == 1 || field.is_editable == 0,
                    },
                    fieldValidators
                  );

                  if (field.control_type == 'TEXTBOX') {
                    field.value_type =
                      field.validation_type == 'NUMERIC' ? 'number' : 'text';
                  }
                });
              });
            });

            this.frmTransaction = new FormGroup(formControls);
            this.activeTab = this.dynamicTabs[0];

            this.activeFieldList = this.transactionFieldList[this.activeTab.tab_id];
            let polineItemTab = this.dynamicTabs.find((x) => x.tab_field_type == "POLINEITEM");

            //this.isPOLineLevelTab = (this.dynamicTabs.find((x) => x.tab_field_type == "POLINEITEM"));//by prakash
            const hasPOLineItem = (this.dynamicTabs.find((x) => x.tab_field_type == "POLINEITEM"));//by Vinod

            // Prakash , on page I have load po line item data and total amount should be calculated
            // queue movement validation. currently totalPOlineiteamount getting calcualted
            // after the user click the PO pull tab, thats y I have written the code like this.
            // please discuss with me before you are going to change anything.
            //if (this.isPOLineLevelTab) {
            if (hasPOLineItem) {
              this.getPoMatchData(polineItemTab.tab_id);
            }

            //to get line item fields for excel upload
            let isContainsLineLevel = (this.dynamicTabs.find((x) => x.tab_field_type == "LINEITEM"));
            if (isContainsLineLevel) {
              this.getWorkItemAllFields();
            }

            // execute actions/query if any
            // this.transactionFieldList.forEach((tab) => {
            //   tab.forEach(section => {
            //     let section_field_details = section.field_details.filter(f => f.actions != null);
            //     if (section_field_details != null && section_field_details.length > 0) {
            //       section_field_details.forEach(field => {

            //         field.actions.forEach(action => {
            //           if (action.action_type == 'SET_VALUE' && action.execute_mode == 'NORMAL') {
            //             this.frmTransaction.get(action.target_db_column_name)
            //               .setValue(this.frmTransaction.get(action.source_db_column_name).value);
            //           }
            //           if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
            //             let formula = action.formula;

            //             action.formula_fields.split(",").forEach(f => {
            //               let field_value = this.frmTransaction.get(f).value;
            //               formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
            //             });


            //             let formulaValue = eval(formula);

            //             this.frmTransaction.get(action.target_db_column_name)
            //               .setValue(formulaValue);


            //             let target_field = section.field_details.filter(item => item.db_column_name == action.target_db_column_name);
            //             if (target_field != null && target_field.length > 0) {
            //               target_field = target_field[0];
            //               if (target_field.validation_type == 'NUMERIC') {
            //                 formulaValue = this.commonService.handleNumberInput(target_field, formulaValue);
            //                 this.frmTransaction.get(action.target_db_column_name).setValue(formulaValue);
            //               }
            //             }
            //           }

            //           if (action.action_type == 'VALIDATION' && action.action_trigger == 'VALUE_CHANGE') {

            //             if (action.validation_type == 'MANDATORY') {
            //               let targetField: any;
            //               this.activeFieldList.forEach(section => {
            //                 let f = section.field_details.find(a => a.db_column_name == action.target_db_column_name);
            //                 if (f != undefined)
            //                   targetField = f;
            //               })

            //               if (targetField.is_mandatory_db == 1) {
            //                 let formula = action.formula;
            //                 let fieldValue: any;
            //                 action.formula_fields.split(",").forEach(f => {
            //                   fieldValue = this.frmTransaction.get(f).value;
            //                   formula = formula.replace(f, (fieldValue != "" && fieldValue != undefined && fieldValue != null) ? Number(fieldValue) : 0);
            //                 });

            //                 let v = eval(formula);

            //                 if (v == true) {
            //                   this.frmTransaction.get(action.target_db_column_name).addValidators([Validators.required]);
            //                   this.activeFieldList.forEach(section => {
            //                     let f = section.field_details.find(a => a.db_column_name == action.target_db_column_name);
            //                     if (f != undefined)
            //                       f.is_mandatory = 1;
            //                   })
            //                 }
            //                 else {
            //                   this.frmTransaction.get(action.target_db_column_name).removeValidators([Validators.required]);
            //                   this.activeFieldList.forEach(section => {
            //                     let f = section.field_details.find(a => a.db_column_name == action.target_db_column_name);
            //                     if (f != undefined)
            //                       f.is_mandatory = 0;
            //                   })
            //                 }
            //                 this.frmTransaction.controls[action.target_db_column_name].updateValueAndValidity();
            //               }
            //             }
            //           }

            //         });
            //       });
            //     }
            //   });
            // });

            this.transactionFieldList.forEach((tab) => {
              tab.forEach(section => {
                let section_field_details = section.field_details.filter(f => f.actions != null);
                if (section_field_details != null && section_field_details.length > 0) {
                  section_field_details.forEach(field => {
                    this.setDynamicMandatoryFieldValidation(field, section);
                  });
                }
              });
            });

            if (this.isDOAExists) {
              setTimeout(() => {
                this.getDOAMatrix();
              }, 1000);
            }
            setTimeout(() => { this.changeQueue(); }, 1000);// on page load next_queue validation not loading.
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }).catch((err) => {
      });

    });

  }

  setDynamicMandatoryFieldValidation(field: any, section: any) {
    // this.transactionFieldList.forEach((tab) => {
    //   tab.forEach(section => {
    //     let section_field_details = section.field_details.filter(f => f.actions != null);
    //     if (section_field_details != null && section_field_details.length > 0) {
    //       section_field_details.forEach(field => {
    //       });
    //     }
    //   });
    // });

    field.actions.forEach(action => {
      if (action.action_type == 'SET_VALUE' && action.execute_mode == 'NORMAL') {
        this.frmTransaction.get(action.target_db_column_name)
          .setValue(this.frmTransaction.get(action.source_db_column_name).value);
      }
      if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
        let formula = action.formula;

        action.formula_fields.split(",").forEach(f => {
          let field_value = this.frmTransaction.get(f).value;
          formula = formula.replaceAll(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
        });

        let formulaValue = eval(formula);

        let target_field = section.field_details.filter(item => item.db_column_name == action.target_db_column_name);
        if (target_field != null && target_field.length > 0) {
          target_field = target_field[0];
          if (target_field.control_type.toLowerCase() != 'date') {
            this.frmTransaction.get(action.target_db_column_name).setValue(formulaValue);
          }
          if (target_field.validation_type == 'NUMERIC') {
            formulaValue = this.commonService.handleNumberInput(target_field, formulaValue);
            this.frmTransaction.get(action.target_db_column_name).setValue(formulaValue);
          }
        }
      }

      if (action.action_type == 'VALIDATION' && action.action_trigger == 'VALUE_CHANGE') {

        if (action.validation_type == 'MANDATORY') {
          if (action.execute_mode == 'NORMAL') {
          }
          else if (action.execute_mode == 'FORMULA') {
            let targetField: any;
            this.activeFieldList.forEach(section => {
              let f = section.field_details.find(a => a.db_column_name == action.target_db_column_name);
              if (f != undefined)
                targetField = f;
            })

            if (targetField.is_mandatory_db == 1) {
              let formula = action.formula;
              let fieldValue: any;
              action.formula_fields.split(",").forEach(f => {
                fieldValue = this.frmTransaction.get(f).value;
                formula = formula.replaceAll(f, (fieldValue != "" && fieldValue != undefined && fieldValue != null) ? Number(fieldValue) : 0);
              });

              let v = eval(formula);

              if (v == true) {
                this.frmTransaction.get(action.target_db_column_name).addValidators([Validators.required]);
                this.activeFieldList.forEach(section => {
                  let f = section.field_details.find(a => a.db_column_name == action.target_db_column_name);
                  if (f != undefined)
                    f.is_mandatory = 1;
                })
              }
              else {
                this.frmTransaction.get(action.target_db_column_name).removeValidators([Validators.required]);
                this.activeFieldList.forEach(section => {
                  let f = section.field_details.find(a => a.db_column_name == action.target_db_column_name);
                  if (f != undefined)
                    f.is_mandatory = 0;
                })
              }
              this.frmTransaction.controls[action.target_db_column_name].updateValueAndValidity();
            }
          }
        }
      }

    });
  }

  getHistory() {
    if (this.documentDetailId == 0 || this.documentDetailId == null) return;

    if (!this.showHistory && !this.isLoadedTranHistory) {
      this.isLoadedTranHistory = true;

      this.transactionHistoryList = [];
      this.fileAttachmentHistoryList = [];

      let params = new HttpParams();
       //addedd and commented the code by imran on 09-01-2026
        params = params.append('documentDetailId', this.documentDetailId);
        params = params.append('documentTypeId', this.transactionDetail.document_type_id);
        params = params.append('roleId', this.commonService.selectedRole);
        params = params.append('projectId', this.commonService.selectedProject);
        params = params.append('module_name', 'AP');
        params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
      // params = params.append('documentDetailId', this.documentDetailId);
      // params = params.append('documentTypeId', this.transactionDetail.document_type_id);
      // params = params.append('roleId', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
      // params = params.append('projectId', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
      // params = params.append('module_name', 'AP');

      this.dataService.getDataPromise('transaction-history', params).then((res) => {
        if (res != null && res != undefined) {
          res.data.comments_history.forEach((x) => {
            this.transactionHistoryList.push({
              refId: x.id,
              fromProcess: x.from_process,
              toProcess: x.to_process,
              reason: x.reject_reason,
              changedDate: x.changed_dt,
              changedBy: x.changed_by,
              comment: (x.comments == null || x.comments == undefined ? '' : x.comments),
              duration: this.commonService.secondsTo_dd_hh_mm_ss(x.duration),
              checklist: x.checklist,
              processingTime: x.processing_time
            });
          });

          res.data.attachments_history.forEach((x) => {
            this.fileAttachmentHistoryList.push({
              id: x.attachment_id,
              attachmentMode: x.mode_of_attachment,
              fileName: x.attachment_name,
              actialFileName: x.actual_attachment_name,
              uploadedDate: x.created_dt,
              uploadedBy: x.created_by_name,
              bodyContent: x.body_content,
              isFinalMail: x.is_final_email,
              uploadedById: x.created_by_id,
              isSupportingFile: x.is_supporting_file,
              ref_history_id: x.document_history_id,
            });
          });

          res.data.doa_history.forEach((x) => {
            this.doaHistory.push({
              id: x.user_id,
              approver: x.approver,
              assignedBy: x.assigned_by,
              assignedDate: x.assigned_date,
              approvedBy: x.approved_by,
              approvedDate: x.approved_date,
              currentStatus: x.current_status,
              level: x.level,
              ref_history_id: x.document_history_id,
            });
          });

          this.hasRejectReasonInHistory =
            this.transactionHistoryList.findIndex((x) => x.reason != '') > -1;
          this.hasChecklistInHistory =
            this.transactionHistoryList.findIndex((x) => x.checklist != '') >
            -1;
          this.isLoadedTranHistory = false;
        }
      });
    }

    this.showHistory = !this.showHistory;
  }

  getDOAMatrix() {

    this.doaFields.forEach((x) => {
      x.doa_rule.forEach(r => {
        if (this.frmTransaction.controls[r.DB_COLUMN_NAME] == undefined) {
          r.VALUE = '';
        } else {
          r.VALUE = this.frmTransaction.get(r.DB_COLUMN_NAME).value ?.toString();
        }
        // this.activeFieldList.forEach((row) => {
        //   row.field_details.forEach((field) => {
        //     if (field.db_column_name == r.DB_COLUMN_NAME && field.control_type == 'DROPDOWN') {
        //       const fieldText = field.options.find((d) => d.id == r.VALUE)?.name;
        //       r.VALUE = fieldText == undefined ? '' : fieldText;
        //     }
        //   });
        // });
        this.transactionFieldList[this.dynamicTabs.find((x) => x.tab_field_type == 'NORMAL').tab_id].forEach((row) => {
          row.field_details.forEach((field) => {
            if (field.db_column_name == r.DB_COLUMN_NAME && field.control_type == 'DROPDOWN') {
              const fieldText = field.options.find((d) => d.id == r.VALUE) ?.name;
              r.VALUE = fieldText == undefined ? '' : fieldText;
            }
          });
        });
      });
    });

    let params = new HttpParams();
    params = params.append('document_detail_id', this.documentDetailId);
    params = params.append('document_type_id', this.transactionDetail.document_type_id);
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('process_id', this.transactionDetail.process_id);
    params = params.append('next_process_id', this.frmTransaction.get(this.nextQueue).value == '' ? '0' : this.frmTransaction.get(this.nextQueue).value);
    params = params.append('field_vals', this.doaFields.length > 0 ? JSON.stringify(this.doaFields) : null);

    this.dataService.getData('doa-matrix', params).subscribe((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          this.doaMatrix = res.data.doa_matrix;
          this.isDOAParallel = this.doaMatrix.doa_matrix_name.toLowerCase().includes('parallel');
          this.doaApproverList = res.data.doa_approvers;
          if (this.doaApproverList.length == 1) {
            this.selectedDOAApprover = this.doaApproverList[0].USER_ID;
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  getDependantFields(fieldMappingDetailId: number, selectedValue: any) {
    let params = new HttpParams();
    params = params.append('field_mapping_detail_id', fieldMappingDetailId);
    params = params.append('selected_value', selectedValue);
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined) {
          if (res.data ?.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                this.activeFieldList.find((x) =>
                  x.field_details.find((f) => {
                    if (f.db_column_name == ele.db_column_name) {
                      const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];
                      // f.options = uniqueData;
                      // //this.frmTransaction.get(f.db_column_name).setValue(f.field_value??'');
                      // if (uniqueData.length == 1) {
                      //   this.frmTransaction
                      //     .get(ele.db_column_name)
                      //     .setValue(uniqueData[0]['id']);
                      // }
                      if (ele.values.length > 0) {
                        var isDependentSelected = ele.values[0].hasOwnProperty('selected');
                        if (!isDependentSelected) {
                          f.options = uniqueData;
                          this.frmTransaction.get(f.db_column_name).setValue(f.field_value);
                        }
                        else {
                          this.frmTransaction.get(f.db_column_name).setValue(ele.values[0]['id']);
                        }
                        if (uniqueData.length == 1 && !isDependentSelected) {
                          this.frmTransaction
                            .get(ele.db_column_name)
                            .setValue(uniqueData[0]['id']);

                          this.changeDropdownFieldValue(f);
                        }
                      }
                    }
                  })
                );
              } else if (ele.control_type == 'TEXTBOX' && ele.values.length > 0) {
                this.frmTransaction
                  .get(ele.db_column_name)
                  .setValue(ele.values[0].name);
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  onTabClick(tab) {
    this.activeTab = tab;
    this.activeFieldList = this.transactionFieldList[this.activeTab.tab_id];
    this.isLineLevelTab = tab.tab_field_type == "LINEITEM" || tab.tab_field_type == "POLINEITEM";
    this.isPOLineLevelTab = tab.tab_field_type == "POLINEITEM";

    this.isDisplayAddButton = false;

    this.activeFieldList.forEach((row) => {
      if (this.isLineLevelTab && !this.isPOLineLevelTab && row.field_details.length > 0) {
        this.isDisplayAddButton = true;
      }
      row.field_details.forEach(field => {
        if (field.is_readonly == 1 || field.is_editable == 0) {//tab.tab_field_type == "POLINEITEM" ||
          this.frmTransaction.controls[field.db_column_name].disable();
        } else {
          this.frmTransaction.controls[field.db_column_name].enable();
        }
      });
    });

    let tabParentField = this.dynamicTabs.find((x) => x.tab_field_type == 'NORMAL');
    this.invoiceAmount = 0
    if (tabParentField != null) {
      this.transactionFieldList[tabParentField.tab_id].forEach((row) => {
        row.field_details.forEach((x) => {
          if (x.is_po_match_amount_column) {
            this.header_tolerance_amount_field_Name = x.field_name;
            this.invoiceAmount = this.frmTransaction.get(x.db_column_name).value;
          }
        });
      });
    }
    if (this.isPOLineLevelTab) {
      this.poPullDataMode = 'BATCHMODE';
      this.getPoMatchData(this.activeTab.tab_id);
    }
  }

  changeTextFieldValue(field: any) {
    let fix_length = 0;
    if (field.min_length == field.max_length) {
      fix_length = field.min_length;
    }

    let field_value = this.frmTransaction.get(field.db_column_name).value;
    if (this.isDOAExists) {
      this.doaFields.forEach((x) => {
        if (x.doa_rule.findIndex(r => field.db_column_name == r.DB_COLUMN_NAME) > -1) {
          this.getDOAMatrix();
        }
      });
    }

    if (field.is_dependant == 1) {
      this.getDependantFields(field.field_mapping_detail_id, this.frmTransaction.get(field.db_column_name).value);
    }

    if (field.actions != null) {

      // execute actions/query if any

      field.actions.forEach(action => {
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'NORMAL') {
          this.frmTransaction.get(action.target_db_column_name)
            .setValue(this.frmTransaction.get(action.source_db_column_name).value);
        }
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
          let formula = action.formula;

          action.formula_fields.split(",").forEach(f => {
            let field_value = this.frmTransaction.get(f).value;
            formula = formula.replaceAll(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
          });

          let formulaValue = eval(formula);

          this.frmTransaction.get(action.target_db_column_name)
            .setValue(formulaValue);

          this.transactionFieldList.forEach((tab) => {
            tab.forEach((section) => {
              let target_field = section.field_details.filter(item => item.db_column_name == action.target_db_column_name);
              if (target_field != null && target_field.length > 0) {
                target_field = target_field[0];
                if (target_field.validation_type == 'NUMERIC') {
                  formulaValue = this.commonService.handleNumberInput(target_field, formulaValue);
                  this.frmTransaction.get(action.target_db_column_name).setValue(formulaValue);
                }
              }
            });
          });
        }
      });
      //below code commentted by prakash , because it creating issue while setting value to target field.
      // the target field may be any of the section. on 2023-04-18
      // let section: any;
      // this.transactionFieldList.forEach((tab) => {
      //   tab.forEach((section) => {
      //     section = section.field_details.filter(item => item.field_name == field.field_name);
      //   })
      // });

      // this.setDynamicMandatoryFieldValidation(field, section);

    }

    if (field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') {
      field_value = this.commonService.handleNumberInput(field, field_value);
      //this.frmTransaction.get(field.db_column_name).setValue(field_value);
      if (field_value.length <= fix_length) {
        this.frmTransaction.get(field.db_column_name).setValue(field_value);

      }
    }

    if (field.is_required_value_based_validation == 1) {
      this.get_field_value_based_validation_settings(field);
    }
  }

  changeDateFieldValue(field: any) {

    let isValidFormula = true;

    if (field.actions != null) {

      field.actions.forEach(action => {
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'NORMAL') {
          this.frmTransaction.get(action.target_db_column_name)
            .setValue(this.frmTransaction.get(action.source_db_column_name).value);
        }
        if (action.action_type == 'SET_VALUE' && action.execute_mode == 'FORMULA' && action.action_trigger == 'VALUE_CHANGE') {
          let formula = action.formula;

          action.formula_fields.split(",").forEach(f => {
            let field_value = this.frmTransaction.get(f).value;
            if (field_value == '' || field_value == null) {
              isValidFormula = false;
              return;
            }
            formula = formula.replaceAll(f, 'new Date(\'' + new Date(field_value) + '\')');
          });
          if (isValidFormula == false) {
            return;
          }
          let formulaValue = eval(formula);

          this.frmTransaction.get(action.target_db_column_name).setValue(formulaValue);
        }
      });
    }
  }

  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value.toString().replace(/,/g, '')).toFixed(Number(decimalPlace)) : value;
  }

  setDecimalPlacesForInput(event: any, decimalPlace: number, validationType: string) {
    event.target.value = validationType.toLowerCase() == 'numeric' ? parseFloat(event.target.value == '' ? 0 : event.target.value).toFixed(Number(decimalPlace)) : event.target.value;
  }

  changeDropdownFieldValue(field: any) {
    if (this.isDOAExists) {
      this.doaFields.forEach((x) => {
        if (x.doa_rule.findIndex(r => field.db_column_name == r.DB_COLUMN_NAME) > -1) {
          this.getDOAMatrix();
        }
      });
    }

    if (field.is_dependant == 1) {
      // let option = field.options.find((d) => d.name == this.frmTransaction.get(field.db_column_name).value);
      // let fieldVal = option.id;
      // this.getDependantFields(field.field_mapping_detail_id, fieldVal);
      this.getDependantFields(
        field.field_mapping_detail_id,
        this.frmTransaction.get(field.db_column_name).value
      );
    }

    if (field.is_required_value_based_validation == 1) {
      this.get_field_value_based_validation_settings(field);
    }


  }

  onSelectRejectReason(e: any, rejectReasonId: number) {
    if (e.checked)
      this.rejectReasonIds.push(rejectReasonId);
    else {
      this.rejectReasonIds.splice(this.rejectReasonIds.findIndex(x => x == rejectReasonId), 1);
    }
  }



  addLineItem() {

    let formValue;
    let blnValidate = true;
    let nonpo_validation_msg = "";
    let nonpo_length_validation_msg = "";

    this.activeFieldList.forEach((row) => {
      row.field_details.forEach((x) => {

        if (x.is_mandatory == 1) {
          formValue = this.frmTransaction.get(x.db_column_name).value;
          // by prakash on 05 MAY 2022
          if (formValue == null || formValue == undefined || formValue == '') {
            blnValidate = false;
            if (nonpo_validation_msg == "") {
              nonpo_validation_msg = '<b>Please fill the required field(s).</b>\r <br/>';
            }
            nonpo_validation_msg += ' - ' + x.field_name + ' \r <br/>'
          }
        }

        if (x.is_readonly == 0 && x.control_type == 'TEXTBOX') {

          let fix_length = 0;
          if (x.min_length == x.max_length) {
            fix_length = x.min_length;
          }
          formValue = this.frmTransaction.get(x.db_column_name).value;

          if (fix_length > 0 && (x.is_mandatory == 1 || formValue != '')) {

            if (formValue.toString().length != fix_length) {
              if (nonpo_length_validation_msg == "")
                nonpo_length_validation_msg = "Length of " + x.field_name + " must be " + fix_length + ".";
              else
                nonpo_length_validation_msg = nonpo_length_validation_msg + "<BR>" + "Length of " + x.field_name + " must be " + fix_length + ".";
            }
          }

          if (fix_length == 0 && x.min_length > 0 && (x.is_mandatory == 1 || formValue != '')) {
            if (formValue.toString().length < x.min_length) {
              if (nonpo_length_validation_msg == "")
                nonpo_length_validation_msg = "Length of " + x.field_name + " is min " + x.min_length + ".";
              else
                nonpo_length_validation_msg = nonpo_length_validation_msg + "<BR>" + "Length of " + x.field_name + " is min " + x.min_length + ".";
            }
          }

          if (fix_length == 0 && x.max_length > 0) {
            if (formValue.toString().length > x.max_length) {
              if (nonpo_length_validation_msg == "")
                nonpo_length_validation_msg = "Length of " + x.field_name + " is up to " + x.max_length + ".";
              else
                nonpo_length_validation_msg = nonpo_length_validation_msg + "<BR>" + "Length of " + x.field_name + " is up to " + x.max_length + ".";
            }
          }
        }

      });
    });

    if (!blnValidate) {
      nonpo_validation_msg = "<div class='text-start'>" + nonpo_validation_msg + "</div>";
      this.commonService.showMessageBox(nonpo_validation_msg, 'Error');
      return;
    }

    if (nonpo_length_validation_msg != '') {
      nonpo_length_validation_msg = "<div class='text-start'>" + nonpo_length_validation_msg + "</div>";
      this.commonService.showMessageBox(nonpo_length_validation_msg, 'Error');
      return;
    }

    let obj = {};

    obj['id'] = 0;

    this.activeFieldList.forEach((row) => {
      row.field_details.forEach((x) => {
        formValue = this.frmTransaction.get(x.db_column_name).value;
        obj[x.db_column_name] = '';
        obj[x.db_column_name + '_text'] = '';

        if (x.control_type == 'DROPDOWN') {
          //if (+formValue != NaN && formValue > 0) { by prakash
          if (formValue != null && formValue != undefined && formValue != '') {
            //let option = x.options.find((d) => d.id == formValue);
            //obj[x.db_column_name] = option.name;
            if (x.options.length > 0) {
              obj[x.db_column_name] = formValue;
              obj['fieldEdit'] = this.editenabled;
              obj[x.db_column_name + '_text'] = x.options.find(
                (d) => d.id == formValue
              ).name;
            }
          }
        } else {
          if (formValue != null && formValue != undefined) {
            obj[x.db_column_name] = formValue;
            obj[x.db_column_name + '_text'] = formValue;
            obj['fieldEdit'] = this.editenabled;
          }
        }
      });
    });

    obj['rowIndex'] = (this.lineLevelItemList.length == 0 ? 0 : [this.activeTab.tab_id].length);
    if (this.lineLevelItemList.length == 0) {
      this.lineLevelItemList = [];
      this.lineLevelItemList.push(obj);

    }
    else {
      this.lineLevelItemList[this.activeTab.tab_id].push(obj);
    }
    this.submitNon_PO_LineItem(obj);
    this.clearLineItemFields();
  }

  async editLineItem(iRow: number) {
    this.editedLineItemIndex = iRow;
    this.isEdit = true;

    let lineItem = this.lineLevelItemList[this.activeTab.tab_id].find(
      (x) => x.id == iRow
    );
    if (lineItem != undefined) {
      let item_value;
      let item_text;
      this.activeFieldList.forEach((row) => {
        row.field_details.forEach(async (x) => {

          item_value = lineItem[x.db_column_name];
          item_text = lineItem[x.db_column_name + "_text"];

          if (x.control_type == 'DROPDOWN') {
            if (x.is_autocomplete == 1) {

              let auto_controls = this.dynamic_auto_complete["_results"];
              if (auto_controls != null && auto_controls != undefined) {
                let current_control = auto_controls.filter((item) => item.field.db_column_name == x.db_column_name);
                if (current_control != null && current_control.length > 0) {
                  current_control[0].myControl.setValue(item_text);
                  x.field_value = item_value;
                  this.frmTransaction.get(x.db_column_name).setValue(item_value);
                  x.options = await this.commonService.getAutocomplete_dropdowndata(x.field_mapping_detail_id, item_value, 'id')
                  setTimeout(() => {
                    current_control[0].ngAfterViewInit();
                  }, 1000);

                  // let event = { target: { value: item_value } };
                  // current_control[0].onSelectionChange(event);
                }
              }

            }
            else {
              this.frmTransaction.get(x.db_column_name).setValue(Number(item_value));
            }

          } else {
            this.frmTransaction.get(x.db_column_name).setValue(item_value);
          }
        });
      });
    }
  }

  editPOLineItem(iRow: number) { }

  deleteLineItem(iRow: number) {

    let selectedLineIDs = [];
    selectedLineIDs.push(iRow);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: 'Are you sure want to delete this item?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.dataService.postData('transaction-line-delete', { doc_child_field_detail_ids: selectedLineIDs }).subscribe(res => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.status == true) {
              this.commonService.showMessageBox("Line item deleted successfully.");
            }
            this.get_non_po_line_item_details();
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
      }
    });
  }

  updateLineItem() {
    let lineItem = this.lineLevelItemList[this.activeTab.tab_id].find((x) => x.id == this.editedLineItemIndex);

    let obj = {};
    obj['id'] = this.editedLineItemIndex;

    if (lineItem != undefined) {
      let formValue;
      this.activeFieldList.forEach((row) => {
        row.field_details.forEach((x) => {
          obj[x.db_column_name] = '';
          obj[x.db_column_name + '_text'] = '';

          formValue = this.frmTransaction.get(x.db_column_name).value;
          if (formValue != null && formValue != undefined && formValue != '') {

            obj[x.db_column_name] = formValue;
            obj[x.db_column_name + '_text'] = formValue;
            if (x.control_type == 'DROPDOWN') {
              if (x.options.length > 0) {
                obj[x.db_column_name + '_text'] = x.options.find(
                  (d) => d.id == formValue
                ).name;
              }
            }
          }
        });
      });
    }

    this.submitNon_PO_LineItem(obj);
    this.clearLineItemFields();
  }

  clearLineItemFields() {

    this.activeFieldList.forEach((row) => {
      row.field_details.forEach((x) => {
        x.field_value = '';

        if (x.control_type == "DROPDOWN") {
          if (x.is_autocomplete == 1) {
            x.options = [];
            let auto_controls = this.dynamic_auto_complete["_results"];
            if (auto_controls != null && auto_controls != undefined) {
              let current_control = auto_controls.filter((item) => item.field.db_column_name == x.db_column_name);
              if (current_control != null && current_control.length > 0) {
                current_control[0].myControl.setValue('');
                current_control[0].ngOnInit();
              }
            }
          }
        }
        this.frmTransaction
          .get(x.db_column_name).setValue('');
      });
    });

  }

  cancelLineItemEdit() {

    this.editedLineItemIndex = 0;
    this.isEdit = false;
    this.clearLineItemFields();
  }

  // scrollInvoicePrimaryDetail(event: Event, direction: string): void {
  //   if (direction == 'next')
  //     (<Element>event.currentTarget).previousElementSibling.scrollLeft += 100;
  //   else (<Element>event.currentTarget).nextElementSibling.scrollLeft -= 100;
  //   event.preventDefault();
  // }

  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= this.widgetsContent.nativeElement.scrollWidth;
  }
  scrollRight() {
    this.widgetsContent.nativeElement.scrollLeft += this.widgetsContent.nativeElement.scrollWidth;
  }

  showHideInvoice() {
    if (this.loadcount == 0 && this.PDFSource == undefined) {
      this.commonService.showHideLoader(true);
      setTimeout(() => {
        if (this.transactionDetail.is_allow_manual_data_extraction_from_file) {
          this.base64ToBlob()
        }
      }, 1000);

      this.loadcount = 1;
    }

    var col_1_size = Number(this.URN_Section.nativeElement.offsetWidth) / 12;
    this.pdfViewerWidth = (col_1_size * 7) - 10;
    this.FieldViewerWidth = (col_1_size * 5) - 10;
    // this.pdfViewerWidth = this.FieldViewerWidth =
    //   Number(this.URN_Section.nativeElement.offsetWidth) / 2 - 10;
    this.isDisplayPDFViewer = !this.isDisplayPDFViewer;

    this.separatorHeight = 780;
    if (!this.isDisplayPDFViewer) {
      this.FieldViewerWidth = Number(
        this.URN_Section.nativeElement.offsetWidth
      );
    }
  }

  openInvoiceFile() {
    let base64 = "";
    if (config.isuseImageVirtual == false || config.isuseImageVirtual == undefined) {
      if (this.PDFSource != undefined) {
        // var blob1 = new Blob([this.PDFSource], { type: 'application/pdf' });
        // var blobURL = URL.createObjectURL(blob1);
        // window.open(blobURL);
      }
      else {
        if (this.transactionDetail.pdf_file_size < Number(this.Autoloadfilelimit)) {
          // base64 = this.transactionDetail.invoice_file[0].invoice_file_encoded;

          // const byteCharacters = atob(base64);
          // const byteNumbers = new Array(byteCharacters.length);
          // for (let i = 0; i < byteCharacters.length; i++) {
          //   byteNumbers[i] = byteCharacters.charCodeAt(i);
          // }
          // const byteArray = new Uint8Array(byteNumbers);
          // const blob = new Blob([byteArray], { type: 'pdf' });
          // const reader = new FileReader();
          // reader.onload = (e: any) => {
          //   this.PDFSource = e.target.result;
          //   var blob1 = new Blob([this.PDFSource], { type: 'application/pdf' });
          //   var blobURL = URL.createObjectURL(blob1);
          //   window.open(blobURL);
          // };
          // reader.readAsArrayBuffer(blob);
        }
        else {

          this.getencodeddata(this.transactionDetail.invoice_file[0].invoice_file_encoded, 1)
        }

      }
    }
    else {
      // let imageserverURL = config.imageServerVirtualDirectory
      let imageserverURL = "";
      let relativefile = this.transactionDetail.invoice_file[0].invoice_file_path;
      let Finalfilepath: any = imageserverURL + relativefile;
      window.open(Finalfilepath);
    }

  }

  base64ToBlob() {
    this.commonService.showHideLoader(true);
    let base64 = "";
    // base64 = this.transactionDetail.invoice_file[0].invoice_file_encoded;
    if (this.transactionDetail.pdf_file_size < Number(this.Autoloadfilelimit)) {
      // base64 = this.transactionDetail.invoice_file[0].invoice_file_encoded;
      // const byteCharacters = atob(base64);
      // const byteNumbers = new Array(byteCharacters.length);
      // for (let i = 0; i < byteCharacters.length; i++) {
      //   byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // const byteArray = new Uint8Array(byteNumbers);
      // const blob = new Blob([byteArray], { type: 'pdf' });
      // const reader = new FileReader();
      // reader.onload = (e: any) => {
      //   this.PDFSource = e.target.result;
      // };
      // reader.readAsArrayBuffer(blob);

      // if (this.transactionDetail.is_allow_manual_data_extraction_from_file == false) {
      //   this.zoomScale = 'page-width';
      //   this.originalSize = false;
      //   //this.zoom = 'page-width';
      //   //this.zoom = '100';
      // }
      // this.commonService.showHideLoader(false);
    }
    else {
      this.getencodeddata(this.transactionDetail.invoice_file[0].invoice_file_encoded, 0);

    }

  }


  getencodeddata(path: any, openflag) {

    let params = {
      path: path
    };

    this.dataService.getData('get_invoice_file_encoded', params).subscribe((res) => {
      if (res != null) {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          const byteCharacters = atob(res.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'pdf' });

          //this.PDFSource = blob;

          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.PDFSource = e.target.result;
            if (openflag == 1) {
              // var blob1 = new Blob([this.PDFSource], { type: 'application/pdf' });
              // var blobURL = URL.createObjectURL(blob1);
              // window.open(blobURL);
            }
          };
          reader.readAsArrayBuffer(blob);

          if (this.transactionDetail.is_allow_manual_data_extraction_from_file == false) {
            this.zoomScale = 'page-width';
            this.originalSize = false;
            //this.zoom = 'page-width';
            //this.zoom = '100';
          }
          this.commonService.showHideLoader(false);
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  //Nilesh-- (20 July,2022)--Start
  onBackButtonClick(isRemoveLock: boolean = true) {
    if (isRemoveLock) {
      let params = new HttpParams;
      params = params.append("document_detail_ids", this.documentDetailId.toString());
      this.dataService.getData('removelock', params).subscribe((res) => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) { }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    }

    //this.commonService.setUserInfoToLocalStorage("transactionSummary_CurrentPage", );
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_RecordsPerPage", 50);
    this.location.back();
    // debugger;
    // this.commonService.getUserInfoToLocalStorage("CurrentPage");
    debugger;
    //this.router.navigate(['dashboard'], {
    this.router.navigate([this.current_page], {
      state: { documentDetailId: this.documentDetailId },
    }).then(() => {
      //window.location.reload();
    });

  }
  //Nilesh-- (20 July,2022)--End

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  onSelectFile(imgFile: any) {
    if (this.commonService.validateFileUpload(imgFile.target.files[0], this.supportDocValidFileExtensions, this.supportDocFileSize)) {
      if (imgFile.target.files && imgFile.target.files[0]) {

        let fileName = imgFile.target.files[0].name.split('.').slice(0, -1).join('');
        let fileExt = imgFile.target.files[0].name.split('.').pop();

        this.frmTransaction.controls['uploadFileName'].setValue(
          fileName + '.' + fileExt
        );
        this.file = imgFile.target.files[0];
        this.uploadFileName = fileName + '.' + fileExt;

        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileBase64FileString = reader.result.toString();
          this.uploadAttachment(e, this.file);
        };

        reader.readAsDataURL(imgFile.target.files[0]);
        this.fileInput.nativeElement.value = '';
      } else {
        this.frmTransaction.controls['uploadFileName'].setValue('Choose File');
        this.uploadFileName = 'Choose File';
      }
    }
  }

  /*  uploadAttachment() {
     if (
       this.uploadFileName == '' ||
       this.uploadFileName == undefined ||
       this.uploadFileName == 'Choose File' ||
       this.fileBase64FileString.length == 0
     ) {
       this.commonService.showMessageBox('Please choose attachment.', 'Alert');
       return;
     }
 
     let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
     let local_extension = '.' + this.uploadFileName.split('.').pop();
     let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 24 ? 0 : local_file_name.length - 24), (local_file_name.length < 24 ? local_file_name.length : 24));
     this.attachmentList.push({
       name: selected_file_name + local_extension,
       file: this.fileBase64FileString,
     });
 
 
     this.lstRQAttachment2.push({
       ATTACHMENT_ID: 0,
       Attachment: selected_file_name + local_extension,
       ["File Type"]: "Supporting Doc",
       action_checkbox_button: false
     });
 
     this.lstRQAttachment = this.lstRQAttachment1.concat(this.lstRQAttachment2);
 
 
 
     this.frmTransaction.controls['uploadFileName'].setValue('Choose File');
     this.uploadFileName = 'Choose File';
     this.fileBase64FileString = '';
     this.commonService.showMessageBox('Attachment uploaded.', 'Success');
   } */

  async uploadAttachment(event: any, imgobj: any) {
     const input = imgobj.target as HTMLInputElement;
    if (
      this.uploadFileName == '' ||
      this.uploadFileName == undefined ||
      this.uploadFileName == 'Choose File' ||
      this.fileBase64FileString.length == 0
    ) {
      this.commonService.showMessageBox('Please choose attachment.', 'Alert');
      return;
    }

    let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
    let local_extension = '.' + this.uploadFileName.split('.').pop();
    let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 50 ? 0 : local_file_name.length - 50), (local_file_name.length < 50 ? local_file_name.length : 50));

    this.attachmentFile = imgobj;
    this.attachmentName = selected_file_name + local_extension
    let FrmData: FormData = new FormData();
    FrmData.append('file', this.attachmentFile, this.attachmentName);
    FrmData.append('document_detail_id', this.documentDetailId.toString());
    FrmData.append('document_type_id', this.transactionDetail.document_type_id);
    FrmData.append('project_id', this.commonService.selectedProject);
    FrmData.append('process_id', this.transactionDetail.process_id);
    // FrmData.append('user_id', this.commonService.getUserInfoFromLocalStorage('userId'));
    FrmData.append('user_id', this.memorystore.getItem('userId'));
    FrmData.append('attachment_name', selected_file_name + local_extension);
    FrmData.append('attachment_encoded', this.fileBase64FileString);
    FrmData.append('document_history_id', "0");
    FrmData.append('module_name', "AP");

    let attachmentBody = {
      document_detail_id: Number(this.documentDetailId),
      document_type_id: Number(this.transactionDetail.document_type_id),
      project_id: Number(this.commonService.selectedProject),
      process_id: Number(this.transactionDetail.process_id),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      attachment_name: selected_file_name + local_extension,
      attachment_encoded: this.fileBase64FileString,
      document_history_id: 0,
      module_name: 'AP'
    };

    await this.dataService.postFilePromise('transaction-upload_urn_temp_path', FrmData).then((res) => {
      if (res) {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.success) {
            if (res.data != null) {
              this.attachmentList.push({
                name: selected_file_name + local_extension,
                file: this.fileBase64FileString,
                filePath: res.data.fPath,
                FileSize: this.commonService.getFileSize(this.file.size).toFixed(2) + ' ' + this.commonService.getFileSizeUnit(this.file.size),
                FileType: this.file.type,
                FileUrl: event.target.result,
                FileProgessSize: 0,
                FileProgress: 0
              });
              this.startProgress(this.file, res);
              //Added by imran on 13-01-2026 to fix same file upload
              input.value = '';
              FrmData = new FormData(); // Creates a fresh empty FormData
            }
            else {
              this.commonService.showMessageBox("Failed to upload", 'Warning');
            }
          }
          else {
            this.commonService.showMessageBox(res.errorMessage, 'Warning');
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
    this.frmTransaction.controls['uploadFileName'].setValue('Choose File');
    this.uploadFileName = 'Choose File';
    this.fileBase64FileString = '';
  }

  deleteAttachment(index: number) {

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: 'Are you sure want to delete this attachment?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // this.dataService.deleteData('transaction-attachments/' + id, null, null).subscribe(res => {
        //   this.fileAttachmentHistoryList = this.fileAttachmentHistoryList.filter(el => el.id !== id);
        // });

        //remove from RaisequeryList
        var attachment_file_name = this.attachmentList[index].name;
        let objIndex = this.lstRQAttachment2.findIndex(el => el.Attachment == attachment_file_name);
        this.lstRQAttachment2.splice(objIndex, 1);
        this.lstRQAttachment = this.lstRQAttachment1.concat(this.lstRQAttachment2);

        this.attachmentList.splice(index, 1);
        this.commonService.showMessageBox('Attachment deleted.', 'Success');


      }
    });
  }

  submitAttachments(documentHistoryId: number) {
    this.attachmentList.forEach((item) => {
      let attachmentBody = {
        document_detail_id: Number(this.documentDetailId),
        document_type_id: Number(this.transactionDetail.document_type_id),
        project_id: Number(this.commonService.selectedProject),
        process_id: Number(this.transactionDetail.process_id),
        user_id: Number(
          // this.commonService.getUserInfoFromLocalStorage('userId')
          this.memorystore.getItem('userId')
        ),
        attachment_name: item.name,
        attachment_encoded: item.FileUrl,
        document_history_id: documentHistoryId,
        module_name: 'PI'
      };

      this.dataService.postData('transaction-attachments', attachmentBody).subscribe((res) => {
        if (res) {
          if (res != null && (res.errorMessage == null || res.errorMessage == "")) { }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
          // this.uploadFileName = '';
          // this.fileBase64FileString = '';
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    });
  }

  changeQueue() {
    this.rejectReasonIds = [];
    this.rejectReasonList = [];

    let requestBody = {
      // document_detail_id: this.documentDetailId.toString(),
      // document_type_id: this.transactionDetail.document_type_id.toString(),
      // role_id: this.commonService.selectedRole.toString(),
      // project_id: this.commonService.selectedProject.toString(),
      // subgroup_id: this.commonService.selectedSubgroup.toString(),
      // process_id: this.transactionDetail.process_id.toString(),
      // next_process_id: this.frmTransaction.controls['nextQueue'].value.toString()
      document_detail_id: this.documentDetailId.toString(),
      document_type_id: this.transactionDetail.document_type_id.toString(),
      role_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole.toString()),
      project_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject.toString()),
      subgroup_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup.toString()),
      process_id: this.transactionDetail.process_id.toString(),
      next_process_id: this.frmTransaction.controls['nextQueue'].value.toString()
    };
    if (requestBody.next_process_id != null && requestBody.next_process_id != "") {
      this.dataService.postData('transaction-validate-next-queue', requestBody).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != undefined) {
            this.isDuplicateCheckRequired = res.is_duplicate_check_required;
            this.isValidationRequired = res.is_next_step_validation_required;
            this.isRejectReasonRequired = res.is_reason_required;
            this.isSESValidationRequired = res.is_ses_validation_required;
            this.is_required_tolerance_check = res.is_required_tolerance_check;
            this.Is_mandatory_to_check_ocr_confidence_level = res.is_mandatory_to_check_ocr_confidence_level;

            if (res.next_queue_pre_validation_actions != null && res.next_queue_pre_validation_actions != undefined && res.next_queue_pre_validation_actions != "") {
              this.next_queue_pre_validation_actions = JSON.parse(res.next_queue_pre_validation_actions);
            }
            else {
              this.next_queue_pre_validation_actions = null;
            }
            this.transactionDetail.checklist = res.checkList;
            this.checklist = res.checkList;
            this.isShowCheckListButton = this.checklist.length > 0;
            this.checklist.forEach((element) => {
              element['checked'] = false;
            });

            // by prakash:  facing issue when selected next queue all mandatory fields 
            // become readonly. so that I'm unable to submit the form.
            // 23-JUNE-2022 : Had discuss with team and decided to remove next queue movement field level
            // disable and enable config changes.       

            // On Discussion 24-06-2022, made a decision , like "Next queue mandatory settings to
            // override the current queue mandatory settings, but enable and disable should be based on current queue"


            res.field_validations.forEach((x) => {
              if (this.frmTransaction.get(x.db_column_name) != null) {
                let field_Value = this.frmTransaction.get(x.db_column_name).value;
                this.frmTransaction.get(x.db_column_name).clearValidators();

                if (x.is_mandatory == 1) {
                  this.frmTransaction.get(x.db_column_name).setValidators([Validators.required]);
                  this.frmTransaction.get(x.db_column_name).updateValueAndValidity();
                  this.frmTransaction.get(x.db_column_name).setValue(field_Value);
                  //this.frmTransaction.get(x.db_column_name).enable();
                }


                let tabParentField = this.dynamicTabs.find((tab) => tab.tab_field_type == 'NORMAL');
                if (tabParentField != null) {
                  this.transactionFieldList[tabParentField.tab_id].forEach((section) => {
                    let fields = section.field_details.find(a => a.db_column_name == x.db_column_name);
                    if (fields != null && fields != undefined) {
                      fields.is_mandatory = x.is_mandatory;
                    }
                  });
                }
                //this.activeTab = tabParentField;
                this.activeFieldList = this.transactionFieldList[this.activeTab.tab_id];
                this.activeFieldList.forEach(section => {
                  let f = section.field_details.find(a => a.db_column_name == x.db_column_name);
                  // On Discussion 24-06-2022, made a decision , like "Next queue mandatory settings to
                  // override the current queue mandatory settings, but enable and disable should be based on current queue"
                  if (f != undefined && f != null) {
                    f.is_mandatory = x.is_mandatory;
                    f.is_mandatory_db = x.is_mandatory;
                    //f.is_editable = x.is_mandatory == 1 ? 1 : f.is_editable;
                  }

                });

              }
            });

            this.transactionFieldList.forEach((tab) => {
              tab.forEach(section => {
                let section_field_details = section.field_details.filter(f => f.actions != null);
                if (section_field_details != null && section_field_details.length > 0) {
                  section_field_details.forEach(field => {
                    this.setDynamicMandatoryFieldValidation(field, section);
                  });
                }
              });
            });

            if (res.reject_reasons.length > 0) {
              this.rejectReasonList = res.reject_reasons;
            }
            this.isDOAExists = res.has_doa == 1;
            if (this.isDOAExists) {
              if (res.doa_fields != null) {
                res.doa_fields.forEach(element => {
                  element.doa_rule = JSON.parse(element.doa_rule);
                });
                this.doaFields = res.doa_fields;
              }
              else {
                this.doaFields = [];
              }
              this.getDOAMatrix();
            }

            this.isRaisedquery = res.is_raised_query;
            this.strRQTO = res.from_email;
            if (this.isRaisedquery) {
              this.fillemailTypeList();
            }
            this.transactionDetail.is_comment_mandatory = res.next_queue_comments_madantory;


          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    }
  }

  submitDOA(documentHistoryId: number) {

    let selectedApprover = this.doaApproverList.find(x => x.USER_ID == this.selectedDOAApprover);
    let doaLevel = selectedApprover != undefined ? selectedApprover['DOA Level'] : 1;
    let doaAssignedTo = [];
    if (this.isDOAParallel) {
      this.selectedApproverNameOrLevel = 'Level: ' + doaLevel;
      this.doaApproverList.forEach(user => {
        if (user['DOA Level'] == doaLevel) {
          doaAssignedTo.push(user.USER_ID);
        }
      });
    } else {
      this.selectedApproverNameOrLevel = selectedApprover['Approver'];
      doaAssignedTo = [this.selectedDOAApprover];
    }

    let requestBody = {};
    requestBody['document_detail_id'] = this.documentDetailId;
    requestBody['document_type_id'] = this.transactionDetail.document_type_id;
    requestBody['project_id'] = this.commonService.selectedProject;
    requestBody['subgroup_id'] = this.commonService.selectedSubgroup;
    requestBody['process_id'] = this.transactionDetail.process_id;
    requestBody['next_process_id'] = this.frmTransaction.get(this.nextQueue).value;
    requestBody['document_history_id'] = documentHistoryId;
    requestBody['doa_assigned_to'] = doaAssignedTo;
    requestBody['doa_matrix_id'] = this.doaMatrix.doa_matrix_id;
    requestBody['doa_level'] = doaLevel;
    // requestBody['user_id'] = Number(this.commonService.getUserInfoFromLocalStorage('userId'));
    requestBody['user_id'] = Number(this.memorystore.getItem('userId'));
    this.dataService.postData('doa-matrix', requestBody).subscribe((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          if (res.data == 'QUERY ASSIGNED') {
            this.isDoaForQuery = true;
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  async submitTransaction() {


    if (this.isSESValidationRequired && this.isSESValidated == false && this.poTabId > 0 && this.lineLevelItemList[this.poTabId].length > 0) {
      this.commonService.showMessageBox('PO line items SES validation required', 'alert');
      return;
    }
    this.submitted = true;
    let isSubmitValid = true;
    let invalidSubmitMsg = '';
    let field_value;

    // if (this.frmTransaction.invalid) {
    //   invalidSubmitMsg += '- Please fill the required field(s).\r <br/>';
    //   isSubmitValid = false;
    // }
    // this frmTransaction has line item form fields, so that
    // on submit this.frmTransaction.invalid became true,
    // even all the header mandatory fields filled.
    // so that I have changed code transactionFieldList mandatory based.
    // and it's has exact mandatory fields by next queue based.
    let is_user_level_system_check_done_for_all_ocr_fields = true;

    let tabParentField = this.dynamicTabs.find((x) => x.tab_field_type == 'NORMAL');
    if (tabParentField != null) {
      this.transactionFieldList[tabParentField.tab_id].forEach((row) => {
        row.field_details.forEach((x) => {
          let form_field_Value = this.frmTransaction.get(x.db_column_name).value;
          if (x.is_mandatory == 1) {
            let form_field_Value = this.frmTransaction.get(x.db_column_name).value;
            // by prakash on 06 JULY 2022
            if (form_field_Value == null || form_field_Value == undefined || form_field_Value == '') {
              if (invalidSubmitMsg == "") {
                invalidSubmitMsg += '<b>Please fill the required field(s).</b>\r <br/>';
              }
              invalidSubmitMsg += '  - ' + x.field_name + '\r <br/>';
              isSubmitValid = false;
              return;
            }
          }

          // // START: field length validation

          if (x.is_readonly == 0 && x.control_type == 'TEXTBOX') {

            let fix_length = 0;
            if (x.min_length == x.max_length) {
              fix_length = x.min_length;
            }

            if (fix_length > 0 && (x.is_mandatory == 1 || form_field_Value != '')) {

              if (form_field_Value.length != fix_length) {
                if (invalidSubmitMsg == "")
                  invalidSubmitMsg = "- Length of " + x.field_name + " should be " + fix_length + ".<BR>";
                else
                  invalidSubmitMsg = invalidSubmitMsg + "<BR>" + " - Length of " + x.field_name + " must be " + fix_length + ".";

                isSubmitValid = false;
                return;
              }
            }

            if (fix_length == 0 && x.min_length > 0 && (x.is_mandatory == 1 || form_field_Value != '')) {
              if (form_field_Value.length < x.min_length) {
                if (invalidSubmitMsg == "")
                  invalidSubmitMsg = "- Length of " + x.field_name + " is min " + x.min_length + ".";
                else
                  invalidSubmitMsg = invalidSubmitMsg + "<BR>" + " - Length of " + x.field_name + " is min " + x.min_length + ".";

                isSubmitValid = false;
                return;
              }
            }

            if (fix_length == 0 && x.max_length > 0 && form_field_Value != null && form_field_Value != undefined && form_field_Value != '') {
              if (form_field_Value.length > x.max_length) {
                if (invalidSubmitMsg == "")
                  invalidSubmitMsg = "- Length of " + x.field_name + " is up to " + x.max_length + ".";
                else
                  invalidSubmitMsg = invalidSubmitMsg + "<BR>" + "- Length of " + x.field_name + " is up to " + x.max_length + ".";

                isSubmitValid = false;
                return;
              }
            }

          }
          //// END: field length validation


          if (x.ocr_confidence_level_cssclass != '' && x.is_ocr == true && x.ocr_confidence_level_cssclass != 'ocr-green') {
            is_user_level_system_check_done_for_all_ocr_fields = false
          }
        });
      });
    }

    if (this.Is_mandatory_to_check_ocr_confidence_level == true) {
      if (!is_user_level_system_check_done_for_all_ocr_fields) {
        invalidSubmitMsg += '  - ' + 'Please click on each of the fields highlighted other than green to validate manually\r <br/>';
      }
    }
    // Ram-Start
    this.toleranceType = this.transactionDetail.tolerance_type;
    this.toleranceLimitValue = this.transactionDetail.tolerance_limit_value;
    this.tolerance_limit_obj = this.transactionDetail.tolerance_limitObj;
    this.is_tolerance_applicable = this.transactionDetail.is_tolerance_applicable;
    //Ram-End
    if (this.transactionDetail.is_comment_mandatory == true && (
      this.frmTransaction.get(this.transactionComment).value == '' ||
      this.frmTransaction.get(this.transactionComment).value == undefined ||
      this.frmTransaction.get(this.transactionComment).value == null)
    ) {
      if (invalidSubmitMsg == "") {
        invalidSubmitMsg = '- Comment is required.\r <br/>';
      }
      else {
        invalidSubmitMsg += '- Comment is required.\r <br/>';
      }

      isSubmitValid = false;
    }

    if (
      this.frmTransaction.get(this.nextQueue).value == 0 ||
      this.frmTransaction.get(this.nextQueue).value == undefined ||
      this.frmTransaction.get(this.nextQueue).value == null ||
      this.frmTransaction.get(this.nextQueue).value == ''
    ) {

      if (invalidSubmitMsg == "") {
        invalidSubmitMsg = '- Please select next queue.\r <br/>';
      }
      else {
        invalidSubmitMsg += '- Please select next queue.\r <br/>';
      }

      isSubmitValid = false;
    }

    if (this.checklist.findIndex((x) => x.checked == false && x.is_mandatory == 1) != -1) {

      invalidSubmitMsg += '- Please select mandatory checklist item(s).\r <br/>';
      isSubmitValid = false;
    }
    if (this.isRejectReasonRequired && this.rejectReasonList.length > 0 && this.rejectReasonIds.length == 0) {
      invalidSubmitMsg +=
        '- Please select at least one reason.\r <br/>';
      isSubmitValid = false;
    }

    const nextQueue = this.processQueue.find(x => x.process_id == this.frmTransaction.get(this.nextQueue).value);
    const nextQueueModule = nextQueue != undefined ? nextQueue.process_module : '';
    if ((this.isDOAExists && this.doaApproverList.length > 0 && this.selectedDOAApprover == 0) || (this.selectedDOAApprover == 0 && nextQueueModule.toLowerCase() == 'approval')) {
      invalidSubmitMsg += '- Please select DOA Approver from DOA Approver list.\r <br/>';
      isSubmitValid = false;
    }


    if (!isSubmitValid) {
      invalidSubmitMsg = '<div class="text-start">' + invalidSubmitMsg + '</div>';
      this.commonService.showMessageBox(invalidSubmitMsg, 'Error');
      return;
    }
    // On Submit Validation added by Prakash on 23-Mar-2022
    let validationMessage = invalidSubmitMsg;
    if (!isSubmitValid) {

      this.transactionFieldList.forEach((tab) => {
        tab.forEach(section => {
          section.field_details.forEach(field => {
            this.frmTransaction.controls[field.db_column_name].markAsTouched();
          });
        });
      });

      this.commonService.showMessageBox(validationMessage, 'Error');
      return;
    }



    // delete line items if any
    if (this.deletedLineItems.length > 0) {
      //this.dataService.deleteData('transaction-tabs', { doc_child_field_detail_ids: this.deletedLineItems }, null).subscribe(res => {
      // });
    }



    let child_field_details = [];

    Object.keys(this.lineLevelItemList).forEach((tab) => {
      let findTab = this.dynamicTabs.find(t => t.tab_id == tab && (t.tab_field_type == "POLINEITEM" || t.tab_field_type == "LINEITEM"));
      if (findTab != undefined) {
        child_field_details = JSON.parse(JSON.stringify(this.lineLevelItemList[tab]));

        child_field_details.forEach((item) => {
          delete item['rowIndex'];
          Object.keys(item).forEach((key) => {
            if (item.hasOwnProperty(key + '_text')) {
              delete item[key + '_text'];
            }
          });
        });
        //child_field_details = this.lineLevelItemList[tab];
      }
    });



    let checklistIds = [];
    this.checklist.forEach((x) => {
      if (x.checked) {
        checklistIds.push(x.checklist_id);
      }
    });

    let requestBody = {};
    // requestBody['document_detail_id'] = this.commonService.getUserInfoFromLocalStorage('documentDetailId');
    requestBody['document_detail_id'] = this.memorystore.getItem('documentDetailId');
    requestBody['document_type_id'] = this.transactionDetail.document_type_id;
    // requestBody['role_id'] = this.commonService.selectedRole;
    requestBody['roleid'] = this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole);
    // // requestBody['user_id'] = Number(this.commonService.getUserInfoFromLocalStorage('userId'));
    // requestBody['user_id'] = Number(this.memorystore.getItem('userId'));
    requestBody['encuserid'] = this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'));
    requestBody['process_id'] = this.transactionDetail.process_id;
    requestBody['sub_document_type_id'] = this.transactionDetail.sub_document_type_id;
    requestBody['next_process_id'] = this.frmTransaction.get(this.nextQueue).value;
    requestBody['reject_reason_ids'] = this.rejectReasonIds;
    requestBody['checklist_ids'] = checklistIds;

    let tab = this.dynamicTabs.find((x) => x.tab_field_type == 'NORMAL');

    let lstParent = [];
    let obj = {};
    let fieldValue;
    let lstDuplicateChk = [];


    // requestBody['parent_fields'] = lstParent;
    // requestBody['comments'] = this.frmTransaction.get(this.transactionComment).value;

    let selectedQueue = this.processQueue.find(
      (x) => x.process_id == this.frmTransaction.get(this.nextQueue).value
    );

    let parent_field_data = this.get_transaction_parent_field(tab);
    lstParent = parent_field_data.lstParent;
    lstDuplicateChk = parent_field_data.lstDuplicateChk;


    requestBody['parent_fields'] = lstParent;
    // requestBody['comments'] = this.frmTransaction.get(this.transactionComment).value + (this.IsContinueWithoutDuplicate == true ? '~#Potential Duplicate validation overruled by ' + this.commonService.getUserInfoFromLocalStorage('userName') : '');
    requestBody['comments'] = this.frmTransaction.get(this.transactionComment).value + (this.IsContinueWithoutDuplicate == true ? '~#Potential Duplicate validation overruled by ' + this.memorystore.getItem('userName') : '');
    requestBody['module_name'] = 'AP';
    requestBody['vendor_type'] = this.companyType;
    // // requestBody['project_id'] = Number(this.commonService.getUserInfoFromLocalStorage('projectId'));
    // requestBody['project_id'] = Number(this.memorystore.getItem('projectId'));
    requestBody['projectid'] = this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('projectId'));
    //Raise Query


    requestBody['IsRaisedQuery'] = this.isRaisedquery == true ? 1 : 0;
    let attachmentIds: string = '';

    if (this.isRaisedquery == true) {

      let ep: any = '';
      let emailValidate: boolean = true;

      //to email id
      if (this.strRQTO == "") {
        validationMessage += "- To email id require in raise query.\r <br/>";
        isSubmitValid = false;

      }
      else if (this.strRQTO != "") {

        // //set single id check
        // ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (this.dataService.allow_multiple_emailid_in_to_email_section == false)
          //set single id check
          ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        else
          //to support multiple email ids
          ep = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;


        emailValidate = ep.test(this.strRQTO)
        if (emailValidate != true) {
          validationMessage += "- Invalid to email id in raise query.\r <br/>";
          isSubmitValid = false;
        }
        else {

          if (this.isDomainRequire == true) {
            let lstDomain = this.strRQTO.split(";")

            lstDomain.every(element => {
              var domain = element.substring(element.lastIndexOf("@"));
              let index = this.lstDomainValues.findIndex(a => a === domain);
              if (index == -1) {
                validationMessage += "- Invalid domain found in To Email Id.\r <br/>";
                isSubmitValid = false;
                return false;
              }
              return true;
            });

          }
          requestBody['RaisedQueryTo'] = this.strRQTO;
        }
      }
      //cc email id
      // if (this.strRQCC == "") {
      //   validationMessage += "<BR>" + "cc email id require in raise query.";
      // }
      //else
      if (this.strRQCC != "") {
        //to support multiple email ids
        ep = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;
        emailValidate = ep.test(this.strRQCC)
        if (emailValidate != true) {
          validationMessage += "- Invalid cc email id in raise query.\r <br/>";
          isSubmitValid = false;
        }
        else {
          if (this.isDomainRequire == true) {
            let lstDomain = this.strRQCC.split(";")
            lstDomain.every(element => {
              var domain = element.substring(element.lastIndexOf("@"));
              let index = this.lstDomainValues.findIndex(a => a === domain);
              if (index == -1) {
                validationMessage += "- Invalid domain found in Cc Email Id.\r <br/>";
                isSubmitValid = false;
                return false;
              }
              return true;
            });
          }
          requestBody['RaisedQueryCC'] = this.strRQCC;
        }
      }

      //email type
      if (typeof this.selectedEmailType !== "undefined") {
        requestBody['RaisedQueryEmailType'] = this.selectedEmailType;
      }
      else {
        isSubmitValid = false;
        validationMessage += "- Please select email  type.\r <br/>";
      }

      //email template
      if (typeof this.selectedEmailTemplate !== "undefined" && this.selectedEmailTemplate !== null) {

        requestBody['RaisedQueryEmailTemplate'] = this.selectedEmailTemplate;
      }
      else {
        validationMessage += "- Please select email template type.\r <br/>";
        isSubmitValid = false;
      }

      //email body
      let strBODY = this.strQCBODY;//  this.bodyform.controls["editorContent"].value;
      if (strBODY.trim() != '') {
        requestBody['RaisedQueryEmailBody'] = strBODY;
      }
      else {
        validationMessage += '- Please enter raise query body.\r <br/>';
        isSubmitValid = false;
      }
      if (this.strQCSubject != '') {
        requestBody['RaisedQueryEmailSubject'] = this.strQCSubject + " " + this.strQCSubjectPost;
      }
      else {
        validationMessage += '- Please enter raise query subject.\r <br/>';
        isSubmitValid = false;
      }

      this.lstRQAttachment ?.forEach((element) => {
        if (element.action_checkbox_button == true) {
          attachmentIds += element["Attachment"] + ",";
        }
      });
      requestBody['AttachmentIds'] = attachmentIds;

    }


    if (!isSubmitValid) {
      validationMessage = '<div class="text-start">' + validationMessage + '</div>';
      this.commonService.showMessageBox(validationMessage, 'Error');
      return;
    }


    this.totalPOLineItemAmount = 0;
    this.totalPOLineItemQty = 0;
    let tabPOChildField = this.dynamicTabs.find((x) => x.tab_field_type == 'POLINEITEM');
    if (tabPOChildField != null && tabPOChildField != undefined) {
      this.lineLevelItemList[tabPOChildField.tab_id].forEach(element => {
        this.totalPOLineItemQty += parseFloat(element[this.poQtyFieldName]);
        this.totalPOLineItemAmount += parseFloat(element[this.poAmtFieldName]);
      });
    }


    if (this.isValidationRequired) {

      //--------------------Dynamic validation start------------------------
      let result = true;
      let isNotBlank = true;
      let formula: any;

      this.transactionFieldList.forEach((tab) => {

        tab.forEach(section => {
          section.field_details.filter(f => f.actions != null).forEach(field => {
            field.actions.forEach(action => {

              if (action.action_trigger == 'SUBMIT') {
                if (action.action_type == 'VALIDATION') {
                  if (action.validation_type == 'COMPARE') {
                    if (action.execute_mode == 'NORMAL') {
                      if (action.condition == 'not_blank')
                        isNotBlank = this.frmTransaction.get(field.db_column_name).value != "" && this.frmTransaction.get(field.db_column_name).value != undefined;
                      else
                        isNotBlank = true;

                      let targetFieldName = "";
                      tab.forEach(tb => {
                        let ff = tb.field_details.find(fd => fd.db_column_name == action.target_db_column_name);
                        if (ff != undefined)
                          targetFieldName = ff.field_name
                      });

                      if (isNotBlank && this.frmTransaction.get(field.db_column_name).value != this.frmTransaction.get(action.target_db_column_name).value) {
                        result = false;
                        if (validationMessage == "")
                          validationMessage = field.field_name + " does not matched with " + targetFieldName;
                        else
                          validationMessage = validationMessage + "<br>" + field.field_name + " does not matched with " + targetFieldName;
                      }
                    }
                    else if (action.execute_mode == 'FORMULA') {
                      formula = action.formula;

                      action.formula_fields.split(",").forEach(f => {
                        field_value = this.frmTransaction.get(f).value;
                        formula = formula.replaceAll(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
                      });

                      result = eval(formula);

                      if (!result) {

                        if (validationMessage != "") validationMessage = validationMessage + "<BR>"

                        if (action.error_message != undefined)
                          validationMessage = validationMessage + action.error_message;
                        else
                          validationMessage = validationMessage + "- Invalid value of " + field.field_name;
                      }
                    }
                  }
                  else if (action.validation_type == 'DATE') {
                    if (action.execute_mode == 'NORMAL') {
                      let dt = new Date(this.frmTransaction.get(field.db_column_name).value);
                      if (action.is_future_date_allow == "TRUE") {
                        let validateDate = new Date();
                        validateDate.setDate(validateDate.getDate() + Number(action.future_no_of_days));
                        if (dt > validateDate) {
                          if (action.error_message != undefined)
                            validationMessage = validationMessage + action.error_message;
                          else
                            validationMessage = validationMessage + "Invalid value of " + field.field_name;
                        }
                      }
                      else {
                        if (dt > new Date()) {
                          if (action.error_message != undefined)
                            validationMessage = validationMessage + action.error_message;
                          else
                            validationMessage = validationMessage + "Invalid value of " + field.field_name;
                        }
                      }
                    }
                  }
                }

                // if (action.action_type == 'COMPARE') {
                //   if (action.condition == 'not_blank')
                //     isNotBlank = this.frmTransaction.get(field.db_column_name).value != "" && this.frmTransaction.get(field.db_column_name).value != undefined;
                //   else
                //     isNotBlank = true;

                //   let targetFieldName = "";
                //   tab.forEach(tb => {
                //     let ff = tb.field_details.find(fd => fd.db_column_name == action.target_db_column_name);
                //     if (ff != undefined)
                //       targetFieldName = ff.field_name
                //   });


                //   if (isNotBlank && this.frmTransaction.get(field.db_column_name).value != this.frmTransaction.get(action.target_db_column_name).value) {
                //     compare = false;
                //     if (validationMessage == "")
                //       validationMessage = field.field_name + " does not matched with " + targetFieldName;
                //     else
                //       validationMessage = validationMessage + "<br>" + field.field_name + " does not matched with " + targetFieldName;
                //   }
                // }

                // if (action.action_type == 'VALIDATION') {
                //   if (action.validation_type == 'COMPARE') {
                //     formula = action.formula;

                //     action.formula_fields.split(",").forEach(f => {
                //       field_value = this.frmTransaction.get(f).value;
                //       formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? Number(field_value) : 0);
                //     });


                //     compare = eval(formula);


                //     if (compare != true) {
                //       if (validationMessage == "")
                //         validationMessage = "Invalid value of " + field.field_name;
                //       else
                //         validationMessage = validationMessage + "<BR>" + "Invalid value of " + field.field_name;
                //     }
                //   }
                // }
              }
            });
          });
        });
      });

      this.transactionFieldList.forEach((tab) => {
        tab.forEach(section => {
          section.field_details.forEach(field => {

            field_value = this.frmTransaction.get(field.db_column_name).value;

            if (field_value == undefined || field_value == null)
              field_value = '';

            if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
              let fix_length = 0;
              if (field.min_length == field.max_length) {
                fix_length = field.min_length;
              }

              if (fix_length > 0 && (field.is_mandatory == 1 || field_value != '')) {

                if (field_value.toString().length != fix_length) {
                  if (validationMessage == "")
                    validationMessage = "Length of " + field.field_name + " must be " + fix_length + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Length of " + field.field_name + " must be " + fix_length + ".";
                }
              }

              if (fix_length == 0 && field.min_length > 0 && (field.is_mandatory == 1 || field_value != '')) {
                if (field_value.toString().length < field.min_length) {
                  if (validationMessage == "")
                    validationMessage = "Length of " + field.field_name + " is min " + field.min_length + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Length of " + field.field_name + " is min " + field.min_length + ".";
                }
              }

              if (fix_length == 0 && field.max_length > 0) {
                if (field_value.toString().length > field.max_length) {
                  if (validationMessage == "")
                    validationMessage = "Length of " + field.field_name + " is up to " + field.max_length + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Length of " + field.field_name + " is up to " + field.max_length + ".";
                }
              }
            }

          });
        });
      });

      //--------------------Dynamic validation end------------------------

      //--------------------Email Validation starrt-----------------------
      let ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let emailValidate: boolean = true;

      this.transactionFieldList.forEach((tab) => {
        tab.forEach(section => {
          section.field_details.forEach(field => {
            if (field.validation_type == 'EMAIL') {
              field_value = this.frmTransaction.get(field.db_column_name).value;

              if (field_value == undefined || field_value == null)
                field_value = '';

              if (field_value != '') {
                emailValidate = ep.test(field_value)

                if (emailValidate != true) {
                  if (validationMessage == "")
                    validationMessage = "Invalid " + field.field_name + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Invalid " + field.field_name + ".";
                }
                else {
                  if (this.transactionDetail.domain_exception_value != '') {
                    if (this.transactionDetail.domain_exception_value.search(field_value.toLowerCase().split('@').pop()) == -1) {
                      emailValidate = false;

                      if (validationMessage == "")
                        validationMessage = "Invalid " + field.field_name + " domain." + " Valid domain is " + this.transactionDetail.domain_exception_value + ".";
                      else
                        validationMessage = validationMessage + "<BR>" + "Invalid " + field.field_name + " domain." + " Valid domain is " + this.transactionDetail.domain_exception_value + ".";
                    }
                  }
                }
              }
            }
          });
        });
      });

      if (this.is_required_tolerance_check == 1 && !this.Tolerance_Limit_validation("ONSUBMIT")) {


        if (this.lineLevelItemList[tabPOChildField.tab_id].length <= 0) {
          validationMessage += "<br/>Please add PO line item or update the SES Number field";
        }
        else {
          validationMessage += "<br/>Line item should match with header " + this.header_tolerance_amount_field_Name.toLocaleLowerCase() + " and should match with tolerance amount range +/- " + this.tolerance_calculated_Range.toString();
        }
      }

      if (validationMessage != "") {
        isSubmitValid = false;
        validationMessage = '<div class="text-start">' + validationMessage + '</div>';
        this.commonService.showMessageBox(validationMessage, 'Validation Alert', "error", 'textLeft');
        return;
      }

      //Prakash added on 24 MAY 2022. for next queue movement validation
      if (this.next_queue_pre_validation_actions != null && this.next_queue_pre_validation_actions != "") {
        // execute actions/query if any    
        let is_queue_validation_completed = new Promise<void>((resolve, reject) => {
          this.next_queue_pre_validation_actions.forEach(async (action, index, array) => {
            if (action.action_type == "API" && action.action_trigger == "SUBMIT") {
              isSubmitValid = false;
              this.queue_movement_validation_response = null;
              await this.Queue_Movement_Validation(action, lstParent, child_field_details).then((res) => {

                if (this.queue_movement_validation_response != null && this.queue_movement_validation_response != "") {
                  let tml_master_data = this.queue_movement_validation_response.data;
                  if (tml_master_data != undefined && tml_master_data != null && tml_master_data != "") {
                    tml_master_data.forEach((item) => {
                      if (this.frmTransaction.get(item.db_column_name) != null) {
                        this.frmTransaction.get(item.db_column_name).setValue(item.field_value);
                      }
                      else {
                        this.ui_field_which_is_not_available.push(item);
                      }
                    });
                  }
                }

                if (res != null && res != "" && res != undefined) {
                  validationMessage += res;
                }

                if (validationMessage != "") {
                  isSubmitValid = false;
                  validationMessage = '<div class="text-start">' + validationMessage + '</div>';
                  this.commonService.showMessageBox(validationMessage, 'Validation Alert', "error", "textLeft");
                  return;
                }
                else {
                  isSubmitValid = true;
                }
              });
            }
            else if (action.validation_type == 'DATE' && action.action_trigger == "SUBMIT") {
              if (action.execute_mode == 'NORMAL') {
                let field_name = "";
                this.transactionFieldList.forEach((tab) => {
                  tab.forEach(section => {
                    section.field_details.forEach(field => {
                      if (field.db_column_name == action.source_db_column_name) {
                        field_name = field.field_name;
                      }
                    });
                  });
                });

                let dt = new Date(this.frmTransaction.get(action.source_db_column_name).value);
                let isDateValid: boolean = true;
                if (action.is_future_date_allow == "TRUE") {
                  let validateDate = new Date();
                  validateDate.setDate(validateDate.getDate() + Number(action.future_no_of_days));
                  if (dt > validateDate) {
                    if (action.error_message != undefined)
                      validationMessage = validationMessage + action.error_message;
                    else
                      validationMessage = validationMessage + "Invalid value of " + field_name;
                    isDateValid = false;
                  }
                }
                else {
                  if (dt > new Date()) {
                    if (action.error_message != undefined)
                      validationMessage = validationMessage + action.error_message;
                    else
                      validationMessage = validationMessage + "Invalid value of " + field_name;
                    isDateValid = false;
                  }
                }

                if (isDateValid != true) {
                  isSubmitValid = false;
                  validationMessage = '<div class="text-start">' + validationMessage + '</div>';
                  this.commonService.showMessageBox(validationMessage, 'Validation Alert', "error", 'textLeft');
                  return;
                }
                else {
                  isSubmitValid = true;
                }
              }
            }
            else if (action.validation_type == 'COMPARE' && action.action_trigger == "SUBMIT") {
              if (action.execute_mode == 'FORMULA') {
                formula = action.formula;

                action.formula_fields.split(",").forEach(f => {

                  if (f == "SOURCE") {
                    field_value = this.invoicePrimaryDetails.source;
                  }
                  else {
                    field_value = this.frmTransaction.get(f).value;
                  }
                  formula = formula.replace(f, (field_value != "" && field_value != undefined && field_value != null) ? field_value : '');

                });

                result = eval(formula);
                if (!result) {
                  if (validationMessage != "") validationMessage = validationMessage + "<BR>";
                  validationMessage = validationMessage + action.error_message;
                }
              }
              if (validationMessage != "") {
                isSubmitValid = false;
                validationMessage = '<div class="text-start">' + validationMessage + '</div>';
                this.commonService.showMessageBox(validationMessage, 'Validation Alert', "error", "textLeft");
                return;
              }
              else {
                isSubmitValid = true;
              }
            }
            else if (action.action_type == 'SET_VALUE' && action.action_trigger == "SUBMIT") {
              if (action.execute_mode == 'SET_NULL') {
                action.formula_fields.split(",").forEach(f => {
                  this.frmTransaction.get(f).setValue('');
                });
              }

            }

            parent_field_data = this.get_transaction_parent_field(tab);
            lstParent = parent_field_data.lstParent;
            lstDuplicateChk = parent_field_data.lstDuplicateChk;

            if (this.ui_field_which_is_not_available.length > 0) {
              let displayText = '';
              this.ui_field_which_is_not_available.forEach((item) => {

                if (item.control_type == "DROPDOWN") {
                  displayText = item.options.find(d => d.id == item.field_value) ?.name;
                }
                obj = {
                  //fieldId: item.field_mapping_detail_id,
                  fieldCol: item.db_column_name,
                  fieldVal: item.field_value,
                  controlType: item.control_type,
                  displayText: displayText == undefined ? '' : displayText
                };
                lstParent.push(obj);
              });
            }
            requestBody['parent_fields'] = lstParent;

            if (index === array.length - 1) resolve();

          });
        });


        is_queue_validation_completed.then(() => {
          if (isSubmitValid) {
            let post_data = {
              lstDuplicateChk: lstDuplicateChk,
              requestBody: requestBody
            };
            this.post_submit_transaction_After_Validation(post_data)
          }
        });
      }
      else {
        if (validationMessage != "") {
          isSubmitValid = false;
          validationMessage = '<div class="text-start">' + validationMessage + '</div>';
          this.commonService.showMessageBox(validationMessage, 'Validation Alert', "error", 'textLeft');
          return;
        }
        else {
          if (isSubmitValid) {
            let post_data = {
              lstDuplicateChk: lstDuplicateChk,
              requestBody: requestBody
            };
            this.post_submit_transaction_After_Validation(post_data)
          }
        }
      }
    }
    else {
      if (isSubmitValid) {
        let post_data = {
          lstDuplicateChk: lstDuplicateChk,
          requestBody: requestBody
        };
        this.post_submit_transaction_After_Validation(post_data)
      }
    }

  }

  post_submit_transaction_After_Validation(post_data: any) {

    let df_params = {
      document_type_id: this.transactionDetail.document_type_id,
      // document_detail_id: this.commonService.getUserInfoFromLocalStorage('documentDetailId'),
      document_detail_id: this.memorystore.getItem('documentDetailId'),
      lstParameter: post_data.lstDuplicateChk,
      fromProcessId: this.transactionDetail.process_id,
      toProcessId: this.frmTransaction.get(this.nextQueue).value
    };

    let requestBody = post_data.requestBody;
    let validationMessage = "";

    let jsonDuplicate: string = ''
    if (this.isDuplicate == false) {
      this.lstDuplicateData = [];
    }
    //to check the duplicate entry
    this.dataService.postData('getduplicate', df_params).subscribe((res) => {

      // if(res?.data?.Table?.length > 0 && this.isDuplicate == true)
      //     this.lstDuplicateData = res.data.Table;
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res ?.data ?.Table ?.length > 0 && this.isDuplicate == false) {
          this.lstDuplicateData = res.data.Table;
          this.isShownDuplicateAlert = true;
          //Chaya 20-July-2022 Duplicate Soft/Hard stop -- Start
          this.IsSoftStop = this.lstDuplicateData.every(val => val ?.SOFT_STOP === '1');
          //Chaya 20-July-2022 Duplicate Soft/Hard stop -- end
          this.showModal(this.duplicateInvoiceSubmittedModal, 'xl');
          this.duplicateDataKeys = Object.keys(this.lstDuplicateData[0]);
          //Duplicate_ref_id = res.data.Table[0].DUPLICATE_REF_ID

        }
        else {

          let processEndTime = new Date();
          requestBody['processingTime'] = parseInt((Math.abs(processEndTime.getTime() - this.processStartTime.getTime()) / (1000) % 60).toString()).toString();

          if (this.lstDuplicateData.length > 0 && this.isDuplicate == true) {
            jsonDuplicate = JSON.stringify(this.lstDuplicateData);
          }

          requestBody['isDOAExists'] = this.isDOAExists;
          //Chaya 20-July-2022 Duplicate Soft/Hard stop -- Start
          if (!this.IsContinueWithoutDuplicate) {
            requestBody['duplicate_ref_id'] = jsonDuplicate;
          }
          //Chaya 20-July-2022 Duplicate Soft/Hard stop -- end
          this.dataService.postData('transaction', requestBody).subscribe((res) => {
            if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
              if (res.success == true && res.data != null) {
                this.selectedQueueName = res.data.nextProcessName;

                let documentHistoryId = res.data.document_history_id;
                if (this.isDOAExists && !this.IsSkipApprovalForDuplicate) {
                  this.submitDOA(documentHistoryId);
                }
                this.submitAttachments(documentHistoryId);
                // Prakash Added this for auto allocation failed scenario. need to show the popup.
                let auto_collacton_config = res.data.auto_collacton_config;
                let auto_allocation_status = res.data.auto_allocation_status;
                let auto_allocation_response = res.data.auto_allocation_response;
                let show_auto_allocation_failed_popup = 0;
                if (auto_collacton_config != undefined && auto_collacton_config != null) {
                  if (auto_collacton_config.is_auto_allocation == 1) {
                    if (auto_allocation_status == 0) {
                      show_auto_allocation_failed_popup = 1;
                    }
                  }
                }
                if (show_auto_allocation_failed_popup == 0) {
                  this.showModal(this.invoiceSubmittedModal, 'md');
                } else {
                  //validationMessage = "Data saved successfully. but auto allocation failed due to " + auto_allocation_response.error_message;
                  validationMessage = auto_allocation_response.error_message;
                  this.commonService.showMessageBox(validationMessage, 'Error', "error", 'textLeft');
                }
              }
              else {
                this.commonService.showMessageBox(res.errorMessage, 'Error', "error", 'textLeft');
              }
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }

          });

          this.isDuplicate = false;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  async postSubmitAction(action: string) {
    this.modalReference.close();
    if (action == 'dashboard') {
      this.router.navigate(['control-panel']);
    } else if (action == 'nextItem') {

      if (this.nextDocumentDetailIDs.length > 0) {
        for (let i = 0; i < this.nextDocumentDetailIDs.length; i++) {

          let isValid = await this.isValidNextURN(this.nextDocumentDetailIDs[0]);
          if (isValid) {
            // this.commonService.setUserInfoToLocalStorage('documentDetailId', this.nextDocumentDetailIDs[0]);
            this.memorystore.setItem('documentDetailId', this.nextDocumentDetailIDs[0]);
            this.nextDocumentDetailIDs.splice(0, 1);
            // this.commonService.setUserInfoToLocalStorage('nextDocumentDetailIDs', this.nextDocumentDetailIDs);
            this.memorystore.setItem('nextDocumentDetailIDs', this.nextDocumentDetailIDs);
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['/transaction']);
            break;
          }
          else {
            this.nextDocumentDetailIDs.splice(0, 1);
            // this.commonService.setUserInfoToLocalStorage('nextDocumentDetailIDs', this.nextDocumentDetailIDs);
            this.memorystore.setItem('nextDocumentDetailIDs', this.nextDocumentDetailIDs);
            i--;
            if (this.nextDocumentDetailIDs.length == 0) {
              this.commonService.showMessageBox('No any next URN left. You are redirecting to Dashboard.');
              this.router.navigate(['control-panel']);
            }
          }
        }
      }
      else {
        this.commonService.showMessageBox('No any next URN left. You are redirecting to Dashboard.');
        this.router.navigate(['control-panel']);
      }
    }
  }

  async isValidNextURN(nextDocumentDetailId: number) {
    let params = new HttpParams();
    params = params.append("document_detail_id", nextDocumentDetailId);
    params = params.append("assigned_to", this.transactionDetail.assigned_to_user_id == '' ? 0 : this.transactionDetail.assigned_to_user_id);
    params = params.append("document_type_id", this.transactionDetail.document_type_id);
    params = params.append("process_id", this.transactionDetail.process_id);

    return await this.dataService.getDataPromise('validate-next-urn', params).then((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        return (res != null && res.status == true);
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
        return '';
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  openAdvanceSearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field_value = this.frmTransaction.get(magnifyDependantFields[x]).value;
        if (field_value != null && field_value != '' && field_value != undefined) {
          // this.activeFieldList.forEach((row) => {
          //   row.field_details.forEach((f) => {
          //     if (f.control_type == 'DROPDOWN' && f.db_column_name == magnifyDependantFields[x]) {
          //       let field = f.options.find(d => d.id == field_value);
          //       if (field != undefined) {
          //         field_value = field.name;
          //       }
          //     }
          //   });
          // });
          dependantFieldValues[x] = field_value.toString();
        }
      });
    }
    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      let selectedField = null;
      this.activeFieldList.find((x) =>
        x.field_details.find((f) => {
          if (f.field_mapping_detail_id == res.fieldId) {
            selectedField = f;
            selectedField.field_value = res.fieldValue;
          }
        })
      );
      if (selectedField != null) {
        // if (selectedField.control_type == 'DROPDOWN') {
        //   let option = selectedField.options.find((d) => d.id == res.fieldValue);
        //   res.fieldValue = option.name;
        // }
        if (selectedField.control_type == 'DROPDOWN') {
          const selectedOptionField = selectedField.options.find(
            (x) => x.id == res.fieldValue
          );
          this.frmTransaction
            .get(selectedField.db_column_name)
            .setValue(selectedOptionField['id']);
          this.changeDropdownFieldValue(selectedField);
        } else if (selectedField.control_type == 'TEXTBOX') {
          this.frmTransaction
            .get(selectedField.db_column_name)
            .setValue(res.fieldValue.toString());
          this.changeTextFieldValue(selectedField);
        }
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  openAdvanceSearchModal_PO_LineItems(fieldMappingDetailId: number, row: any = null, col: string = '', predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName.toLowerCase();
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      row[col] = res.fieldValue.toString();
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  getKeys(obj: any) {
    return Object.keys(obj);
  }

  setDragStatus(event: MouseEvent, status: number) {
    if (status === 1) {
      event.stopPropagation();
    }
    this.dragStatus = status;
  }

  resize() {
    if (!this.isFlipViewer) {
      let width = Number(
        this.URN_Section.nativeElement.offsetWidth - this.mouse.x
      );
      this.pdfViewerWidth = width - 2;
      this.FieldViewerWidth =
        this.URN_Section.nativeElement.offsetWidth - width - 6;
    } else {
      let width = Number(
        this.URN_Section.nativeElement.offsetWidth - this.mouse.x
      );
      this.FieldViewerWidth = width - 2;
      this.pdfViewerWidth =
        this.URN_Section.nativeElement.offsetWidth - width - 6;
    }
  }

  get f() {
    return this.frmTransaction.controls;
  }

  isFormControlExists(controlName: string) {
    const formControl = this.frmTransaction.get(controlName);
    if (formControl)
      return true;
    else
      return false;
  }
  //============================================================

  onInput(v) {
    this.dropDownSearchText = v.target.value;
  }

  triggerModal(content) {
    this.modalService.open(content);
  }

  checkRestrictedKeywords(formControlName: string, useVariable = false) {
    let foundedRestrictedKeyword = [];
    let input
    if (useVariable)
      input = formControlName;
    else
      input = this.frmTransaction.get(formControlName).value;

    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = input.replaceAll(keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.frmTransaction.get(formControlName).setValue(input);
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }

  //------------------------ START: PO ----------------------

  getPoMatchData(tab_id: any = null) {
    if (tab_id == null || tab_id == undefined || tab_id == "") {
      tab_id = this.activeTab.tab_id;
    }
    let requestBody = {
      document_detail_id: Number(this.documentDetailId),
      document_type_id: Number(this.transactionDetail.document_type_id),
      tab_id: Number(tab_id),
      dynamicvalue: '',
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      action: 'GETPOMATCHDATA',
      multiple_pomatch_id: '',
      module_name: 'AP'
    };

    this.dataService.postData('po-match-data', requestBody).subscribe((res) => {
      if (res) {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.success) {
            //if (flag == 'ontabclicked') {
            this.poPullDataMode = res.data["Table"] ?.length > 0 ? res.data["Table"][0].DATA_MODE : '';
            //}
            if (res.data["Table1"].length > 0) {
              res.data["Table1"].forEach(field => {
                this.activeFieldList.find(x => x.tab_header_id == field.TAB_HEADER_ID) ?.field_details.forEach(f => {
                  if (f.field_mapping_detail_id == field.FIELD_ID) {
                    f['po_match_child_column'] = field.PO_MATCH_CHILD_COLUMN;
                    f['po_db_column_name'] = field.PO_MATCH_DB_COLUMN_NAME;
                  }
                });
              });
            }

            this.poQtyFieldName = res.data["Table"][0].QUANTITY_COLUMN;
            this.poAmtFieldName = res.data["Table"][0].AMOUNT_COLUMN;
            this.poGrandTotalFields = res.data["Table"][0].GRAND_TOTAL_COLUMNS ?.split(',');
            this.poLineItemErrorRemarkField = res.data["Table"][0].ERROR_REMARK_COLUMN;

            res.data["Table"].forEach(element => {
              if (element.API_NAME == 'VALIDATE_PO_LINE_ITEMS_WITH_CLIENT') {
                this.poLineItemValidateClientAPI = element;
              }
              if (element.DATA_MODE == 'REALTIME' && element.API_NAME == 'PO_PULL') {
                this.realtimePoPullAPI = element;
              }
              if (element.API_NAME == 'SES_LINEITEM_FETCH') {
                this.fetchSesLineitemAPI = element;
              }
            });

            if (res.data["Table2"].length > 0) {
              this.lineLevelItemList[this.activeTab.tab_id] = res.data["Table2"];
              this.totalPOLineItemQty = 0; this.totalPOLineItemAmount = 0;
              this.isSESValidated = false;

              this.lineLevelItemList[this.activeTab.tab_id].forEach(element => {
                this.totalPOLineItemQty += parseFloat(element[this.poQtyFieldName]);
                this.totalPOLineItemAmount += parseFloat(element[this.poAmtFieldName]);
              });

            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  getRealTimePOLineItem() {

    if (this.realtimePoPullAPI == null || this.realtimePoPullAPI == undefined) {
      return;
    }
    if (!this.validatePOFields()) {
      return;
    }

    let apiParams = this.realtimePoPullAPI['PARAMETER'];
    let apiID = this.realtimePoPullAPI['API_ID'];

    if (apiParams != null) {
      apiParams = JSON.parse(apiParams);
    }

    //this.saveAndProcessRealtimePOPullData(null);

    if (this.realtimePoPullAPI['ACTION_TYPE'] == 'PULL') {
      let params = {};
      if (apiParams != null && typeof (apiParams) == 'object') {
        Object.keys(apiParams).forEach(p => {
          //params = params.append(p, apiParams[p].startsWith('COLUMN') ? this.frmTransaction.get(apiParams[p]).value : apiParams[p]);
          params[p] = apiParams[p].startsWith('COLUMN') ? this.frmTransaction.get(apiParams[p]).value : apiParams[p];
        });
      }

      this.dataService.get_realTimeApi(apiID, params).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            res = JSON.parse(JSON.parse(res.data));
            if (res != null && (res.status == true || res.status == 'success')) {
              if (res.data != null && res.data ?.item.length > 0) {
                this.saveAndProcessRealtimePOPullData(res.data);
              } else {
                this.commonService.showMessageBox(res.error_message, 'Error');
                return;
              }
            }
          } else {
            this.commonService.showMessageBox(res.error_message, 'Error');
            return;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    } else {

      if (apiParams != null && typeof (apiParams) == 'object') {
        Object.keys(apiParams).forEach(p => {
          apiParams[p] = this.frmTransaction.get(apiParams[p]).value;
        });
      }

      this.dataService.post_realTimeApi(apiID, apiParams).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            res = JSON.parse(JSON.parse(res.data));
            if (res != null && (res.status == true || res.status == 'success')) {
              if (res.data != null && res.data ?.item.length > 0) {
                this.saveAndProcessRealtimePOPullData(res.data);
              } else {
                this.commonService.showMessageBox('No data found.', 'Error');
                return;
              }
            } else {
              this.commonService.showMessageBox(res.error_message, 'Error');
              return;
            }
          } else {
            this.commonService.showMessageBox(res.error_message, 'Error');
            return;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    }

  }

  saveAndProcessRealtimePOPullData(res: any) {
    const saampleResult = {
      "status": "success",
      "message": null,
      "error_message": null,
      "data": {
        "item": [
          {
            "PoNumber": "4430013415",
            "PoItem": "00010",
            "Service": "000000009348000023",
            "ShortText": "USER_1",
            "ServiceLine": "0000000010",
            "Quantity": "100.0",
            "Uom": "EA",
            "Rate": "200",
            "Amount": "20000",
            "GrossPrice": "20000",
            "TaxCode": "VG",
            "GLAcct": "0000445049",
            "CostCtr": "0001611039",
            "Acctasscat": "K",
            "Wbs": "",
            "OrderNo": "",
            "Activity": "",
            "Network": "",
            "OvLimit": "0.0",
            "HsnSac": "1111.11",
            "Packno": "0000167496",
            "SubPackno": "0000000000",
            "SerialNo": "01",
            "RowNo": "0000000002",
            "ShortTextPo": "Test Material 2",
            "PoServices_Id": 0
          }, {
            "PoNumber": "4430013415",
            "PoItem": "00020",
            "Service": "000000009348000025",
            "ShortText": "USER_1",
            "ServiceLine": "0000000010",
            "Quantity": "100.0",
            "Uom": "EA",
            "Rate": "200",
            "Amount": "20000",
            "GrossPrice": "20000",
            "TaxCode": "VG",
            "GLAcct": "0000445049",
            "CostCtr": "0001611039",
            "Acctasscat": "K",
            "Wbs": "",
            "OrderNo": "",
            "Activity": "",
            "Network": "",
            "OvLimit": "0.0",
            "HsnSac": "1111.11",
            "Packno": "0000167496",
            "SubPackno": "0000000000",
            "SerialNo": "01",
            "RowNo": "0000000002",
            "ShortTextPo": "Test Material 2",
            "PoServices_Id": 0
          }
        ]
      },
      "original_response": "<env:Envelope xmlns:env=\"http://www.w3.org/2003/05/soap-envelope\"><env:Header/><env:Body><n0:ZmmFetchPoDetailResponse xmlns:n0=\"urn:sap-com:document:sap:soap:functions:mc-style\"><PoServices><item><PoNumber>2620000034</PoNumber><PoItem>00010</PoItem><Service>000000009348000023</Service><ShortText>AUDIT_test</ShortText><ServiceLine>0000000010</ServiceLine><Quantity>1.0</Quantity><Uom>EA</Uom><Rate>324456.0</Rate><Amount>324456.0</Amount><GrossPrice>324456.0</GrossPrice><TaxCode>VG</TaxCode><GLAcct>0000445049</GLAcct><CostCtr>0001611039</CostCtr><Acctasscat>K</Acctasscat><Wbs/><OrderNo/><Activity/><Network/><OvLimit>0.0</OvLimit><HsnSac>1111.11</HsnSac><Packno>0000167496</Packno><SubPackno>0000000000</SubPackno><SerialNo>01</SerialNo><RowNo>0000000002</RowNo><ShortTextPo>Test Material 2</ShortTextPo></item></PoServices><Return1/></n0:ZmmFetchPoDetailResponse></env:Body></env:Envelope>",
      "original_request": "<soap:Envelope xmlns:soap='http://www.w3.org/2003/05/soap-envelope' xmlns:urn='urn:sap-com:document:sap:soap:functions:mc-style'><soap:Header /><soap:Body ><urn:ZmmFetchPoDetail><PoServices><!--Zero or more repetitions:--><item><PoNumber></PoNumber><PoItem></PoItem><Service></Service><ShortText></ShortText><ServiceLine></ServiceLine><Quantity></Quantity><Uom></Uom><Rate></Rate><Amount></Amount><GrossPrice></GrossPrice><TaxCode></TaxCode><GLAcct></GLAcct><CostCtr></CostCtr><Acctasscat></Acctasscat><Wbs></Wbs><OrderNo></OrderNo><Activity></Activity><Network></Network><OvLimit></OvLimit><HsnSac></HsnSac><Packno></Packno><SubPackno></SubPackno><SerialNo></SerialNo><RowNo></RowNo><ShortTextPo></ShortTextPo></item></PoServices><Poitem>00000</Poitem><Ponumber>2620000034</Ponumber><Return1><!--Zero or more repetitions:--><item><Type></Type><Code></Code><Message></Message><LogNo></LogNo><LogMsgNo></LogMsgNo><MessageV1></MessageV1><MessageV2></MessageV2><MessageV3></MessageV3><MessageV4></MessageV4></item></Return1></urn:ZmmFetchPoDetail></soap:Body></soap:Envelope>"
    };
    let dynamicValues = this.getPODynamicParamWithValue();
    let requestBody = {
      dynamicValue: dynamicValues,
      data: JSON.stringify(res.item),
      document_type_id: Number(this.transactionDetail.document_type_id),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      // project_id: Number(this.commonService.getUserInfoFromLocalStorage('projectId'))
      user_id: Number(this.memorystore.getItem('userId')),
      project_id: Number(this.memorystore.getItem('projectId'))
    };

    //this.selectedPOList = [];
    this.dataService.postData("save-realtime-po-items", requestBody).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          this.getBatchModePOLineItem();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  getBatchModePOLineItem() {

    if (!this.validatePOFields()) {
      return;
    }
    let dynamicValues = this.getPODynamicParamWithValue();

    let requestBody = {
      dynamicvalue: dynamicValues,
      document_type_id: Number(this.transactionDetail.document_type_id),
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      module_name: 'AP'
    };
    this.poLineItemList = [];
    this.dataService.postData("po-match-data", requestBody).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          if (res.data != null && res.data.Table.length > 0) {

            this.poDefaultFieldsConfig = res.data.Table1;
            this.poLineItemList = res.data.Table;
            this.poLineItemList.forEach(element => {
              element.isSelected = false;
            });

            const fieldConfig = res.data.Table1;
            this.poFirstGridFieldsConfig = [];

            Object.keys(this.poLineItemList[0]).forEach(k => {
              const result = fieldConfig.filter(c => c.DISPLAY_NAME == k);
              if (result.length > 0)
                this.poFirstGridFieldsConfig.push(result[0]);
              else
                this.poFirstGridFieldsConfig.push({ IS_EDITABLE: false, FIELD_NAME: k, DISPLAY_NAME: k, CONTROL_TYPE: 'LABEL', DECIMAL_PLACES: 0, VALIDATION_TYPE: 'ALPHA NUMERIC' })
            });

          } else {
            this.commonService.showMessageBox('No record found.', 'Alert');
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  validatePOFields(): boolean {
    let formValue: string | number;
    let blnValidate = true;
    let invalidSubmitMsg = 'Please fill the required field(s) as below.\r <br/>';

    this.activeFieldList.forEach((row) => {
      row.field_details.forEach((x) => {
        formValue = this.frmTransaction.get(x.db_column_name).value;

        if (x.control_type == 'DROPDOWN') {
          if (Number.isNaN(formValue) || formValue == 0) {
            blnValidate = false;
            invalidSubmitMsg += x.field_name + '\r <br/>';
          }
        } else {
          if (formValue == null || formValue == undefined || formValue == '') {
            blnValidate = false;
            invalidSubmitMsg += '- ' + x.field_name + '\r <br/>';
          }
        }
      });
    });

    if (!blnValidate) {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
    }
    return blnValidate;
  }

  getPODynamicParamWithValue(): string {
    let dynamicValues = '';
    this.activeFieldList[0].field_details.forEach(field => {
      if (field.hasOwnProperty('po_db_column_name')) {
        const fieldVal = this.frmTransaction.get(field.db_column_name).value;
        dynamicValues += (dynamicValues != '' ? ' AND ' : '') + field.po_db_column_name + ' = |' + fieldVal + '|';
      }
    });
    return dynamicValues;
  }

  flipPO() {
    this.invalidPOLineItemNo = [];
    this.invalidPOLineItemFields = {};
    const selectedItems = this.poLineItemList.filter((item) => item.isSelected);
    if (selectedItems.length == 0) {
      this.commonService.showMessageBox('Please select at least one PO Line Item.', 'Alert');
      return;
    }
    else {

      let dynamicValues = this.getPODynamicParamWithValue();
      let selectedIds = '';
      selectedItems.forEach(x => { selectedIds = selectedIds == '' ? x.SELECT : selectedIds + ',' + x.SELECT })

      let requestBody = {
        document_detail_id: this.documentDetailId,
        dynamicvalue: dynamicValues,
        document_type_id: Number(this.transactionDetail.document_type_id),
        // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        user_id: Number(this.memorystore.getItem('userId')),
        multiple_pomatch_id: selectedIds,
        module_name: 'AP'
      };

      //this.selectedPOList = [];

      this.dataService.postData("po-match-data", requestBody).subscribe(res => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.success == true) {
            if (res.data != null && res.data.Table.length > 0) {

              this.isPOLineItemsValid = false;
              res.data.Table.forEach(row => {
                this.selectedPOList.push(row);
              });

              const fieldConfig = res.data.Table1;
              this.poFieldsConfig = []; this.totalSelectedPoQty = 0; this.totalSelectedPoAmount = 0;
              const quantityColumn = fieldConfig.find(f => f.IS_QUANTITY_COLUMN == true);


              // if (this.poExcelData.length > 0) {
              //   let isMatchItem = true;
              //   this.poExcelData.forEach(item => {
              //     let obj = { 'Total Quantity': item[quantityColumn.DISPLAY_NAME] };
              //     for (let cols of this.poDefaultFieldsConfig) {
              //       if (item.hasOwnProperty(cols.DISPLAY_NAME)) {
              //         obj[cols.DISPLAY_NAME] = item[cols.DISPLAY_NAME];
              //       } else {
              //         if (cols.DISPLAY_NAME == 'Row No') {
              //           obj[cols.DISPLAY_NAME] = this.selectedPOList.length + 1;
              //         } else if (cols.IS_CALCULATED && cols.CALCULATION_FORMULA != '') {
              //           let calcFormula = '';
              //           cols.CALCULATION_FORMULA.split('|').forEach(f => {
              //             let regex = /^[+-]?\d+(\.\d+)?([eE][+-]?\d+)?$/;
              //             if (regex.test(f.trim())) {
              //               const matchField = this.poDefaultFieldsConfig.find(p => p.FIELD_MAPPING_DETAIL_ID == Number(f));
              //               let fieldVal = 0;
              //               if (matchField) {
              //                 fieldVal = item[matchField.DISPLAY_NAME];
              //               }
              //               calcFormula = calcFormula + 'parseFloat(' + fieldVal + ')';
              //             }
              //             else {
              //               calcFormula = calcFormula + f.trim();
              //             }
              //           });
              //           const val = eval(calcFormula);
              //           obj[cols.DISPLAY_NAME] = isNaN(parseFloat(val)) ? '' : parseFloat(val);
              //         } else {
              //           const uniqueCombinationCols = this.poFirstGridFieldsConfig.filter(f => f.IS_USED_FOR_UNIQUE_COLUMN == true);
              //           if (cols.DISPLAY_NAME == 'Total Quantity') {
              //             // no need to set this column value bcoz it is already set initially
              //           } else if (cols.IS_UNIQUE) {
              //             let poUniqueID = '';
              //             uniqueCombinationCols.forEach(u => {
              //               poUniqueID += (poUniqueID != '' ? '_' : '') + item[u.DISPLAY_NAME];
              //             });
              //             obj[cols.DISPLAY_NAME] = poUniqueID;
              //           } else {
              //             let filteredData = 'this.poLineItemList.find(a => true';
              //             uniqueCombinationCols.forEach(u => {
              //               filteredData += ' && a["' + u.DISPLAY_NAME + '"]==item["' + u.DISPLAY_NAME + '"]';
              //             });
              //             filteredData += ')';
              //             const filteredObj = eval(filteredData);
              //             if (filteredObj != undefined) {
              //               obj[cols.DISPLAY_NAME] = filteredObj[cols.DISPLAY_NAME];
              //             } else {
              //               obj[cols.DISPLAY_NAME] = '';
              //               isMatchItem = false;
              //               break;
              //             }
              //           }
              //         }
              //       }
              //     }
              //     this.invalidPOLineItemFields[this.selectedPOList.length + 1] = [];
              //     if (isMatchItem)
              //       this.selectedPOList.push(obj);
              //   });
              // }

              this.selectedPOList.forEach((sp, i) => {
                sp['Row No'] = (i + 1);
                this.invalidPOLineItemFields[sp['Row No']] = [];
                if (!sp.hasOwnProperty('Total Quantity'))
                  sp['Total Quantity'] = sp[quantityColumn.FIELD_NAME];
                this.totalSelectedPoQty += parseFloat(sp[quantityColumn.FIELD_NAME]);
                this.totalSelectedPoAmount += parseFloat(sp[fieldConfig.find(f => f.IS_AMOUNT_COLUMN == true).FIELD_NAME]);
              });

              Object.keys(this.selectedPOList[0]).forEach(async (k, i) => {
                const result = fieldConfig.filter(c => (c.IS_EDITABLE && c.FIELD_NAME == k) || (c.IS_EDITABLE == false && c.DISPLAY_NAME == k));
                if (result.length > 0) {
                  result[0].order = i;
                  this.poFieldsConfig.push(result[0]);
                  if (result[0].IS_EDITABLE && result[0].CONTROL_TYPE == 'DROPDOWN') {
                    result[0].options = await this.commonService.getDropdownData(result[0].FIELD_MAPPING_DETAIL_ID);
                  }
                }
                else
                  this.poFieldsConfig.push({ order: i, IS_EDITABLE: false, FIELD_NAME: k, DISPLAY_NAME: k, CONTROL_TYPE: 'LABEL', DECIMAL_PLACES: (k == 'Total Quantity' ? quantityColumn.DECIMAL_PLACES : 0), VALIDATION_TYPE: (k == 'Total Quantity' ? 'NUMERIC' : 'ALPHA NUMERIC') })
              });

              var element = this.poFieldsConfig.find(f => f.FIELD_NAME == 'Total Quantity');
              element.order = this.poFieldsConfig.find(f => f.IS_USED_QUANTITY_COLUMN == true) ?.order;
              this.poFieldsConfig = this.poFieldsConfig.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));

              this.poFieldsConfig.forEach(async field => {
                field['mandatory_line_no'] = [];
                field['editable_line_no'] = [];
              });
              this.selectedPOList.forEach(rowData => {
                this.poFieldsConfig.forEach(async field => {
                  if (field.IS_REQUIRED_VALUE_BASED_VALIDATION == 1) {
                    this.poFieldValueBasedValidation(field, rowData);
                  }
                });
              });
            } else {
              this.commonService.showMessageBox('No record found.', 'Alert');
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    }
  }

  deleteSecondGridPOLineItem(iRow: number) {
    let selectedLine = [];
    if (iRow == -1) {
      this.selectedPOList.forEach(element => {
        if (element.isSelected) {
          selectedLine.push(element);
        }
      });
    } else {
      let lineItem = this.selectedPOList[iRow];
      if (lineItem != undefined) {
        selectedLine.push(lineItem);
      }
    }
    if (selectedLine.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: 'Are you sure want to delete selected PO line item(s)?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {

          selectedLine.forEach(x => {
            this.selectedPOList.splice(this.selectedPOList.findIndex(a => a == x), 1);
          });

          this.totalSelectedPoQty = 0; this.totalSelectedPoAmount = 0;
          this.selectedPOList.forEach((sp, i) => {
            sp['Row No'] = (i + 1);
            const quantityColumn = this.poFieldsConfig.find(f => f.IS_QUANTITY_COLUMN == true);
            this.totalSelectedPoQty += parseFloat(sp[quantityColumn.FIELD_NAME]);
            this.totalSelectedPoAmount += parseFloat(sp[this.poFieldsConfig.find(f => f.IS_AMOUNT_COLUMN == true).FIELD_NAME]);
          });

          this.poFieldsConfig.forEach(async field => {
            field['mandatory_line_no'] = [];
            field['editable_line_no'] = [];
          });
          this.selectedPOList.forEach(rowData => {
            this.poFieldsConfig.forEach(async field => {
              if (field.IS_REQUIRED_VALUE_BASED_VALIDATION == 1) {
                this.poFieldValueBasedValidation(field, rowData);
              }
            });
          });
        }
      });
    } else {
      this.commonService.showMessageBox('Please select items to delete.', 'Alert');
      return;
    }
  }
  deleteSecondGridNPOLineItem(iRow: number) {

    let selectedLine = [];
    if (iRow == -1) {
      this.lineLevelItemList.forEach(element => {
        element.forEach(item => {
          if (item['isSelected']) {
            selectedLine.push(item['id']);
          }
        })
      });
    } else {
      let lineItem = this.lineLevelItemList[iRow];
      if (lineItem != undefined) {
        selectedLine.push(lineItem);
      }
    }
    if (this.lineLevelItemList.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: 'Are you sure want to delete selected Non PO line item(s)?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.IsAllChecked = false;
          this.dataService.postData('transaction-line-delete', { doc_child_field_detail_ids: selectedLine }).subscribe(res => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res.status == true) {
                this.commonService.showMessageBox("Line item deleted successfully.");
              }
              this.get_non_po_line_item_details();
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }
          },
          error => {
            if (error.includes("401")) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
          });
        }
      });
    } else {
      this.commonService.showMessageBox('Please select items to delete.', 'Alert');
      return;
    }
  }

  async poTextFieldChangeEvent(event: any, field: any, rowData: any) {

    this.isPOLineItemsValid = false;
    rowData[field.FIELD_NAME] = event.target.value;

    if (field.IS_QUANTITY_COLUMN) {
      this.poFieldsConfig.filter(c => c.IS_CALCULATED && c.CALCULATION_FORMULA != null).forEach(x => {
        let calcFormula = '';
        x.CALCULATION_FORMULA.split('|').forEach(f => {
          let regex = /^[+-]?\d+(\.\d+)?([eE][+-]?\d+)?$/;
          if (regex.test(f.trim())) {
            const matchField = this.poFieldsConfig.find(p => p.FIELD_MAPPING_DETAIL_ID == Number(f));
            let fieldVal = 0;
            if (matchField) {
              fieldVal = rowData[matchField.FIELD_NAME];
            }
            calcFormula = calcFormula + 'parseFloat(' + fieldVal + ')';
          }
          else {
            calcFormula = calcFormula + f.trim();
          }
        });
        const val = eval(calcFormula);

        rowData[rowData.hasOwnProperty(x.FIELD_NAME) ? x.FIELD_NAME : x.DISPLAY_NAME] = isNaN(parseFloat(val)) ? '' : this.setDecimalPlaces(val, x.DECIMAL_PLACES, x.VALIDATION_TYPE);
      });

      this.totalSelectedPoQty = 0; this.totalSelectedPoAmount = 0;
      this.selectedPOList.forEach(sp => {
        this.totalSelectedPoQty += parseFloat(sp[this.poFieldsConfig.find(f => f.IS_QUANTITY_COLUMN == true).FIELD_NAME]);
        this.totalSelectedPoAmount += parseFloat(sp[this.poFieldsConfig.find(f => f.IS_AMOUNT_COLUMN == true).DISPLAY_NAME]);
      });
    }
    if (field.IS_REQUIRED_VALUE_BASED_VALIDATION == 1) {
      this.poFieldValueBasedValidation(field, rowData);
    }
  }

  async poFieldValueBasedValidation(field: any, rowData: any) {

    let res_field_validation = await this.getLineLevelFieldValueBasedValidation(field, rowData[field.FIELD_NAME]);
    res_field_validation.forEach(validation => {
      let targetField = this.poFieldsConfig.find(f => f.DB_COLUMN_NAME == validation.db_column_name);
      if (targetField) {

        if (!targetField.hasOwnProperty('mandatory_line_no')) {
          targetField['mandatory_line_no'] = [];
        }
        if (!targetField.hasOwnProperty('editable_line_no')) {
          targetField['editable_line_no'] = [];
        }

        if (validation.is_mandatory == 1 && targetField['mandatory_line_no'].indexOf(rowData['Row No']) == -1) {
          targetField['mandatory_line_no'].push(rowData['Row No']);
        }
        if (validation.is_mandatory == 0 && targetField['mandatory_line_no'].indexOf(rowData['Row No']) > -1) {
          const index = targetField['mandatory_line_no'].indexOf(rowData['Row No']);
          targetField['mandatory_line_no'].splice(index, 1);
        }

        if ((validation.is_mandatory == 1 || validation.is_editable == 1) && targetField['editable_line_no'].indexOf(rowData['Row No']) == -1) {
          targetField['editable_line_no'].push(rowData['Row No']);
        }
        if (validation.is_editable == 0 && targetField['editable_line_no'].indexOf(rowData['Row No']) > -1) {
          const index = targetField['editable_line_no'].indexOf(rowData['Row No']);
          targetField['editable_line_no'].splice(index, 1);
        }
      }
    });
  }

  async poDropdownFieldChangeEvent(event: any, field: any, rowData: any) {
    this.isPOLineItemsValid = false;
    rowData[field.FIELD_NAME] = event.value;

    if (field.IS_REQUIRED_VALUE_BASED_VALIDATION == 1) {
      this.poFieldValueBasedValidation(field, rowData);
    }
  }

  validatePOLineItemsFromAPI() {
    /// -- just we are checking the mandatory validation. but need to implement 
    /// as same like a submit button validation. 

    if (this.poLineItemValidateClientAPI == null || this.poLineItemValidateClientAPI == undefined) {
      this.commonService.showMessageBox('PO items validation client API not found.', 'Error');
      return;
    }

    let apiParams = this.poLineItemValidateClientAPI['PARAMETER'];
    let apiID = this.poLineItemValidateClientAPI['API_ID'];

    if (apiParams != null) {
      apiParams = JSON.parse(apiParams);
    }

    if (this.poLineItemValidateClientAPI['ACTION_TYPE'] == 'PULL') {
      let params = {};
      if (apiParams != null && typeof (apiParams) == 'object') {
        Object.keys(apiParams).forEach(p => {
          //params = params.append(p, apiParams[p].startsWith('COLUMN') ? this.frmTransaction.get(apiParams[p]).value : apiParams[p]);
          params[p] = apiParams[p].startsWith('COLUMN') ? this.frmTransaction.get(apiParams[p]).value : apiParams[p];
        });
      }

      this.dataService.get_realTimeApi(apiID, params).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            res = JSON.parse(JSON.parse(res.data));
            if ((res.status == true || res.status == 'success') && res.data ?.item != null) {
              this.isPOLineItemsValid = true;
              this.isSESValidated = true;
            } else {
              this.commonService.showMessageBox(res.error_message, 'Error');
              return;
            }
          } else {
            this.commonService.showMessageBox(res.error_message, 'Error');
            return;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    } else {

      if (apiParams != null && typeof (apiParams) == 'object') {
        Object.keys(apiParams).forEach(p => {
          if (p == 'sesHeader') {
            Object.keys(apiParams[p]).forEach(f => {
              if (apiParams[p][f].startsWith('COLUMN')) {
                let arrCol = apiParams[p][f].split('__');
                if (arrCol[1] == 'PARENT') {
                  let val = this.frmTransaction.get(arrCol[0]).value;
                  if (val == null) {
                    apiParams[p][f] = '';
                  } else {
                    if (val instanceof Date || (typeof (val) == 'object' && val.hasOwnProperty('_d'))) {
                      var dateValue = new Date();
                      if (typeof (val) == 'object' && val.hasOwnProperty('_d')) {
                        dateValue = new Date(val._d);
                      }
                      else {
                        dateValue = new Date(val);
                      }
                      apiParams[p][f] = this.commonService.formatDate(dateValue, "yyyy-MM-dd");
                    } else {
                      // encode special char
                      if (this.commonService.encodeSpecialCharInSesValidation == true) {
                        val = val.toString().replace(/[&]/g, "&#38;").replace(/[<]/g, "&#60;").replace(/[>]/g, "&#62;").replace(/[']/g, "&#39;").replace(/["]/g, "&#34;");
                      }
                      apiParams[p][f] = val.toString();
                    }
                  }
                } else if (arrCol[1] == 'POCHILD') {
                  // encode special char
                  let val = this.lineLevelItemList[this.poTabId][0][arrCol[2]];
                  if (val == null || val == undefined) {
                    val = '';
                  }
                  if (this.commonService.encodeSpecialCharInSesValidation == true) {
                    val = val.toString().replace(/[&]/g, "&#38;").replace(/[<]/g, "&#60;").replace(/[>]/g, "&#62;").replace(/[']/g, "&#39;").replace(/["]/g, "&#34;");
                  }
                  apiParams[p][f] = val;
                }
              } else if (apiParams[p][f] == '#URN#') {
                // encode special char
                let val = this.transactionDetail.urn;
                if (this.commonService.encodeSpecialCharInSesValidation == true) {
                  val = val.toString().replace(/[&]/g, "&#38;").replace(/[<]/g, "&#60;").replace(/[>]/g, "&#62;").replace(/[']/g, "&#39;").replace(/["]/g, "&#34;");
                }
                apiParams[p][f] = val;
              }
            });
          }
          else if (p == 'item') {
            let arrItems = [];
            this.lineLevelItemList[this.poTabId].forEach((row, i) => {
              let obj = {};
              Object.keys(apiParams[p]).forEach(f => {
                obj[f] = '';
                if (apiParams[p][f].startsWith('COLUMN')) {
                  let arrCol = apiParams[p][f].split('__');
                  // encode special char
                  let val = row[arrCol[1]];
                  if (val == null || val == undefined) {
                    val = '';
                  }
                  if (this.commonService.encodeSpecialCharInSesValidation == true) {
                    val = val.toString().replace(/[&]/g, "&#38;").replace(/[<]/g, "&#60;").replace(/[>]/g, "&#62;").replace(/[']/g, "&#39;").replace(/["]/g, "&#34;");
                  }
                  obj[f] = val;
                } else if (f == 'SrNo') {
                  obj[f] = (i + 1).toString();
                }

              });
              arrItems.push(obj);
            });
            apiParams[p] = arrItems;
          }
        });
      }
      this.dataService.post_realTimeApi(apiID, apiParams).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            res = JSON.parse(JSON.parse(res.data));
            if ((res.status == true || res.status == 'success') && res.data ?.item != null) {
              let isAllPoLinesSuccess = true;
              if (res.data ?.Summary[0].Id == 'E') {
                isAllPoLinesSuccess = false;
              }
              this.poItemsErrorList = [];
              res.data.item.forEach((item, i) => {
                if (isAllPoLinesSuccess == false && item.Remark != null && item.Remark != '') {
                  this.poItemsErrorList.push({ srno: Number(item.SrNo), error: item.Remark });
                } else {
                  this.poItemsErrorList.push({ srno: Number(item.SrNo), error: '' });
                }
              });

              if (isAllPoLinesSuccess) {
                this.commonService.showMessageBox('SES validation success', 'success');
                this.isPOLineItemsValid = true;
                this.isSESValidated = true;
              } else {
                this.isPOLineItemsValid = false;
                this.isSESValidated = false;
                let lineItemFailHtml = '<table><tr><th>Sr No</th><th>Remark</th></tr>';
                this.poItemsErrorList.forEach(ele => {
                  if (ele.error != '')
                    lineItemFailHtml += '<tr><td>' + ele.srno + '</td><td>' + ele.error + '</td></tr>';
                });
                lineItemFailHtml += '</table>';
                this.commonService.showMessageBox(this.poItemsErrorList.length + ' PO line items SES validation failed.<br>' + lineItemFailHtml, 'alert');
              }
            } else {
              this.commonService.showMessageBox(res.error_message, 'Error');
              return;
            }
          } else {
            this.commonService.showMessageBox(res.error_message, 'Error');
            return;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    }

  }

  validatePOLineItems() {

    if ((this.lineLevelItemList[this.activeTab.tab_id].length + this.selectedPOList.length) > this.transactionDetail.max_line_item_limit_per_invoice) {
      this.commonService.showMessageBox('Line items exceed the max allowed limit.<br>Maximum line items allowed: ' + this.transactionDetail.max_line_item_limit_per_invoice, 'Error');
      return;
    }

    let lineLimitCombinationName = '';
    let lineItemCombinationColumns = [];
    let combinationWiseCount = [];

    this.transactionDetail.po_column_combination_for_lineitem_limit.split(',').forEach(element => {
      const displayName = this.poFieldsConfig.find(f => f.DB_COLUMN_NAME == element) ?.DISPLAY_NAME;
      lineItemCombinationColumns.push(displayName);
      lineLimitCombinationName += (lineLimitCombinationName == '' ? '' : ' + ') + displayName;
    });

    this.selectedPOList.forEach(row => {
      let combinationVal = '';
      lineItemCombinationColumns.forEach(col => {
        combinationVal += (combinationVal == '' ? '' : '_') + row[col];
      });

      let matchCombination = combinationWiseCount.find(x => x.combination == combinationVal);
      if (matchCombination != undefined) {
        matchCombination.count = matchCombination.count + 1;
      } else {
        combinationWiseCount.push({ combination: combinationVal, count: 1 });
      }
    });

    this.lineLevelItemList[this.activeTab.tab_id].forEach(row => {
      let combinationVal = '';
      lineItemCombinationColumns.forEach(col => {
        combinationVal += (combinationVal == '' ? '' : '_') + row[col];
      });

      let matchCombination = combinationWiseCount.find(x => x.combination == combinationVal);
      if (matchCombination != undefined) {
        matchCombination.count = matchCombination.count + 1;
      } else {
        combinationWiseCount.push({ combination: combinationVal, count: 1 });
      }
    });

    let isExceedCombinationWiseLineLimit = false;
    let exceededLineItemDetails = '<table class="table custom_table"><tr><th><small>' + lineLimitCombinationName + '</small></th><th><small>Line Count</small></th></tr>';
    combinationWiseCount.forEach(c => {
      if (c.count > this.transactionDetail.max_po_line_item_limit_per_combination) {
        isExceedCombinationWiseLineLimit = true;
        exceededLineItemDetails += '<tr><td>' + c.combination + '</td><td>' + c.count + '</td></tr>';
      }
    });

    if (isExceedCombinationWiseLineLimit) {
      exceededLineItemDetails += '</table>';
      this.commonService.showMessageBox('Below line items exceed the <small><b>(' + lineLimitCombinationName + ')</b></small> wise max allowed limit.<br><small>Maximum <b>(' + lineLimitCombinationName + ')</b> wise line items limit is: ' + this.transactionDetail.max_po_line_item_limit_per_combination + '</small><br>' + exceededLineItemDetails, 'Error');
      return;
    }

    //---------- Quantity validation ----------
    this.invalidPOLineItemNo = [];
    let exceedQtyList = '';
    let zeroQtyList = '';
    let exceedTotalQtyList = '';
    let exceedAvailableQtyForSameInvList = '';
    let mandatoryFieldList = '';
    let invalidLengthMsg = '';
    const quantityField = this.poFieldsConfig.find(f => f.IS_QUANTITY_COLUMN == true).FIELD_NAME;
    const usedQuantityField = this.poFieldsConfig.find(f => f.IS_USED_QUANTITY_COLUMN == true);
    const uniqueIdField = this.poFieldsConfig.find(f => f.IS_UNIQUE == true);

    this.selectedPOList.forEach(sp => {

      this.invalidPOLineItemFields[sp['Row No']] = [];

      let totalQty = parseFloat(sp['Total Quantity']);
      let usedQty = parseFloat(sp[usedQuantityField.DISPLAY_NAME]);
      let enteredQty = 0;
      let sameInvoiceUsedQty = 0;

      this.selectedPOList.forEach(sp2 => {
        if (sp2[uniqueIdField.FIELD_NAME] == sp[uniqueIdField.DISPLAY_NAME]) {
          enteredQty += parseFloat(sp2[quantityField]);
        }
      });

      this.lineLevelItemList[this.activeTab.tab_id].forEach(element => {
        if (element[uniqueIdField.FIELD_NAME] == sp[uniqueIdField.DISPLAY_NAME]) {
          sameInvoiceUsedQty += parseFloat(element[quantityField]);
        }
      });

      if (enteredQty == 0) {
        zeroQtyList += (zeroQtyList != '' ? ', ' : '') + sp['Row No'];
        this.invalidPOLineItemNo.push(sp['Row No']);
        this.invalidPOLineItemFields[sp['Row No']].push(quantityField);
      }
      if (enteredQty > totalQty) {
        exceedTotalQtyList += (exceedTotalQtyList != '' ? ', ' : '') + sp['Row No'];
        this.invalidPOLineItemNo.push(sp['Row No']);
        this.invalidPOLineItemFields[sp['Row No']].push(quantityField);
      }
      if (enteredQty > (totalQty - sameInvoiceUsedQty)) {
        exceedAvailableQtyForSameInvList += (exceedAvailableQtyForSameInvList != '' ? ', ' : '') + sp['Row No'];
        this.invalidPOLineItemNo.push(sp['Row No']);
        this.invalidPOLineItemFields[sp['Row No']].push(quantityField);
      }
      if (enteredQty > (totalQty - usedQty)) {
        exceedQtyList += (exceedQtyList != '' ? ', ' : '') + sp['Row No'];
        this.invalidPOLineItemNo.push(sp['Row No']);
        this.invalidPOLineItemFields[sp['Row No']].push(quantityField);
      }

      this.poFieldsConfig.filter(f => (f.hasOwnProperty('IS_MANDATORY') && f.IS_MANDATORY == true) || f['mandatory_line_no'] ?.includes(sp['Row No'])).forEach(field => {
        if (sp.hasOwnProperty(field.FIELD_NAME) && (sp[field.FIELD_NAME] == '' || sp[field.FIELD_NAME] == null)) {
          mandatoryFieldList += (mandatoryFieldList != '' ? '<br>- ' : '- ') + field.FIELD_NAME;
          this.invalidPOLineItemNo.push(sp['Row No']);
          this.invalidPOLineItemFields[sp['Row No']].push(field.FIELD_NAME);
        }
      });

      this.poFieldsConfig.filter(f => f.CONTROL_TYPE == 'TEXTBOX').forEach(field => {
        if (sp.hasOwnProperty(field.FIELD_NAME) && sp[field.FIELD_NAME] != '' && sp[field.FIELD_NAME] != null) {

          let fix_length = 0;
          if (field.MIN_LENGTH == field.MAX_LENGTH) {
            fix_length = field.MIN_LENGTH;
          }
          let formValue = sp[field.FIELD_NAME];

          if (fix_length > 0 && formValue.toString().length != fix_length) {
            if (invalidLengthMsg == "")
              invalidLengthMsg = "Length of <b>" + field.DISPLAY_NAME + "</b> must be " + fix_length + " in Row No. " + sp['Row No'];
            else
              invalidLengthMsg += "<BR>" + "Length of <b>" + field.DISPLAY_NAME + "</b> must be " + fix_length + " in Row No. " + sp['Row No'];

            this.invalidPOLineItemNo.push(sp['Row No']);
            this.invalidPOLineItemFields[sp['Row No']].push(field.FIELD_NAME);
          }

          if (fix_length == 0 && field.MIN_LENGTH > 0) {
            if (formValue.toString().length < field.MIN_LENGTH) {
              if (invalidLengthMsg == "")
                invalidLengthMsg = "Length of <b>" + field.DISPLAY_NAME + "</b> is min " + field.MIN_LENGTH + " in Row No. " + sp['Row No'];
              else
                invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of <b>" + field.DISPLAY_NAME + "</b> is min " + field.MIN_LENGTH + " in Row No. " + sp['Row No'];

              this.invalidPOLineItemNo.push(sp['Row No']);
              this.invalidPOLineItemFields[sp['Row No']].push(field.FIELD_NAME);
            }
          }

          if (fix_length == 0 && field.MAX_LENGTH > 0) {
            if (formValue.toString().length > field.MAX_LENGTH) {
              if (invalidLengthMsg == "")
                invalidLengthMsg = "Length of <b>" + field.DISPLAY_NAME + "</b> is up to " + field.MAX_LENGTH + " in Row No. " + sp['Row No'];
              else
                invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of <b>" + field.DISPLAY_NAME + "</b> is up to " + field.MAX_LENGTH + " in Row No. " + sp['Row No'];

              this.invalidPOLineItemNo.push(sp['Row No']);
              this.invalidPOLineItemFields[sp['Row No']].push(field.FIELD_NAME);
            }
          }

        }
      });

    });

    if (invalidLengthMsg != '') {
      this.commonService.showMessageBox(invalidLengthMsg, 'Alert');
      return;
    }

    this.totalPOLineItemAmount = 0;
    this.totalPOLineItemQty = 0;
    let tabPOChildField = this.dynamicTabs.find((x) => x.tab_field_type == 'POLINEITEM');
    if (tabPOChildField != null && tabPOChildField != undefined) {
      this.lineLevelItemList[tabPOChildField.tab_id].forEach(element => {
        this.totalPOLineItemQty += parseFloat(element[this.poQtyFieldName]);
        this.totalPOLineItemAmount += parseFloat(element[this.poAmtFieldName]);
      });
    }
    if (this.is_tolerance_applicable) {
      this.totalPOLineItemAmount = this.totalSelectedPoAmount + this.totalPOLineItemAmount;
    }
    if (zeroQtyList != '') {
      this.commonService.showMessageBox('Please enter Quantity greater than zero for Row No(s) : <b>' + zeroQtyList + '</b>', 'Alert');
      if (this.transactionDetail.is_po_exceed_qty_restrict)
        return;
    } else if (exceedTotalQtyList != '') {
      this.commonService.showMessageBox('Entered Quantity should not be greater than Total Quantity for Row No(s) : <b>' + exceedTotalQtyList + '</b>', 'Alert');
      return;
    } else if (exceedAvailableQtyForSameInvList != '') {
      this.commonService.showMessageBox('Entered Quantity should not be greater than Total Available Quantity for this Invoice for Row No(s) : <b>' + exceedAvailableQtyForSameInvList + '</b><br><small>(Total Quantity - Total Used Quantity in same invoice)</small>', 'Alert');
      return;
    } else if (exceedQtyList != '' && this.transactionDetail.is_po_exceed_qty_restrict) {
      this.commonService.showMessageBox('Entered Quantity(s) exceed the limit for Row No(s) : <b>' + exceedQtyList + '</b>', 'Alert');
      return;
    } else if (mandatoryFieldList != '') {
      // this.commonService.showMessageBox('<div class="text-start">Please fill the mandatory field(s) as below : <h6>' + mandatoryFieldList + '</h6></div>', 'Alert');
      this.commonService.showMessageBox('Please fill the mandatory field(s).', 'Alert');
      return;
    } else if ((this.totalSelectedPoAmount + this.totalPOLineItemAmount) > this.invoiceAmount && !this.is_tolerance_applicable) {

      this.commonService.showMessageBox('PO line item(s) total amount should not be greater than Invoice amount<div class="text-start">Invoice Amount: <b>' + this.invoiceAmount + '</b></div><div class="text-start">PO Line Item(s) Total Amount: <b>' + this.setDecimalPlaces((this.totalSelectedPoAmount + this.totalPOLineItemAmount), 2, 'NUMERIC') + '</b><br><small>(Selected PO Line Items Amount + Added PO Line Items Amount)</small></div>', 'Alert');
      return;
    }
    else if ((this.totalSelectedPoAmount + this.totalPOLineItemAmount) > this.invoiceAmount && this.is_tolerance_applicable && !this.Tolerance_Limit_validation("POLINEITEM"))//affirm with child item total amount for the range
    {
      this.totalPOLineItemAmount = this.totalPOLineItemAmount - this.totalSelectedPoAmount;

      this.commonService.showMessageBox('Line item(s) total amount is greater or exceeding the tolerance limit defined with the Invoice Amount.', 'Alert');
      return;
    }
    else if (exceedQtyList != '' && this.transactionDetail.is_po_exceed_qty_restrict == false) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: 'Quantity entered is exceeding the Balance Quantity (Total Available Quantity - Used Quantity in invoice) for Row No(s): <b>' + exceedQtyList + '</b>.<br>If Used Quantity for this PO line item is of some other invoice, then this invoice may get failed during SES Creation due to insufficient Qty in PO line item. Please confirm if you still want to proceed...',
          buttonText: {
            ok: 'Ok',
            cancel: 'Cancel',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          //this.validatePOLineItemsFromAPI();
          this.submitPoLineItems();
        }
      });
    }
    else {
      if (exceedQtyList != '' && this.transactionDetail.is_po_exceed_qty_restrict == false) {
        this.commonService.showMessageBox('There is already Qty utilized for Row No(s) <b>' + exceedQtyList + '</b> for some other invoice, So this invoice may get failed during SES Creation due to insufficient Qty in PO line item.', 'Alert');
      }
      //this.validatePOLineItemsFromAPI();
      this.submitPoLineItems();
    }

    // this.selectedPOList = [];
    // this.poLineItemList = [];
    // this.clearLineItemFields();
  }

  async validatePoItemsWithMaster() {

    let fieldConfig = [];
    this.poFieldsConfig.forEach(f => {
      if (f.hasOwnProperty('IS_REQUIRED_MASTER_CHECK') && f.IS_REQUIRED_MASTER_CHECK == true) {
        fieldConfig.push({ DISPLAY_NAME: f.DISPLAY_NAME, FIELD_MAPPING_DETAIL_ID: f.FIELD_MAPPING_DETAIL_ID, PREDEFINED_TABLE_COLUMN_NAME: f.PREDEFINED_TABLE_COLUMN_NAME });
      }
    });
    let lineItemsAndFieldConfig = {
      lineItems: JSON.stringify(this.selectedPOList),
      fieldConfig: JSON.stringify(fieldConfig)
    };

    const result = await this.dataService.postData('validate-po-items-with-master', lineItemsAndFieldConfig).toPromise();
    if (result != null && (result.errorMessage == null || result.errorMessage == "")) {
      if (result != null && result.success == true) {
        return true;
      } else {
        this.invalidPoLineItemsMasterCheck = result.data;
        return false;
      }
    }
    else {
      if (result.errorCode != 0 && result.errorCode == 4000) {
        this.router.navigateByUrl('/unauthorized');
      }
      if (result.errorCode != 0 && result.errorCode == 3000) {
        this.commonService.showMessageBox("Internal error")
      }
      return false;
    }
  }

  async submitPoLineItems() {

    var masterValidationRes = await this.validatePoItemsWithMaster();
    if (masterValidationRes == false && this.invalidPoLineItemsMasterCheck.length > 0) {
      let invalidMasterCheckItems = [];
      this.invalidPoLineItemsMasterCheck.forEach(ele => {
        if (invalidMasterCheckItems.findIndex(x => x.RowNo == ele.RowNo) == -1) {
          invalidMasterCheckItems.push({ 'RowNo': ele.RowNo, Fields: [ele.FieldName] });
        } else {
          invalidMasterCheckItems[invalidMasterCheckItems.findIndex(x => x.RowNo == ele.RowNo)].Fields.push(ele.FieldName);
        }
      });
      let lineItemFailHtml = '<table class="table mt-2"><tr><th>Row No</th><th>Field(s)</th></tr>';
      invalidMasterCheckItems.forEach(ele => {
        lineItemFailHtml += '<tr><td>' + ele.RowNo + '</td><td>' + ele.Fields.join(', ') + '</td></tr>';
      });
      lineItemFailHtml += '</table>';
      this.commonService.showMessageBox('Below values does not exists in master.<br>' + lineItemFailHtml, 'Alert');
      return;
    }

    let dynamicValues = this.getPODynamicParamWithValue();
    let parameterNames = '1';
    let parameterValues = '1';

    this.selectedPOList.forEach((row: {}) => {

      Object.keys(row).forEach(col => {
        const field = this.poFieldsConfig.find(x => x.hasOwnProperty('DB_COLUMN_NAME') && (x.FIELD_NAME == col || x.DISPLAY_NAME == col));
        if (field) {
          parameterNames += '&amp;&amp;' + field.DB_COLUMN_NAME;
          parameterValues += '&amp;&amp;' + (row[col] == '' || row[col] == null ? 'undefined' : row[col]);
        }
      });

      parameterNames += ';'
      parameterValues += ';'
    });

    let requestBody = {
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      // project_id: Number(this.commonService.getUserInfoFromLocalStorage('projectId')),
      user_id: Number(this.memorystore.getItem('userId')),
      project_id: Number(this.memorystore.getItem('projectId')),
      document_type_id: Number(this.transactionDetail.document_type_id),
      document_detail_id: this.documentDetailId,
      parameter_names: parameterNames,
      parameter_values: parameterValues,
      dynamicvalue: dynamicValues,
      tab_id: Number(this.activeTab.tab_id),
      module_name: 'AP'
    };
    this.dataService.postData("add-po-line-items", requestBody).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.success == true) {
          this.commonService.showMessageBox('PO line Items added to the Invoice', 'Success');
          this.getPoMatchData();
          this.poLineItemList = [];
          this.poFirstGridFieldsConfig = [];
          this.selectedPOList = [];
          this.poFieldsConfig = []; this.totalSelectedPoQty = 0; this.totalSelectedPoAmount = 0;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });

  }

  deletePOLineItem(iRow: number) {
    let selectedLineIDs = [];
    if (iRow == -1) {
      this.lineLevelItemList[this.activeTab.tab_id].forEach(element => {
        if (element.isSelected) {
          selectedLineIDs.push(element.ID);
        }
      });
    } else {
      let lineItem = this.lineLevelItemList[this.activeTab.tab_id][iRow];
      if (lineItem != undefined) {
        selectedLineIDs.push(lineItem.ID);
      }
    }
    if (selectedLineIDs.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: 'Are you sure want to delete selected PO line item(s)?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.dataService.postData('transaction-line-delete', { doc_child_field_detail_ids: selectedLineIDs }).subscribe(res => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res.status == true) {
                this.commonService.showMessageBox('PO line item deleted', 'Success');
                selectedLineIDs.forEach(id => {
                  const index = this.lineLevelItemList[this.activeTab.tab_id].findIndex(x => x.ID == id);
                  if (index != -1) {
                    this.lineLevelItemList[this.activeTab.tab_id].splice(index, 1);
                  }
                });
                this.totalPOLineItemQty = 0; this.totalPOLineItemAmount = 0;
                this.isSESValidated = false;
                this.poItemsErrorList = [];
                this.lineLevelItemList[this.activeTab.tab_id].forEach(element => {
                  this.totalPOLineItemQty += parseFloat(element[this.poQtyFieldName]);
                  this.totalPOLineItemAmount += parseFloat(element[this.poAmtFieldName]);
                });
              }
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }
          },
          error => {
            if (error.includes("401")) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
          });
        }
      });
    } else {
      this.commonService.showMessageBox('Please select items to delete.', 'Alert');
      return;
    }
  }

  onPOExcelFileUpload(imgFile: any) {
    this.poExcelData = [];
    this.invalidPOLineItemNo = [];
    this.poExcelUploadFileName = 'Choose File';

    if (imgFile.target.files && imgFile.target.files[0]) {

      if (imgFile.target.files[0].type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        this.commonService.showMessageBox("Please select excel file.", "Alert");
        this.poExcelUploadFileControl.nativeElement.value = '';
        return;
      }
      let workBook = null;
      const reader = new FileReader();
      const excelfile = imgFile.target.files[0];

      this.poExcelUploadFileName = imgFile.target.files[0].name;

      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        const sheet = workBook.Sheets[Object.keys(workBook.Sheets)[0]];

        if (sheet != undefined) {
          var range = XLSX.utils.decode_range(sheet['!ref']);
          let header = [], row = 0, col = 0;
          for (var excelRow = range.s.r; excelRow <= range.e.r; ++excelRow) {
            let obj = {}
            for (var excelCol = range.s.c; excelCol <= range.e.c; ++excelCol) {
              var cell_address = { c: excelCol, r: excelRow };
              var val = XLSX.utils.encode_cell(cell_address);
              if (row == 0) {
                header.push(sheet[val].w);
              } else {
                obj[header[col]] = sheet[val] == undefined ? '' : sheet[val].w;
              }
              col++;
            }
            if (row > 0) {
              this.poExcelData.push(obj);
            }
            col = 0;
            row++;
          }

          if (this.poExcelData == undefined || this.poExcelData.length == 0) {
            this.commonService.showMessageBox("No data found in file.", "Alert");
            this.poExcelUploadFileControl.nativeElement.value = '';
            this.poExcelUploadFileName = 'Choose File';
            return;
          }
          else {
            let isMatchItem = true;
            let invalidPOItems = '';
            const quantityColumn = this.poDefaultFieldsConfig.find(f => f.IS_QUANTITY_COLUMN == true);
            const usedQuantityField = this.poDefaultFieldsConfig.find(f => f.IS_USED_QUANTITY_COLUMN == true);
            let invalidLengthMsg = '';
            this.poExcelData.forEach(item => {
              if (this.poExcelData.length == 0) {
                return;
              }
              let obj = {};
              for (let cols of this.poDefaultFieldsConfig) {

                // START: field length validation
                if (cols.CONTROL_TYPE == 'TEXTBOX') {
                  let fix_length = 0;
                  if (cols.MIN_LENGTH == cols.MAX_LENGTH) {
                    fix_length = cols.MIN_LENGTH;
                  }
                  let formValue = '';
                  if (item.hasOwnProperty(cols.DISPLAY_NAME) && item[cols.DISPLAY_NAME] != '') {
                    formValue = item[cols.DISPLAY_NAME];
                  }
                  if (fix_length > 0 && formValue != '') {

                    if (formValue.toString().length != fix_length) {
                      if (invalidLengthMsg == "")
                        invalidLengthMsg = "Length of " + cols.DISPLAY_NAME + " must be " + fix_length + ".";
                      else
                        invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + cols.DISPLAY_NAME + " must be " + fix_length + ".";
                    }
                  }

                  if (fix_length == 0 && cols.MIN_LENGTH > 0 && formValue != '') {
                    if (formValue.toString().length < cols.MIN_LENGTH) {
                      if (invalidLengthMsg == "")
                        invalidLengthMsg = "Length of " + cols.DISPLAY_NAME + " is min " + cols.MIN_LENGTH + ".";
                      else
                        invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + cols.DISPLAY_NAME + " is min " + cols.MIN_LENGTH + ".";
                    }
                  }

                  if (fix_length == 0 && cols.MAX_LENGTH > 0) {
                    if (formValue.toString().length > cols.MAX_LENGTH) {
                      if (invalidLengthMsg == "")
                        invalidLengthMsg = "Length of " + cols.DISPLAY_NAME + " is up to " + cols.MAX_LENGTH + ".";
                      else
                        invalidLengthMsg = invalidLengthMsg + "<BR>" + "Length of " + cols.DISPLAY_NAME + " is up to " + cols.MAX_LENGTH + ".";
                    }
                  }
                }
                // END: field length validation

                if (item.hasOwnProperty(cols.DISPLAY_NAME) && cols.IS_IMPORT_DATA_FROM_TEMPLATE == true) {
                  if (isMatchItem && cols.DISPLAY_NAME == quantityColumn.DISPLAY_NAME && item[cols.DISPLAY_NAME].trim() == '') {
                    this.commonService.showMessageBox(quantityColumn.DISPLAY_NAME + ' should not be blank.', 'Error', 'error');
                    this.poExcelData = [];
                    this.invalidPOLineItemNo = [];
                    isMatchItem = false;
                    break;
                  }
                  obj[cols.DISPLAY_NAME] = item[cols.DISPLAY_NAME];
                } else {
                  if (cols.DISPLAY_NAME == 'Row No') {
                    obj[cols.DISPLAY_NAME] = this.selectedPOList.length + 1;
                  } else if (cols.IS_CALCULATED && cols.CALCULATION_FORMULA != '') {
                    let calcFormula = '';
                    cols.CALCULATION_FORMULA.split('|').forEach(f => {
                      let regex = /^[+-]?\d+(\.\d+)?([eE][+-]?\d+)?$/;
                      if (regex.test(f.trim())) {
                        const matchField = this.poDefaultFieldsConfig.find(p => p.FIELD_MAPPING_DETAIL_ID == Number(f));
                        let fieldVal = 0;
                        if (matchField) {
                          fieldVal = item[matchField.DISPLAY_NAME];
                        }
                        calcFormula = calcFormula + 'parseFloat(' + fieldVal.toString().replace(/,/g, '') + ')';
                      }
                      else {
                        calcFormula = calcFormula + f.trim();
                      }
                    });
                    const val = eval(calcFormula);
                    obj[cols.DISPLAY_NAME] = isNaN(parseFloat(val)) ? '' : parseFloat(val);
                  } else {
                    const uniqueCombinationCols = this.poFirstGridFieldsConfig.filter(f => f.IS_USED_FOR_UNIQUE_COLUMN == true);
                    if (cols.IS_UNIQUE) {
                      let poUniqueID = '';
                      uniqueCombinationCols.forEach(u => {
                        poUniqueID += (poUniqueID != '' ? '_' : '') + item[u.DISPLAY_NAME];
                      });
                      obj[cols.DISPLAY_NAME] = poUniqueID;
                    } else {
                      let filteredData = 'this.poLineItemList.find(a => true';
                      uniqueCombinationCols.forEach(u => {
                        filteredData += ' && a["' + u.DISPLAY_NAME + '"]==item["' + u.DISPLAY_NAME + '"]';
                      });
                      filteredData += ')';
                      const filteredObj = eval(filteredData);
                      if (filteredObj != undefined) {
                        if (!obj.hasOwnProperty('Total Quantity')) {
                          obj['Total Quantity'] = filteredObj[quantityColumn.DISPLAY_NAME];
                        }
                        if (cols.DISPLAY_NAME == usedQuantityField.DISPLAY_NAME) {
                          obj[cols.DISPLAY_NAME] = filteredObj[usedQuantityField.DISPLAY_NAME];
                        } else if (cols.DISPLAY_NAME != 'Total Quantity') {
                          obj[cols.DISPLAY_NAME] = filteredObj[cols.DISPLAY_NAME];
                        }
                      } else {
                        obj[cols.DISPLAY_NAME] = '';
                        isMatchItem = false;
                        if (invalidPOItems == '') {
                          invalidPOItems = '<table class="table custom_table"><tr>';
                          uniqueCombinationCols.forEach(u => {
                            invalidPOItems += '<th>' + u.DISPLAY_NAME + '</th>';
                          });
                          invalidPOItems += '</tr>';
                        }
                        invalidPOItems += '</tr>';
                        uniqueCombinationCols.forEach(u => {
                          invalidPOItems += '<td>' + (item[u.DISPLAY_NAME] == undefined ? '-' : item[u.DISPLAY_NAME]) + '</td>';
                        });
                        invalidPOItems += '</tr>';
                        break;
                      }
                    }
                  }
                }
              }

              if (isMatchItem) {
                this.selectedPOList.push(obj);
              }
            });

            if (invalidPOItems != '') {
              invalidPOItems += '</table>';
              this.commonService.showMessageBox('Below PO item(s) does not exists.<br>' + invalidPOItems, 'Error', 'error');
            }

            if (invalidLengthMsg != '') {
              this.commonService.showMessageBox(invalidLengthMsg, 'Alert');
              this.poExcelData = []; this.selectedPOList = [];
              return;
            }

            this.selectedPOList.forEach((sp, i) => {
              sp['Row No'] = (i + 1);
              this.invalidPOLineItemFields[sp['Row No']] = [];
              this.totalSelectedPoQty += parseFloat(sp[quantityColumn.FIELD_NAME].toString().replace(/,/g, ''));
              this.totalSelectedPoAmount += parseFloat(sp[this.poDefaultFieldsConfig.find(f => f.IS_AMOUNT_COLUMN == true).FIELD_NAME].toString().replace(/,/g, ''));
            });

            if (this.poFieldsConfig.length == 0) {
              this.poDefaultFieldsConfig.push({ IS_EDITABLE: false, FIELD_NAME: 'Total Quantity', DISPLAY_NAME: 'Total Quantity', CONTROL_TYPE: 'LABEL', DECIMAL_PLACES: quantityColumn.DECIMAL_PLACES, VALIDATION_TYPE: 'NUMERIC' });

              var eleRowNo = this.poDefaultFieldsConfig.find(f => f.FIELD_NAME == 'Row No');
              if (eleRowNo != undefined) {
                this.poDefaultFieldsConfig.splice(this.poDefaultFieldsConfig.findIndex(f => f.FIELD_NAME == 'Row No'), 1);
                this.poDefaultFieldsConfig.splice(0, 0, eleRowNo);
              }
              var eleTotalQty = this.poDefaultFieldsConfig.find(f => f.FIELD_NAME == 'Total Quantity');
              this.poDefaultFieldsConfig.splice(this.poDefaultFieldsConfig.findIndex(f => f.FIELD_NAME == 'Total Quantity'), 1);
              this.poDefaultFieldsConfig.splice(this.poDefaultFieldsConfig.findIndex(f => f.IS_USED_QUANTITY_COLUMN == true), 0, eleTotalQty);

              this.poFieldsConfig = this.poDefaultFieldsConfig;
            }
            this.poFieldsConfig.forEach(async field => {
              field['mandatory_line_no'] = [];
              field['editable_line_no'] = [];
            });
            this.selectedPOList.forEach(rowData => {
              this.poFieldsConfig.forEach(async field => {
                if (field.IS_REQUIRED_VALUE_BASED_VALIDATION == 1) {
                  this.poFieldValueBasedValidation(field, rowData);
                }
              });
            });
            this.isPOLineItemsValid = false;
          }
        }
      }
      reader.readAsBinaryString(excelfile);
      if (this.poExcelUploadFileControl) {
        this.poExcelUploadFileControl.nativeElement.value = '';
      }
    } else {
      this.poExcelUploadFileName = 'Choose File';
    }
  }

  downloadPoUploadTemplate() {
    let excelTemplateData = [];
    this.poLineItemList.forEach(row => {
      let obj = {};
      let filteredCols = this.poFirstGridFieldsConfig.filter(f => f.IS_DISPLAY_TEMPLATE == true);
      filteredCols.sort((a, b) => (a.TEMPLATE_COLUMN_ORDER > b.TEMPLATE_COLUMN_ORDER) ? 1 : ((b.TEMPLATE_COLUMN_ORDER > a.TEMPLATE_COLUMN_ORDER) ? -1 : 0));
      filteredCols.forEach(col => {
        obj[col.DISPLAY_NAME] = col.IS_EXPORT_DATA_TO_TEMPLATE == true ? row[col.DISPLAY_NAME] : '';
      });
      excelTemplateData.push(obj);
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelTemplateData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');
    // XLSX.writeFile(wb, this.commonService.getUserInfoFromLocalStorage('projectName') + '_PO Item Template' + '.xlsx');
    XLSX.writeFile(wb, this.memorystore.getItem('projectName') + '_PO Item Template' + '.xlsx');
  }

  getObjectFromArrayIfExists(list: any, key: string, val: any) {
    return list.find(x => x[key] == val);
  }

  fetchSesLineItem() {

    if (this.fetchSesLineitemAPI == null || this.fetchSesLineitemAPI == undefined && this.fetchSesLineitemAPI != '') {
      return;
    }

    let apiParams = this.fetchSesLineitemAPI['PARAMETER'];
    let apiID = this.fetchSesLineitemAPI['API_ID'];

    if (apiParams != null) {
      apiParams = JSON.parse(apiParams);
    }

    let invalidFieldMsg = '';
    if (apiParams != null && typeof (apiParams) == 'object') {
      Object.keys(apiParams).forEach(p => {
        let val = this.frmTransaction.get(apiParams[p]).value;
        if (val == null || val == undefined || val == '') {
          let fieldName = p;
          this.transactionFieldList.forEach((section) => {
            section.forEach(a => {
              a.field_details.forEach(async (field) => {
                if (field.db_column_name == apiParams[p]) {
                  fieldName = field.field_name;
                }
              });
            });
          });
          invalidFieldMsg += '- ' + fieldName + '<br>';
        }
        apiParams[p] = this.frmTransaction.get(apiParams[p]).value;
      });
    }
    if (invalidFieldMsg != '') {
      //this.commonService.showMessageBox('Below field(s) are required.<br>' + invalidFieldMsg, 'Error', 'error');
      this.commonService.showMessageBox('SES not created in SAP yet.<br>SES details can be fetched from SAP only when the SES number is available in SES Number field.', 'Alert', 'error');
      return;
    }

    this.sesLineitemList = [];

    ////test data
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.showModal(this.sesLineitemModal, 'xl');

    this.dataService.post_realTimeApi(apiID, apiParams).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          res = JSON.parse(JSON.parse(res.data));
          if (res != null && (res.status == true || res.status == 'success')) {
            if (res.data != null && res.data ?.item.length > 0) {
              this.sesLineitemList = res.data.item;
              this.showModal(this.sesLineitemModal, 'xl');
            } else {
              this.commonService.showMessageBox("SES line item not found.", "Alert");
            }
          }
          else {
            this.commonService.showMessageBox("SES line item not found.", "Alert");
          }
        } else {
          this.commonService.showMessageBox(res.error_message, 'Error');
          return;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  //------------------------ END: PO ----------------------

  callOnAutoCompleteChangedEvent(data) {
    this.frmTransaction
      .get(data.db_column_name)
      .setValue(data.fieldValue);
    if (data.control_type == 'DROPDOWN') {
      this.changeDropdownFieldValue(data);
    } else if (data.control_type == 'TEXTBOX') {
      this.changeTextFieldValue(data);
    }


  }

  onTextBoxKeyPressEvent(event: any, field: any) {
    const reg = this.commonService.getRegForDecimal;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  fieldLevelActionClicked(field: any, action: any) {

    if (action.action_type == 'API') {

      let params = new HttpParams();
      params = params.append("project_id", this.commonService.selectedProject);
      params = params.append("document_type_id", this.transactionDetail.document_type_id);
      params = params.append("process_id", this.transactionDetail.process_id);
      params = params.append("api_name", action.action_name);

      this.dataService.getData("realtime_api_details", params).subscribe(res => {
        if (res != null && res.status) {
          if (res.data != null && res.data.length > 0) {

            let params = res.data[0].parameter;
            let apiID = res.data[0].api_id;
            //apiUrl = this.commonService.rewriteRealtimeApiUrl(apiUrl);

            if (params != null) {
              params = JSON.parse(params);
            }
            if (params != null && typeof (params) == 'object') {
              Object.keys(params).forEach(p => {
                params[p] = this.frmTransaction.get(params[p]).value;
              });
            }
            //Xerox Specific change Start
            // else if (this.commonService.getUserInfoFromLocalStorage("projectId") == 4) {
            else if (this.memorystore.getItem("projectId") == 4) {
              let searchColumns = {};
              searchColumns['PONUMBER'] = this.frmTransaction.get(field.db_column_name).value;
              params = {

                sub_group_id: this.commonService.selectedSubgroup.toString(),
                search_columns: searchColumns,
                // subgroup_id: this.commonService.selectedSubgroup.toString()
              };

            }
            //Xerox Specific change end

            this.dataService.post_realTimeApi(apiID, params).subscribe((res) => {
              if (res != null && (res.error_message == null || res.error_message == "")) {
                if (res.status == true) {
                  res = JSON.parse(JSON.parse(res.data));
                  if (res.message == 'request received') {
                    this.frmTransaction.get(field.db_column_name).setValue(res["VatCode"]);
                    this.frmTransaction.get(field.db_column_name).setValue(res["response"]);
                  }
                  //Xerox Specific change Start
                  // else if (this.commonService.getUserInfoFromLocalStorage("projectId") == 4) {
                  else if (this.memorystore.getItem("projectId") == 4) {
                    this.lstPOMaster = res.Result.data;
                    this.strponumber = this.frmTransaction.get(field.db_column_name).value
                    this.showModal(this.RealtimeDataModal, 'xl');
                  }
                  //Xerox Specific change End
                } else {
                  this.commonService.showMessageBox(res.error_message, 'Error');
                  return;
                }
              }
              else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                  this.router.navigateByUrl('/unauthorized');
                  return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                  this.commonService.showMessageBox("Internal error")
                }
              }
            },
            error => {
              if (error.includes("401")) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
            });
          } else {
            this.commonService.showMessageBox('Realtime API details not available for current selection', 'Alert');
          }
        }
      });

    }

  }

  isCheckListValid() {
    return this.checklist.findIndex((x) => x.checked == false && x.is_mandatory == 1) == -1;
  }

  lineItemCount(tab_id: number) {
    const count = this.lineLevelItemList[tab_id] ?.length
    return count == undefined ? 0 : count;
  }

  get_ocr_process_status(current_process_id, document_type_id) {
    // let params = {
    //   // // project_id: Number(this.commonService.getUserInfoFromLocalStorage("projectId")),
    //   // project_id: Number(this.memorystore.getItem("projectId")),
    //   // document_type_id: document_type_id,
    //   // // user_id: Number(this.commonService.getUserInfoFromLocalStorage("userId")),
    //   user_id: Number(this.memorystore.getItem("userId")),
    //   project_id: (this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem("projectId"))),
    //   document_type_id: this.encryptDecryptservice.encryptUsingAES256(document_type_id),
    // };
    let bodydata = {
      documenttypeid: (this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId.toString())),
      encuserid: (this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))),
      projectid: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    }
    // this.dataService.getData('ocr/get_ocr_process_queue_id', params).subscribe((res) => {
    this.dataService.postData('ocr/get_ocr_process_queue_id', bodydata).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined) {
          if (res.data != undefined && res.data != null) {

            let ocr_process_queue_id = res.data[0] ?.process_id;
            let ocr_queue_access_eable_role = res.data[0] ?.ocr_queue_access_eable_role;
            if (ocr_process_queue_id == current_process_id) {
              let dialog_Message = this.invoicePrimaryDetails.source !== "Vendor Portal" ? "<b>OCR extraction is in-progress.</b> <br/> Do you want to cancel?." : "<b>OCR extraction is in-progress.</b> <br/>";
              let ok_Message = this.invoicePrimaryDetails.source !== "Vendor Portal" ? 'Yes' : 'Create Another Invoice';
              if (ocr_queue_access_eable_role) {

                const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                  disableClose: true,
                  data: {
                    title: "Message",
                    message: dialog_Message,
                    messageBoxType: 'progress-bar',
                    buttonText: {
                      ok: ok_Message,
                      cancel: 'Back to Dashboard',
                    },
                  },
                });
                dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                  if (confirmed) {
                    if (this.invoicePrimaryDetails.source !== "Vendor Portal") {
                      this.cancel_OCR_Queue_and_Moving_to_Next_Queue(res.data[0]);
                    }
                    else {
                      this.router.navigate(['/create-work-item']);
                    }

                  } else {
                    this.router.navigate(['/control-panel']);
                  }
                });

              }
              // else {
              //   const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              //     disableClose: true,
              //     data: {
              //       title: "Message",
              //       message: dialog_Message,
              //       messageBoxType: 'progress-bar',
              //       buttonText: {
              //         ok: 'Back to Dashboard',
              //         cancel: 'Create Another Invoice',
              //       },
              //     },
              //   });
              //   dialogRef.afterClosed().subscribe((confirmed: boolean) => {
              //     if (confirmed) {
              //       this.router.navigate(['/dashboard']);
              //     } else {
              //       this.router.navigate(['/create-work-item']);
              //     }
              //   });
              // }
            }
          }

        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  attachmentCount(refId: number): number {
    let result = this.fileAttachmentHistoryList.filter(x => x.ref_history_id == refId);
    return result != undefined ? result.length : 0;
  }

  processAsDuplicateInvoice() {
    this.IsSkipApprovalForDuplicate = true;
    this.isDuplicate = true;
    this.submitTransaction();
  }

  openDuplicateInvoice() {
    let params = new HttpParams();
    // params = params.append('documentDetailId', this.commonService.getUserInfoFromLocalStorage('documentDetailId'));
    params = params.append('documentDetailId', this.memorystore.getItem('documentDetailId'));
    this.dataService.getData('getduplicatedata', params).subscribe((response) => {
      if (response != null && (response.error_message == null || response.error_message == "")) {
        if (response ?.data ?.Table ?.length > 0) {
          this.lstDuplicateData = [];
          this.isShownDuplicateAlert = false;
          this.lstDuplicateData = response.data.Table;
          this.duplicateDataKeys = Object.keys(this.lstDuplicateData[0]);
          this.showModal(this.duplicateInvoiceSubmittedModal, 'xl');
        }
        else {

          this.commonService.showMessageBox("No data found.", "Message")
        }
      }
      else {
        if (response.errorCode != 0 && response.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (response.errorCode != 0 && response.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

  // duplicateGridCellClickEvent(cellData) {
  //   if (cellData.columnName.toLowerCase() == "attachment") {
  //     this.commonService.openAttachment(cellData.rowData.URN, '');
  //   }
  // }

  toggleSelectAllCheckbox(event: any, list: any, targetColumn: string) {
    list.forEach(x => x[targetColumn] = event.checked);
  }
  toggleNonPOSelectAllCheckbox(event: any, list: any, targetColumn: string) {
    this.lineLevelItemList.forEach(element => {
      element.forEach(item => {
        item['isSelected'] = event.checked;
      })
    });
    this.IsAllChecked = true;
  }

  getLineItemsGrandTotalByField(dbColumnName: string, list: any) {
    let total = 0;
    list.forEach(x => total += Number(x[dbColumnName]));
    return total;
  }

  downloadAttachment(filePath: string) {
    if (filePath != '')
      this.commonService.openAttachment('', filePath);
  }

  cancel_OCR_Queue_and_Moving_to_Next_Queue(ocr_queue_data: any) {
    //roleId,userId,projectId

    let params = new HttpParams();
    // params = params.append('document_detail_id', this.commonService.getUserInfoFromLocalStorage('documentDetailId'));
    // params = params.append('project_id', this.commonService.getUserInfoFromLocalStorage('projectId'));
    // params = params.append('user_id', this.commonService.getUserInfoFromLocalStorage('userId'));
    // params = params.append('role_id', this.commonService.getUserInfoFromLocalStorage('roleId'));
    params = params.append('document_detail_id', this.memorystore.getItem('documentDetailId'));
    params = params.append('project_id', this.memorystore.getItem('projectId'));
    params = params.append('user_id', this.memorystore.getItem('userId'));
    params = params.append('role_id', this.memorystore.getItem('roleId'));
    params = params.append('source', this.invoicePrimaryDetails.source);
    params = params.append('ocr_queue_id', ocr_queue_data.process_id);

    this.dataService.getData('ocr/cancel_ocr_queue', params).subscribe((response) => {
      if (response != null && (response.error_message == null || response.error_message == "")) {
        if (response != null && response.status == true) {
          this.commonService.showMessageBox("OCR queue cancelled successfully.", "Message");
          window.location.reload();
        }
        else {
          this.commonService.showMessageBox("Unable to cancel OCR queue.");
        }
      }
      else {
        if (response.errorCode != 0 && response.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (response.errorCode != 0 && response.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  get_transaction_parent_field(tab: any) {
    let fieldValue;
    let lstParent = [];
    let obj = {};
    let lstDuplicateChk = [];
    if (tab != null) {
      this.transactionFieldList[tab.tab_id].forEach((row) => {
        row.field_details.forEach((x) => {
          fieldValue = this.frmTransaction.get(x.db_column_name).value;

          let displayText = '';
          if (fieldValue != null && fieldValue != undefined) {
            if (x.control_type == 'DROPDOWN') {
              displayText = fieldValue.toString();
              if (x.options != null) {
                let option = x.options.find((o) => o.name == fieldValue);
                if (option != undefined) {
                  fieldValue = option.id;
                }
                else {
                  displayText = x.options.find((o) => o.id == fieldValue) ?.name;
                }
              }
            }
            if (x.control_type == "DATE") {
              fieldValue = this.commonService.dateFormating(fieldValue);
            }
            obj[x.db_column_name] = fieldValue;
          } else {
            if (x.control_type == 'DROPDOWN') {
              obj[x.db_column_name] = 0;
            } else {
              obj[x.db_column_name] = '';
            }
          }
          obj = {
            fieldId: x.field_mapping_detail_id,
            fieldCol: x.db_column_name,
            fieldVal: fieldValue != null ? fieldValue.toString().trim() : '',
            controlType: x.control_type,
            displayText: displayText == undefined ? '' : displayText
          };
          lstParent.push(obj);

          lstDuplicateChk.push({
            ParameterName: x.db_column_name,
            ParameterValue: fieldValue != null ? fieldValue.toString().trim() : ''
          });
          //COLUMN_1="COMPANY TYPE"
          if (x.db_column_name == 'COLUMN_1') {
            if (fieldValue != null && fieldValue != undefined && fieldValue != '') {
              this.companyType = (fieldValue == 1) ? 'TML' : 'TMPVL';
            }
          }

        });
      });
    }
    return {
      lstParent, lstDuplicateChk
    }
  }

  async getProjectList() {
    this.lstProjectList = [];

    let params = new HttpParams();
    // // params = params.append("project_id", this.commonService.getUserInfoFromLocalStorage('projectId'));
    // params = params.append("project_id", this.memorystore.getItem('projectId'));
    params = params.append("project_id", this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('projectId')));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    await this.dataService.getDataPromise('get-projects', params).then((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.lstProjectList.push({
              value: res.data[i].project_id,
              text: res.data[i].project_name

            });
          }
          // this.selectedProject = Number(this.commonService.getUserInfoFromLocalStorage('projectId'));
          this.selectedProject = Number(this.memorystore.getItem('projectId'));
          this.getDocumentTypeList();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

  async getDocumentTypeList() {
    this.lstDocumentType = [];

    let params = new HttpParams();
    // params = params.append("project_id", this.selectedProject);
    // params = params.append("subgroup_id", this.commonService.selectedSubgroup);
    // params = params.append("role_id", this.commonService.selectedRole);
    params = params.append("project_id", this.encryptDecryptservice.encryptUsingAES256(this.selectedProject));
    params = params.append("subgroup_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    // params = params.append("role_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
    await this.dataService.getDataPromise('invoice/getdocumenttypes', params).then((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.lstDocumentType.push({
              documentTypeId: res.data[i].DOCUMENT_TYPE_ID,
              documentTypeName: res.data[i].DOCUMENT_TYPE_NAME,
              isCommentMandatory: res.data[i].IS_COMMENT_MANDATORY,
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  async openChangeDocumentTypeModel() {
    if (this.lstDocumentType.length == 0) {

      await this.getProjectList();
    }

    let document = this.lstDocumentType.find(d => d.documentTypeId == this.transactionDetail.document_type_id);
    if (document != undefined) {
      this.selectedDocument = document;
    }


    this.modalReference_ChangeDocumentType = this.modalService.open(this.changeDocumentTypeModal, {
      size: 'md', centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  onSelectDocument(doc: any) {
    let obj = {
      action: "SUB_DOC_WITH_PROCESS",
      projectId: this.commonService.selectedProject,
      documentTypeId: this.selectedDocument.documentTypeId,
      urn: "",
      durationCreateDate: "",
      durationInvoiceDate: ""
    }

    this.lstSubDocumentType = [];
    this.isSubDocumentTypeExist = false;

    this.dataService.getData('getWorkItemTypeChangeFilter', obj).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          res.data.Table.forEach((element) => {
            this.lstSubDocumentType.push({
              subDocumentTypeId: element.value,
              subDocumentTypeName: element.text
            });
          });
          this.isSubDocumentTypeExist = this.lstSubDocumentType.length > 0;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

  changeDocumentType() {
    if (this.transactionDetail.document_type_id != this.selectedDocument.documentTypeId) {

      if (this.selectedDocument.isCommentMandatory && (this.changeDocumentComment == '' || this.changeDocumentComment == undefined)) {
        this.commonService.showMessageBox("Comment is mandatory.", "Validation");
        return;
      }

      let lst = [];
      lst.push({
        DocumentDetailId: this.documentDetailId,
        SrcDocumentTypeId: this.transactionDetail.document_type_id,
        DestDocumentTypeId: this.selectedDocument.documentTypeId,
        DestSubDocTypeId: this.selectedSubDocument.subDocumentTypeId,
        Reason: this.changeDocumentComment,
        // UserId: this.commonService.getUserInfoFromLocalStorage('userId'),
        UserId: this.memorystore.getItem('userId'),
        ModuleName: 'AP'
      });

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          title: "Change Work Item Type",
          messageBoxType: 'question',
          message: 'Some of the fields may be lost when you change the work item type.<BR>Are you sure you want to change the work item type?',
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          let initial_params = {
            lstParameter: lst
          }
          this.dataService.postData('postWorkItemChange', initial_params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
              if (res.status != null) {
                const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
                  disableClose: true,
                  data: {
                    title: "Message",
                    messageBoxType: 'ok',
                    icon: 'success',
                    message: 'Work item type successfully changed to ' + this.selectedDocument.documentTypeName + '.'
                  }
                });
                dialogRef1.afterClosed().subscribe((confirmed: boolean) => {
                  if (confirmed) {
                    this.modalReference_ChangeDocumentType.close();
                    this.isCommentExpand_changeDocumentTypeModel = false;
                    this.router.navigate(['/control-panel']);
                  }
                  else {
                    this.modalReference_ChangeDocumentType.close();
                    this.isCommentExpand_changeDocumentTypeModel = false;
                  }
                });
              }
            }
            else {
              if (res.errorCode != 0 && res.errorCode == 4000) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
              if (res.errorCode != 0 && res.errorCode == 3000) {
                this.commonService.showMessageBox("Internal error")
              }
            }

          },
            error => {
              if (error.includes("401")) {
                this.router.navigateByUrl('/unauthorized');
                return;
              }
            });
        }
        else {
          this.modalReference_ChangeDocumentType.close();
          this.isCommentExpand_changeDocumentTypeModel = false;
          this.selectedDocument = this.lstDocumentType[0];
        }
      });
    }
    else {
      this.commonService.showMessageBox("Select another Work Item Type.", "Validation");
      return;
    }

  }

  closeChangeDocumentTypeModal() {
    this.selectedDocument = { documentTypeId: this.transactionDetail.document_type_id, documentTypeName: this.transactionDetail.document_type_name };
    this.modalReference_ChangeDocumentType.close();
    this.isCommentExpand_changeDocumentTypeModel = false;
  }

  fillemailTypeList() {
    this.emailTypeList = [];
    this.emailTypeList.push({ value: 0, text: 'Single' });
    this.emailTypeList.push({ value: 1, text: 'Group' });
    this.selectedEmailType = 0;
    this.onSelectEmailType(this.selectedEmailType);
  }

  onSelectEmailType(val: any) {

    this.emailTemplateList = [];
    this.strQCBODY = '';
    this.strQCSubject = '';
    this.selectedEmailTemplate = null;
    let obj = {
      document_type_id: this.transactionDetail.document_type_id,
      from_process_id: 0,//this.transactionDetail.process_id,
      to_process_id: this.frmTransaction.get(this.nextQueue).value,
      is_group_template: val,

    }

    this.dataService.getData('get-raise-query-template-name', obj).subscribe(
      (res) => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          res.data ?.Table ?.forEach((element) => {
            this.emailTemplateList.push({
              value: element.EMAIL_TEMPLATE_ID,
              text: element.EMAIL_TEMPLATE_NAME
            });
          });
          if (this.commonService.selectedProject == '4' && this.emailTemplateList.length > 0) {
            this.selectedEmailTemplate = this.emailTemplateList[0].value;
            this.onSelectEmailTemplate(this.selectedEmailTemplate);
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

  onSelectEmailTemplate(val: any) {
    this.strQCBODY = '';
    this.strQCSubject = '';
    let obj = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_id: this.transactionDetail.document_type_id,
      // document_detail_id: this.commonService.getUserInfoFromLocalStorage('documentDetailId'),
      document_detail_id: this.memorystore.getItem('documentDetailId'),
      from_process_id: 0,//this.transactionDetail.process_id,
      to_process_id: this.frmTransaction.get(this.nextQueue).value,
      is_group_template: this.selectedEmailType,
      his_id: 0,
      email_template_id: val

    }

    this.isDomainRequire = false;
    this.lstDomainValues = [];
    this.dataService.getData('get-raise-query-template-body', obj).subscribe(
      (res) => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.data ?.Table ?.length > 0) {
            this.strQCBODY = res.data.Table[0]['Email_Body'];
            this.strQCSubject = res.data.Table[0]['Email_Subject'];
            this.strQCSubjectPost = res.data.Table[0]['Post_Email_Subject'];

            if (res.data.Table2[0]["ISDOMAINEXCEPTIONREQUIRED"] == "1") {
              this.isDomainRequire = true;
              let domainValue = res.data.Table2[0]["DomainExceptionValue"];
              this.lstDomainValues = domainValue.split(',');
            }
            this.lstRQAttachment = [];
            this.lstRQAttachment1 = [];
            this.lstRQAttachment1 = res.data.Table1;

            this.lstRQAttachment = this.lstRQAttachment1.concat(this.lstRQAttachment2);

          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

  openRQSearchModal(openbox: number) {

    this.isRQOpenSearchBox = openbox;
    let obj = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_id: this.transactionDetail.document_type_id,
      to_process_id: this.frmTransaction.get(this.nextQueue).value
    }

    this.dataService.getData('get-raise-query-user-list', obj).subscribe(
      (res) => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          this.lstRQUserList = res.data.Table;
          this.showModal(this.raiseQuerySearchModal, 'lg');
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      })

  }

  setRQEmailIds() {

    let emailIds: string = '';

    this.lstRQUserList ?.forEach((element) => {

      if (element.action_checkbox_button == true) {

        emailIds += element["Email Id"] + ";";

      }
    });

    emailIds = emailIds.replace(/;\s*$/, "");

    if (this.isRQOpenSearchBox == 0) {

      this.strRQTO += emailIds;
    }
    else {
      this.strRQCC += emailIds;
    }

  }

  showModalBody(modelTemplate, body: any, modalSize: string = 'lg', mode_of_attachment) {


    var parser = new DOMParser();
    var doc = parser.parseFromString(body, 'text/html');

    if (mode_of_attachment == 'Email')
      this.attachmentMailContent = doc.body.innerHTML;
    else
      this.attachmentMailContent = doc.body.innerText;

    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });


  }

  getCellStyle(col: string): Object {
    let hyperlinkCols: any = ['attachment'];
    if (hyperlinkCols.includes(col.toLowerCase())) {
      return { 'cursor': 'pointer', 'text-decoration': 'underline', 'color': '#76449b', 'font-weight': 600 };
    } {
      return {};
    }
  }

  duplicateGridCellClickEventNew(columnName: String, rowData: any, rowIndex: number) {
    if (columnName.toLowerCase() == "attachment") {
      this.commonService.openAttachment(rowData.URN, '');
    }
  }

  submitNon_PO_LineItem(tab_data: any) {
    let lineItemRequest = {
      document_detail_id: this.documentDetailId,
      document_type_id: this.transactionDetail.document_type_id,
      project_id: this.commonService.selectedProject,
      tabs: [],
    };
    let tab_item_list = [];

    Object.keys(this.lineLevelItemList).forEach((tab) => {
      let findTab = this.dynamicTabs.find(t => t.tab_id == tab && t.tab_field_type != "POLINEITEM");
      if (findTab != undefined) {
        tab_item_list.push(tab_data)
        tab_item_list.forEach((item) => {
          delete item['rowIndex'];
          // Object.keys(item).forEach((key) => {
          //   if (item.hasOwnProperty(key + '_text')) {
          //     delete item[key + '_text'];
          //   }
          // });
        });
        lineItemRequest.tabs.push({
          tab_id: tab,
          tab_data: tab_item_list,
        });
      }

      this.dataService.postData('transaction-tabs', lineItemRequest).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res != undefined) {
            if (res.status == 1) {

              if (this.isEdit) {
                this.commonService.showMessageBox("Line items updated successfully.", 'Message');
              }
              else {
                this.commonService.showMessageBox("Line items added successfully.", 'Message');
              }
            }
            else {
              if (this.isEdit) {
                this.commonService.showMessageBox("Unable to add Line items.", 'Alert');
              }
              else {
                this.commonService.showMessageBox("Unable to update Line items.", 'Alert');
              }
            }
            //this.lineLevelItemList = [];
            this.lineLevelItemList[tab] = res.data;
            this.getNonPoLineItemAmountTotal();
          }
          this.editedLineItemIndex = 0;
          this.isEdit = false;
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
    });


  }

  getNonPoLineItemAmountTotal(tabId: number = 0) {
    this.lineItemTotalAmount = 0;
    let nonPoLineItemAmountColumn = '';
    this.transactionFieldList[tabId == 0 ? this.activeTab.tab_id : tabId].forEach((row) => {
      row.field_details.forEach((x) => {
        if (x.is_po_match_amount_column)
          nonPoLineItemAmountColumn = x.db_column_name;
      });
    });
    if (nonPoLineItemAmountColumn != '') {
      this.lineLevelItemList[tabId == 0 ? this.activeTab.tab_id : tabId].forEach(item => {
        this.lineItemTotalAmount += parseFloat(item[nonPoLineItemAmountColumn]);
      });
    }
  }

  get_non_po_line_item_details() {
    let params = {
      document_detail_id: this.documentDetailId,
      document_type_id: this.transactionDetail.document_type_id,
      project_id: this.commonService.selectedProject
    };
    this.dataService.getData("get_non_po_lineitem", params).subscribe((res) => {
      if (res != null && res != undefined) {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            Object.keys(this.lineLevelItemList).forEach((tab) => {
              //this.lineLevelItemList = [];
              this.lineLevelItemList[tab] = res.data;
              this.getNonPoLineItemAmountTotal();
            });
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  async Queue_Movement_Validation(to_queue_actions: any, lstParent: any, child_field_details: any): Promise<string> {
    let validation_message = "";
    let apiID: number;
    let dynamic_params: any;
    let tabParentField = this.dynamicTabs.find((x) => x.tab_field_type == 'NORMAL');
    this.invoiceAmount = 0
    if (tabParentField != null) {
      this.transactionFieldList[tabParentField.tab_id].forEach((row) => {
        row.field_details.forEach((x) => {
          if (x.is_po_match_amount_column) {
            this.header_tolerance_amount_field_Name = x.field_name;
            this.invoiceAmount = this.frmTransaction.get(x.db_column_name).value;
          }
        });
      });
    }
    this.totalPOLineItemAmount = 0;
    this.totalPOLineItemQty = 0;
    let tabPOChildField = this.dynamicTabs.find((x) => x.tab_field_type == 'POLINEITEM');
    if (tabPOChildField != null && tabPOChildField != undefined) {
      this.lineLevelItemList[tabPOChildField.tab_id].forEach(element => {
        this.totalPOLineItemQty += parseFloat(element[this.poQtyFieldName]);
        this.totalPOLineItemAmount += parseFloat(element[this.poAmtFieldName]);
      });
    } else {
      this.totalPOLineItemAmount = this.lineItemTotalAmount;
    }
    // let tabNONPOChildField = this.dynamicTabs.find((x) => x.tab_field_type == 'LINEITEM');
    // let non_po_line_item_amount_db_field_name: any;
    // if (tabNONPOChildField != null && tabNONPOChildField != undefined) {
    //   this.transactionFieldList[tabNONPOChildField.tab_id].forEach((row) => {
    //     row.field_details.forEach((x) => {
    //       if (x.is_po_match_amount_column)
    //         non_po_line_item_amount_db_field_name = x.db_column_name;
    //     });
    //   });

    //   this.lineLevelItemList[tabNONPOChildField.tab_id].forEach(element => {
    //     this.totalPOLineItemAmount += parseFloat(element[non_po_line_item_amount_db_field_name]);
    //   });
    // }

    let checklistIds = [];
    this.checklist.forEach((x) => {
      if (x.checked) {
        checklistIds.push(x.checklist_id);
      }
    });
    let tolerance_mst: any = null;
    let tolerance_Obj = this.tolerance_limit_obj.length > 0 ? this.tolerance_limit_obj[0] : null;
    if (tolerance_Obj != null) {
      tolerance_mst = {
        forValidate: "ONSUBMIT",
        header_invoice_amount: parseFloat(this.invoiceAmount.toString()),
        line_item_Total_amount: parseFloat(this.totalPOLineItemAmount.toString()),
        document_type_id: tolerance_Obj.document_type_id,
        tolerance_type: tolerance_Obj.tolerance_type,
        lower_limit_percentage: tolerance_Obj.lower_limit_percentage,
        upper_limit_percentage: tolerance_Obj.upper_limit_percentage,
        lower_limit_fixed: tolerance_Obj.lower_limit_fixed,
        upper_limit_fixed: tolerance_Obj.upper_limit_fixed,
      }

    }

    let params = {
      module_name: "PI",
      project_id: Number(this.commonService.selectedProject),
      document_detail_id: Number(this.documentDetailId),
      document_type_id: this.transactionDetail.document_type_id,
      role_id: Number(this.commonService.selectedRole),
      from_queue_id: this.transactionDetail.process_id,
      to_queue_id: this.frmTransaction.get(this.nextQueue).value,
      invoice_amount: parseFloat(this.setDecimalPlaces(this.invoiceAmount, 2, 'NUMERIC')),
      child_item_total_amount: parseFloat(this.setDecimalPlaces(this.totalPOLineItemAmount, 2, 'NUMERIC')),
      child_item_count: child_field_details.length,
      parent_field_details: lstParent,
      child_field_details: child_field_details,
      source: this.transactionDetail.source,
      vendor_type: this.companyType,
      comment: this.frmTransaction.get(this.transactionComment).value,
      checklist_ids: checklistIds,
      reject_reason_ids: this.rejectReasonIds,
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      tolerance_type: this.toleranceType,
      tolerance_limit_value: this.toleranceLimitValue,
      tolerance_limitObj: tolerance_mst
      //tol type,tol limit-Ram change
    };

    let realtime_params = new HttpParams();
    realtime_params = realtime_params.append("project_id", Number(this.commonService.selectedProject));
    realtime_params = realtime_params.append("document_type_id", this.transactionDetail.document_type_id);
    realtime_params = realtime_params.append("process_id", this.frmTransaction.get(this.nextQueue).value);
    realtime_params = realtime_params.append("api_name", to_queue_actions.action_name);

    return await this.dataService.getDataPromise("realtime_api_details", realtime_params)
      .then(async (realtime_response) => {
        if (realtime_response != null && realtime_response.status) {
          if (realtime_response.data != null && realtime_response.data.length > 0) {

            dynamic_params = realtime_response.data[0].parameter;
            apiID = realtime_response.data[0].api_id;

            if (dynamic_params != null) {
              dynamic_params = JSON.parse(dynamic_params);
            }
            if (apiID == null) {
              return validation_message;
            }
          }
        }
        else {
          return validation_message;
        }
        return await this.dataService.postPromiseRealTimeAPI(apiID, params).then((validation_response) => {
          if (validation_response != null && (validation_response.error_message == null || validation_response.error_message == "")) {
            if (validation_response.status == true) {
              validation_response = JSON.parse(JSON.parse(validation_response.data));
              if (validation_response != null && validation_response != undefined) {
                this.queue_movement_validation_response = validation_response;
                validation_message = validation_response.error_message != undefined && validation_response.error_message != null && validation_response.error_message != '' ? validation_response.error_message : "";
                validation_message = validation_response.Result != undefined && validation_response.Result != null ? validation_response.Result.error_message : validation_message;
              }
              return validation_message;
            } else {
              this.commonService.showMessageBox(validation_response.error_message, 'Error');
              return '';
            }
          }
          else {
            if (validation_response.errorCode != 0 && validation_response.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
            }
            if (validation_response.errorCode != 0 && validation_response.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
            return '';
          }
        });

      })
      .catch(err => {
        if (err.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
        }
        return validation_message;
      });
  }

  onLineItemExcelFileUpload(excelFile: any) {
    this.isValidLineItemExcelData = false;
    this.lineItemExcelData = [];
    this.invalidLineItemNo = [];
    this.lineItemExcelUploadFileName = 'Choose File';

    if (excelFile.target.files && excelFile.target.files[0]) {

      if (excelFile.target.files[0].type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        this.commonService.showMessageBox("Please select excel file.", "Alert");
        this.lineItemExcelUploadFileControl.nativeElement.value = '';
        return;
      }
      let workBook = null;
      const reader = new FileReader();
      const excelfile = excelFile.target.files[0];

      this.lineItemExcelUploadFileName = excelFile.target.files[0].name;

      reader.onload = async (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        // const sheet = workBook.Sheets[Object.keys(workBook.Sheets)[0]];
        const sheet = workBook.Sheets['LoadDataSheet'];

        if (sheet != undefined)
          this.lineItemExcelData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        if (this.lineItemExcelData == undefined || this.lineItemExcelData.length == 0) {
          this.commonService.showMessageBox("No data found in file.", "Alert");
          this.lineItemExcelUploadFileControl.nativeElement.value = '';
          this.lineItemExcelUploadFileName = 'Choose File';
          return;
        }

        let missingCol = "";
        let cols = Object.keys(this.lineItemExcelData[0]);
        this.workItemFieldChildList_upload.forEach(f => {
          if (cols.findIndex(a => a == f.field_name) == -1) {
            missingCol = (missingCol == '') ? f.field_name : missingCol + ', ' + f.field_name;
          }
        });

        if (missingCol != "") {
          this.commonService.showMessageBox("Below column(s) are missing in excel data file.<br>" + missingCol, "Alert");
          this.lineItemExcelUploadFileControl.nativeElement.value = '';
          this.lineItemExcelUploadFileName = 'Choose File';
          return;
        }

        // START: field length validation
        let validationMessage = '';
        this.lineItemExcelData.forEach((item) => {
          this.workItemFieldChildList_upload.forEach(field => {
            if (field.control_type == 'TEXTBOX') {
              let fix_length = 0;
              if (field.min_length == field.max_length) {
                fix_length = field.min_length;
              }
              let field_value = item[field.field_name];
              if (fix_length > 0 && field_value != '') {

                if (field_value.toString().length != fix_length) {
                  if (validationMessage == "")
                    validationMessage = "Length of " + field.field_name + " must be " + fix_length + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Length of " + field.field_name + " must be " + fix_length + ".";
                }
              }

              if (fix_length == 0 && field.min_length > 0 && field_value != '') {
                if (field_value.toString().length < field.min_length) {
                  if (validationMessage == "")
                    validationMessage = "Length of " + field.field_name + " is min " + field.min_length + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Length of " + field.field_name + " is min " + field.min_length + ".";
                }
              }

              if (fix_length == 0 && field.max_length > 0) {
                if (field_value.toString().length > field.max_length) {
                  if (validationMessage == "")
                    validationMessage = "Length of " + field.field_name + " is up to " + field.max_length + ".";
                  else
                    validationMessage = validationMessage + "<BR>" + "Length of " + field.field_name + " is up to " + field.max_length + ".";
                }
              }
            }
          });
        });
        if (validationMessage != '') {
          this.commonService.showMessageBox(validationMessage, 'Alert');
          this.lineItemExcelUploadFileControl.nativeElement.value = '';
          this.lineItemExcelUploadFileName = 'Choose File';
          return;
        }
        // END: field length validation      

        let result = await this.fileValidation(this.lineItemExcelUploadFileName);
        if (result == false) {
          this.lineItemExcelUploadFileControl.nativeElement.value = '';
          this.lineItemExcelUploadFileName = 'Choose File';
          return;
        }
        else {
          this.isValidLineItemExcelData = true;
        }

      }
      reader.readAsBinaryString(excelfile);
      if (this.lineItemExcelUploadFileControl) {
        this.lineItemExcelUploadFileControl.nativeElement.value = '';
      }
    } else {
      this.lineItemExcelUploadFileName = 'Choose File';
    }
  }

  async fileValidation(filename): Promise<Boolean> {

    let validate: boolean;
    let ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let mandatoryFields = "";
    let numericFields = "";
    let emailFields = "";
    let emailFields_domain = "";
    let childlenMessage = "";
    let childmandatoryFields = "";
    let childdisableFields = "";
    let childnumericFields = "";
    let childdropdownFields = "";
    let childemailFields = "";
    let childemailFields_domain = "";
    let childvalidationMessage = "";
    let validationMessage = "";
    let isValidate: boolean = true;
    let areAllcolumnempty: boolean = true;
    let childitemerror = false;

    mandatoryFields = "";
    numericFields = "";
    emailFields = "";
    emailFields_domain = "";
    validationMessage = "";
    areAllcolumnempty = true;
    childitemerror = false;

    let valuebasedValidationFields = [];
    let valuebasedEditableMandatoryFields: any = [];

    if (this.workItemFieldChildList_upload != null) {
      if (this.workItemFieldChildList_upload.length > 0) {
        if (this.lineItemExcelData != null) {
          this.lineItemExcelData.forEach(data1 => {
            data1["valuebasedMandatoryFields"] = []
            this.workItemFieldChildList_upload.forEach(async field => {
              if (field.is_required_value_based_validation) {
                let fieldValue = data1[field.field_name];
                if (fieldValue != "" && fieldValue != null && fieldValue != undefined) {

                  if (field.control_type == 'DROPDOWN') {
                    const fieldData = field.options.find((d) => d.name.toString().toUpperCase() == fieldValue.toString().toUpperCase());
                    if (fieldData != undefined) {
                      fieldValue = fieldData.id.toString();
                    } else {
                      fieldValue = '0';
                    }
                  }

                  let index1 = valuebasedValidationFields.findIndex(x => x.db_column_name.toUpperCase() == field.db_column_name.toUpperCase() && x.field_value.toUpperCase() == fieldValue.toString().toUpperCase())
                  if (index1 == -1) {
                    let depedent_query_params = [];
                    let params = {
                      project_id: this.transactionDetail.project_id,
                      field_mapping_detail_id: field.field_mapping_detail_id,
                      db_column_name: field.db_column_name,
                      field_value: '' + fieldValue + '',
                      depedent_query_params: depedent_query_params,
                    };
                    valuebasedValidationFields.push(params);
                  }

                }
              }
            });
          });
        }
      }
    }

    //get value based editable / mandatory fields
    if (valuebasedValidationFields.length > 0) {
      valuebasedEditableMandatoryFields = await this.getLineLevelBulkFieldValueBasedValidation(valuebasedValidationFields);
    }

    if (this.workItemFieldChildList_upload != null) {
      if (this.workItemFieldChildList_upload.length > 0) {
        if (this.lineItemExcelData != null) {
          this.lineItemExcelData.forEach(data1 => {
            //This is for child level records
            childlenMessage = "";
            childmandatoryFields = "";
            childnumericFields = "";
            childdropdownFields = "";
            childdisableFields = "";

            childemailFields = "";
            childemailFields_domain = "";
            childvalidationMessage = "";

            data1["valuebasedMandatoryFields"] = [];
            data1["valuebasedDisableFields"] = [];

            this.workItemFieldChildList_upload.forEach(async field => {
              let fieldValue = data1[field.field_name];

              if (fieldValue == null || fieldValue == undefined) fieldValue = "";

              if (field.is_mandatory == 1) {
                if (fieldValue == "") {
                  if (childmandatoryFields.search(field.field_name) == -1)
                    childmandatoryFields = (childmandatoryFields == "") ? field.field_name : childmandatoryFields + ", " + field.field_name;
                }
              }

              if (field.is_readonly == 0 && field.control_type == 'TEXTBOX') {
                if (fieldValue.toString().length > field.max_length) {
                  childlenMessage = (childlenMessage == "") ? field.field_name : childlenMessage + ", " + field.field_name;
                }

                if (field.validation_type == 'NUMERIC') {
                  fieldValue = fieldValue.toString().replace(/,/g, '');
                  if (isNaN(+fieldValue)) {
                    if (childnumericFields.search(field.field_name) == -1)
                      childnumericFields = (childnumericFields == "") ? field.field_name : childnumericFields + ", " + field.field_name;
                  }
                }

                if (field.validation_type == 'EMAIL') {
                  if (fieldValue != "") {
                    if (!ep.test(fieldValue)) {
                      if (childemailFields.search(field.field_name) == -1)
                        childemailFields = (childemailFields == "") ? field.field_name : childemailFields + ", " + field.field_name;
                    }
                    else {
                      if (field.DomainExceptionValue != '') {
                        if (field.DomainExceptionValue.search(fieldValue.split('@').pop()) == -1) {
                          if (childemailFields_domain.search(field.field_name) == -1)
                            childemailFields_domain = (childemailFields_domain == "") ? field.field_name : childemailFields_domain + ", " + field.field_name;
                        }
                      }
                    }
                  }
                }
              }
              if (field.control_type == 'DROPDOWN') {
                if (fieldValue != "" && fieldValue != null && fieldValue != undefined) {
                  const fieldText = field.options.find((d) => d.name.toString().toUpperCase() == fieldValue.toString().toUpperCase()) ?.id;
                  if (fieldText == undefined) {
                    if (childdropdownFields.search(field.field_name) == -1)
                      childdropdownFields = (childdropdownFields == "") ? field.field_name : childdropdownFields + ", " + field.field_name;
                  }
                }
              }
              if (valuebasedEditableMandatoryFields != null) {
                if (field.is_required_value_based_validation) {
                  let valuebasedMandatoryField = {
                    db_column_name: field.db_column_name,
                    field_name: field.field_name,
                    field_mapping_detail_id: field.field_mapping_detail_id,
                    mandatoryfields: [],
                    disablefields: []
                  }

                  if (field.control_type == 'DROPDOWN') {
                    const fieldData = field.options.find((d) => d.name.toString().toUpperCase() == fieldValue.toString().toUpperCase());
                    if (fieldData != undefined) {
                      fieldValue = fieldData.id.toString();
                    }
                  }

                  let targetFields = valuebasedEditableMandatoryFields.filter(x => x.field_mapping_detail_id == field.field_mapping_detail_id && x.field_value.toUpperCase() == fieldValue.toString().toUpperCase());
                  if (targetFields != null) {
                    targetFields.forEach(res => {
                      if (res.is_mandatory) {
                        let targetField = this.workItemFieldChildList_upload.find(f => f.db_column_name == res.db_column_name);
                        if (targetField) {
                          valuebasedMandatoryField["mandatoryfields"].push(targetField.field_name);
                        }
                      }
                      if (!res.is_editable) {
                        let targetField = this.workItemFieldChildList_upload.find(f => f.db_column_name == res.db_column_name);
                        if (targetField) {
                          valuebasedMandatoryField["disablefields"].push(targetField.field_name);
                        }
                      }
                    });
                    data1["valuebasedMandatoryFields"] = valuebasedMandatoryField["mandatoryfields"];
                    data1["valuebasedDisableFields"] = valuebasedMandatoryField["disablefields"];
                  }
                }
              }

            });

            data1["valuebasedMandatoryFields"].forEach(valueField => {
              if (data1[valueField] == "" || data1[valueField] == null || data1[valueField] == undefined) {
                childmandatoryFields = (childmandatoryFields == "") ? valueField : childmandatoryFields + ", " + valueField;
              }
            });

            data1["valuebasedDisableFields"].forEach(valueField => {
              if (data1[valueField] != '' && data1[valueField] != null && data1[valueField] != undefined) {
                childdisableFields = (childdisableFields == "") ? valueField : childdisableFields + ", " + valueField;
              }
            });

            if (childmandatoryFields != "") {
              if (childvalidationMessage != "")
                childvalidationMessage = childvalidationMessage + " ";

              childvalidationMessage = childmandatoryFields + " is mandatory.";
            }

            if (childdisableFields != "") {
              if (childvalidationMessage != "")
                childvalidationMessage = childvalidationMessage + " ";

              childvalidationMessage = childvalidationMessage + childdisableFields + " should be empty.";
            }

            if (childdropdownFields != "") {
              if (childvalidationMessage != "")
                childvalidationMessage = childvalidationMessage + " ";

              childvalidationMessage = childvalidationMessage + "Invalid " + childdropdownFields + "."
            }

            if (childnumericFields != "") {
              if (childvalidationMessage != "")
                childvalidationMessage = childvalidationMessage + " ";

              childvalidationMessage = childvalidationMessage + childnumericFields + " should be numeric."
            }

            if (childemailFields != "") {
              if (childvalidationMessage != "")
                childvalidationMessage = childvalidationMessage + " "

              childvalidationMessage = childvalidationMessage + childemailFields + " is invalid."
            }

            if (childemailFields_domain != "") {
              if (childvalidationMessage != "")
                childvalidationMessage = childvalidationMessage + " "

              childvalidationMessage = childvalidationMessage + childemailFields_domain + " has invalid domain."
            }

            if (childvalidationMessage != "") {
              childitemerror = true;
              data1['Message'] = childvalidationMessage;
            }
            else {
              data1['Message'] = "";
            }

          });
        }
      }
    }

    if (childitemerror)
      isValidate = false;

    if (isValidate != true) {
      // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.lineItemExcelData);
      // const wb: XLSX.WorkBook = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, 'LoadDataSheet');
      // XLSX.writeFile(wb, "Error_" + filename);
      this.commonService.showMessageBox("Data in excel file are invalid. <br> Please look at the Message column on grid for more detail.", "Validation Alert");
      return false;
    }
    //-------------------------------------------------------
    return true;
  }

  viewLineItem() {
    this.showModal(this.lineItemModal, 'fullscreentest');
  }

  async uploadLineItem() {
    let lineItemRequest = {
      document_detail_id: this.documentDetailId,
      project_id: this.commonService.selectedProject,
      document_type_id: this.transactionDetail.document_type_id,
      tabs: [],
    };

    //let invalidValueBasedValidationList = [];
    //let excelRowCount = 0;
    let lstlineItemExcelData = JSON.parse(JSON.stringify(this.lineItemExcelData));

    for (let data1 of lstlineItemExcelData) {
      //this.lineItemExcelData.forEach(async data1 => {
      //excelRowCount++;
      for (const field of this.workItemFieldChildList_upload) {
        //this.workItemFieldChildList_upload.forEach(async field => {
        let fieldValue = data1[field.field_name];

        if (field.control_type == 'DROPDOWN') {
          if (fieldValue != "" && fieldValue != null && fieldValue != undefined) {
            const fieldData = field.options.find((d) => d.name.toString().toUpperCase() == fieldValue.toString().toUpperCase());
            if (fieldData != undefined) {
              data1[field.field_name] = fieldData.id;
            }
            data1[field.field_name + '_text'] = fieldValue;
          } else {
            data1[field.field_name + '_text'] = '';
          }
        }
        // if (field.is_required_value_based_validation == 1) {
        //   let depedent_query_params = [];
        //   let paramsValueBasedValidation = [{
        //     project_id: this.transactionDetail.project_id,
        //     field_mapping_detail_id: field.field_mapping_detail_id,
        //     db_column_name: field.db_column_name,
        //     field_value: data1[field.field_name].toString(),
        //     depedent_query_params: depedent_query_params,
        //   }];
        //   let valuebasedMandatoryFields = await this.getLineLevelBulkFieldValueBasedValidation(paramsValueBasedValidation);

        //   if (valuebasedMandatoryFields != null) {
        //     valuebasedMandatoryFields.forEach(ele => {
        //       const mandatoryFieldName = this.workItemFieldChildList_upload.find(x => x.db_column_name == ele.db_column_name)?.field_name;
        //       if (ele.is_mandatory == 1 && mandatoryFieldName != undefined && data1[mandatoryFieldName] == '') {
        //         invalidValueBasedValidationList.push({ 'RowNo': excelRowCount, 'Remark': mandatoryFieldName + ' is mandatory for ' + field.field_name + ' : ' + fieldValue })
        //       }
        //     });
        //   }
        // }
      }
      //);
    }
    //);

    // if (invalidValueBasedValidationList.length > 0) {
    //   let invalidExcelMsg = '<br><table class="table custom_table"><tr><th>Excel Row</th><th>Remark</th><tr>';
    //   invalidValueBasedValidationList.forEach(ele => {
    //     invalidExcelMsg += '<tr><td>' + ele.RowNo + '</td><td>' + ele.Remark + '</td><tr>';
    //   });
    //   this.commonService.showMessageBox(invalidExcelMsg, 'Invalid excel data', 'Error');
    //   return;
    // }

    lineItemRequest.tabs.push({
      tab_id: this.activeTab.tab_id,
      tab_data: lstlineItemExcelData,
    });
    this.dataService.postData('post-excel-lineitems', lineItemRequest).subscribe((res) => {
      if (res != null && res != undefined) {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == 1) {
            this.commonService.showMessageBox("Line items added successfully.", 'Message');
          }
          else {
            this.commonService.showMessageBox(res.error_message, 'Alert');
          }
          this.lineLevelItemList[this.activeTab.tab_id] = res.data;
          this.lineItemExcelUploadFileControl.nativeElement.value = '';
          this.lineItemExcelUploadFileName = 'Choose File';
          this.lineItemExcelData = [];
          this.isValidLineItemExcelData = false;
          this.isSESValidated = false;
          this.getNonPoLineItemAmountTotal();
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getStatusClass(STATUS) {
    if (STATUS == '' || STATUS == 'Success')
      return "completed-status-btn";
    else if (STATUS == 'In Progess')
      return "in-progress-status-btn";
    else if (STATUS == 'Fail')
      return "error-status-btn";
    else
      return "completed-status-btn";
  }

  getStyle(col, value) {
    let style = {};


    if (col == 'Status') {
      if (value == 'Success') {
        style = { color: 'green' };
      }
      else if (value == 'Fail') {
        style = { color: 'red' };
      }
      else {
        style = { color: 'blue' };
      }
    }
    return style;
  }

  //------------------------Ng2-pdf-viewer-----------------------------------
  onError(event) {
  }


  convertToBase64(url: string) {
    var base64data;
    if (url !== '') {
      if (this.fileExists(url)) {
        this.http.get(url, { responseType: 'blob' })
          .subscribe(res => {
            const reader = new FileReader();
            reader.onloadend = (event: any) => {
              //Here you can do whatever you want with the base64 String
              // base64data = reader.result.toString().replace('data:application/pdf;base64,', '');

            }

            reader.readAsDataURL(res);
          });
      }
    }
  }

  fileExists(url: string) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', url, false);
    xhr.send();

    if (xhr.status === 404) {
      return false;
    } else {
      return true;
    }
  }





  // getCoordinates(field) {

  //   var selectedText = window.getSelection().toString();

  //   if (selectedText != '') {

  //     // var pageIndex = this.pdfComponent.pdfViewer.currentPageNumber - 1
  //     // var page = this.pdfComponent.pdfViewer.getPageView(pageIndex);
  //     var pageIndex = 0;
  //     var page = this.pdfComponent.pdfViewer.getPageView(pageIndex);
  //     //var pageIndex = this.pdfComponent.PDFViewerApplication.pdfViewer.currentPageNumber - 1
  //     //var page = this.pdfComponent.PDFViewerApplication.pdfViewer.getPageView(pageIndex);

  //     var pageRect = page.canvas.getClientRects()[0];
  //     let selectedRect = window.getSelection().getRangeAt(0).getClientRects();


  //     //if (selectedRect.length > 0 && selectedText != '') {
  //     var coords = (pageIndex + 1).toString()

  //     if (this.transactionDetail.ocr_pdftype == 'OCERED') {
  //       coords = coords + '|' + (selectedRect[0].left - pageRect.left) * 2.15;
  //       coords = coords + '|' + (selectedRect[0].top - pageRect.top) * 2.20
  //       coords = coords + '|' + (selectedRect[0].width) * 1.85
  //       coords = coords + '|' + (selectedRect[0].height)
  //     }
  //     else { //Source
  //       coords = coords + '|' + (selectedRect[0].left - pageRect.left) / 1.33;
  //       coords = coords + '|' + (selectedRect[0].top - pageRect.top) / 1.29
  //       coords = coords + '|' + (selectedRect[0].width) / 1.5
  //       coords = coords + '|' + (selectedRect[0].height) / 2
  //     }

  //     this.activeFieldList.forEach((row) => {
  //       row.field_details.forEach(fd => {
  //         if (fd.field_name == field.field_name) {
  //           if (this.frmTransaction.get(fd.db_column_name).disabled == false) {
  //             if (fd.control_type == 'DATE') {
  //               selectedText = this.getDateValue(selectedText)
  //               this.frmTransaction.get(fd.db_column_name).setValue(selectedText)
  //             }
  //             else {
  //               this.frmTransaction.get(fd.db_column_name).setValue(selectedText);
  //             }

  //             if (this.ocrFieldList.hasOwnProperty(field.db_column_name)) {
  //               this.ocrFieldList[field.db_column_name].manual_coordinate = coords;
  //               this.ocrFieldList[field.db_column_name].manual_value = selectedText;
  //               this.ocrFieldList[field.db_column_name].is_manual = 1;
  //             }
  //             else {
  //               this.ocrFieldList[field.db_column_name] = {
  //                 field_mapping_detail_id: field.field_mapping_detail_id,
  //                 manual_coordinate: coords,
  //                 manual_value: selectedText,
  //                 is_manual: 1
  //               }
  //             }
  //           }
  //         }
  //       });
  //     });
  //   }
  //   else {
  //     if (this.ocrFieldList.hasOwnProperty(field.db_column_name)) {
  //       if (this.ocrFieldList[field.db_column_name].manual_coordinate != undefined
  //         && this.ocrFieldList[field.db_column_name].manual_coordinate != ''
  //         && this.ocrFieldList[field.db_column_name].manual_coordinate != '||||') {
  //         this.highlightText(this.ocrFieldList[field.db_column_name].manual_coordinate);
  //       }
  //       else if (this.ocrFieldList[field.db_column_name].ocr_coordinate != undefined
  //         && this.ocrFieldList[field.db_column_name].ocr_coordinate != ''
  //         && this.ocrFieldList[field.db_column_name].ocr_coordinate != '||||') {

  //         let arr = this.ocrFieldList[field.db_column_name].ocr_coordinate.split("|");
  //         let crd = arr[0] + "|" + arr[1] + "|" + arr[3] + "|" + arr[4] + "|" + arr[2]
  //         this.highlightText(crd);
  //       }
  //     }
  //   }

  // }

  // highlightText(coords) {
  //   let coArray = coords.split('|');
  //   let pageIndex = Number(coArray[0]) - 1

  //   if (this.transactionDetail.ocr_pdftype == 'OCERED') {
  //     coArray[1] = (Number(coArray[1]) / 2.15).toString()
  //     coArray[2] = ((Number(coArray[2]) / 2.20) - 7).toString()
  //     coArray[3] = (Number(coArray[3]) / 1.85).toString()
  //     coArray[4] = (Number(coArray[4]) + 7).toString()

  //     coArray[1] = (Number(coArray[1]) - 10).toString();// left
  //     coArray[3] = (Number(coArray[3]) + 20).toString();// right
  //   }
  //   else { //Source
  //     coArray[1] = (Number(coArray[1]) * 1.33).toString() // left
  //     coArray[2] = (Number(coArray[2]) * 1.29).toString();
  //     coArray[3] = (Number(coArray[3]) * 1.5).toString();// right
  //     coArray[4] = (Number(coArray[4]) * 2).toString()
  //   }

  //   var page = this.pdfComponent.pdfViewer.getPageView(pageIndex);
  //   //var page = this.pdfComponent.PDFViewerApplication.pdfViewer.getPageView(pageIndex);

  //   var pageElement = page.canvas.parentElement;
  //   var viewport = page.viewport;

  //   this.newPDFElement.setAttribute('style', 'position:absolute; border: 2px solid red;background: #ffff0087;' +
  //     'left:' + coArray[1] + 'px; top:' + coArray[2] + 'px; width:' + coArray[3] + 'px; height:' + coArray[4] + 'px;');

  //   pageElement.appendChild(this.newPDFElement);
  // }

  getDateValue(value): string {

    let createdDate = '';

    let arr = value.split('/');

    if (arr.length <= 1) {
      arr = value.split('-')
    }

    if (arr.length <= 1) {
      arr = value.split('.')
    }

    if (arr.length > 2) {
      let firstPart = arr[0].toString();

      if (firstPart.length == 4) {
        createdDate = firstPart + '-' + arr[1].toString().padStart(2, "0") + '-' + arr[2].toString().padStart(2, "0");
      }

      if (firstPart.length == 3) {
        if (Number(firstPart) > 12) {

        }
      }

      if (firstPart.length == 2) {
        createdDate = arr[2].toString();  //Year
        if (createdDate.length == 2) {
          createdDate = '20' + createdDate;
        }
        if (Number(firstPart) > 12) {
          createdDate = createdDate + '-' + arr[1].toString() + '-' + arr[0].toString().padStart(2, "0");
        }
        else {
          if (arr[1].toString().length >= 3) {
            createdDate = createdDate + '-' + this.getMonth(arr[1].toString()) + '-' + arr[0].toString();
          }
          else {
            createdDate = createdDate + '-' + arr[1].toString().padStart(2, "0") + '-' + arr[0].toString().padStart(2, "0");
          }
        }
      }

      if (firstPart.length == 1) {
        createdDate = arr[2].toString(); //Year
        if (createdDate.length == 2) {
          createdDate = '20' + createdDate;
        }

        if (arr[1].toString().length >= 3) {
          createdDate = createdDate + '-' + this.getMonth(arr[1].toString()) + '-' + arr[0].toString().padStart(2, "0");
        }
        else {
          createdDate = createdDate + '-' + arr[1].toString().padStart(2, "0") + '-' + arr[0].toString().padStart(2, "0");
        }
      }

    }

    return createdDate;
  }

  getMonth(monthName): string {
    if (monthName.toLowerCase() == 'jan')
      return '01';
    else if (monthName.toLowerCase() == 'feb')
      return '02';
    else if (monthName.toLowerCase() == 'mar')
      return '03';
    else if (monthName.toLowerCase() == 'apr')
      return '04';
    else if (monthName.toLowerCase() == 'may')
      return '05';
    else if (monthName.toLowerCase() == 'jun')
      return '06';
    else if (monthName.toLowerCase() == 'jul')
      return '07';
    else if (monthName.toLowerCase() == 'aug')
      return '08';
    else if (monthName.toLowerCase() == 'sep')
      return '09';
    else if (monthName.toLowerCase() == 'oct')
      return '10';
    else if (monthName.toLowerCase() == 'nov')
      return '11';
    else if (monthName.toLowerCase() == 'dec')
      return '12';
    else
      return '01';
  }
  //------------------------Ng2-pdf-viewer-----------------------------------
  changeEmail(event: any) {

    let ep: any = '';
    let emailValidate: boolean = true;
    let validationMessage: string = '';
    let is_To_event: boolean = true;

    if (event.target.id == "txtRQCC") {
      is_To_event = false;
    }

    if (is_To_event == true) {

      //to email id
      if (this.strRQTO == "") {
        validationMessage += "<BR>" + "To email id require in raise query.";
      }
      else if (this.strRQTO != "") {


        if (this.dataService.allow_multiple_emailid_in_to_email_section == false)
          //set single id check
          ep = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        else
          //to support multiple email ids
          ep = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;

        emailValidate = ep.test(this.strRQTO)

        if (emailValidate != true) {
          validationMessage += "<BR>" + "Invalid to email id in raise query.";

        }
        else {

          if (this.isDomainRequire == true) {
            let lstDomain = this.strRQTO.split(";")

            lstDomain.every(element => {
              var domain = element.substring(element.lastIndexOf("@"));
              let index = this.lstDomainValues.findIndex(a => a === domain);
              if (index == -1) {
                validationMessage += "<BR>" + "Invalid domain found in To Email Id.";
                return false;

              }

              return true;
            });

          }
        }
      }
    }
    else {

      if (this.strRQCC != "") {
        //to support multiple email ids
        ep = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;
        emailValidate = ep.test(this.strRQCC)
        if (emailValidate != true) {
          validationMessage += "<BR>" + "Invalid cc email id in raise query.";
        }
        else {
          if (this.isDomainRequire == true) {
            let lstDomain = this.strRQCC.split(";")
            lstDomain.every(element => {
              var domain = element.substring(element.lastIndexOf("@"));
              let index = this.lstDomainValues.findIndex(a => a === domain);
              if (index == -1) {
                validationMessage += "<BR>" + "Invalid domain found in Cc Email Id.";
                return false;
              }
              return true;
            });
          }

        }
      }

    }


    if (validationMessage != "") {
      this.commonService.showMessageBox(validationMessage, 'Alert');
    }
    else {
      let params = new HttpParams();
      params = params.append('project_id', this.commonService.selectedProject);
      if (is_To_event == true) {
        params = params.append('email_id', this.strRQTO.toString());

      }
      else {
        params = params.append('email_id', this.strRQCC.toString());
      }
      this.dataService.getData('get-restricted-email-detail', params).subscribe(
        (res) => {

          let is_email_popup: number = 0;
          if (res != null && res != undefined) {
            if (res ?.data ?.length > 0) {
              is_To_event == true ? this.strRQTO = '' : this.strRQCC = '';
              let strTable = '<table class="table custom_table"><tr><th><small>Input Email</small></th><th><small>Alternate Email</small></th></tr>';
              res.data ?.forEach(c => {
                if (c["IS_RESTRICTED"] == 1) {
                  is_email_popup = 1;
                  strTable += '<tr><td>' + c["Input Email"] + '</td><td>' + c["Alternate Email"] + '</td></tr>';
                  if (is_To_event == true) {
                    //this.strRQTO = c["Alternate Email"];
                    if (this.dataService.allow_multiple_emailid_in_to_email_section == false)
                      this.strRQTO = c["Alternate Email"];
                    else
                      this.strRQTO += this.strRQTO == '' ? c["Alternate Email"] == '' ? '' : c["Alternate Email"] : c["Alternate Email"] == '' ? '' : ';' + c["Alternate Email"];

                  }
                  else {
                    this.strRQCC += this.strRQCC == '' ? c["Alternate Email"] == '' ? '' : c["Alternate Email"] : c["Alternate Email"] == '' ? '' : ';' + c["Alternate Email"];
                  }
                }
                else {
                  if (is_To_event == true) {
                    //this.strRQTO = c["Input Email"];
                    if (this.dataService.allow_multiple_emailid_in_to_email_section == false)
                      this.strRQTO = c["Input Email"];
                    else
                      this.strRQTO += this.strRQTO == '' ? c["Input Email"] == '' ? '' : c["Input Email"] : c["Input Email"] == '' ? '' : ';' + c["Input Email"];
                  }
                  else {
                    this.strRQCC += this.strRQCC == '' ? c["Input Email"] == '' ? '' : c["Input Email"] : c["Input Email"] == '' ? '' : ';' + c["Input Email"];
                  }

                }

              });
              strTable += '</table>';
              if (is_email_popup == 1) {
                this.commonService.showMessageBox('<p>We found some entered restricted email ids and replaced with alternative email ids if any.</p>' + strTable, 'Error');
              }

            }

          }

        });

    }
  }

  async get_field_value_based_validation_settings(field: any) {

    let depedent_query_params = [];
    let field_value = this.frmTransaction.get(field.db_column_name).value;
    let params = {
      // project_id: this.transactionDetail.project_id,
      Projectid: this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.project_id),
      field_mapping_detail_id: field.field_mapping_detail_id,
      db_column_name: field.db_column_name,
      field_value: field_value.toString(),
      depedent_query_params: depedent_query_params,
    };

    let res_field_validation = await this.commonService.get_field_value_based_validation_settings(params);

    if (res_field_validation != undefined && res_field_validation != null && res_field_validation != "") {
      res_field_validation.forEach((x) => {

        if (this.frmTransaction.get(x.db_column_name) != null) {

          this.frmTransaction.get(x.db_column_name).clearValidators();

          this.frmTransaction.get(x.db_column_name).setValue('');

          if (x.is_mandatory == 1) {
            this.frmTransaction.get(x.db_column_name).setValidators([Validators.required]);
            this.frmTransaction.get(x.db_column_name).enable();
          }
          if (x.is_editable == 1) {
            this.frmTransaction.get(x.db_column_name).enable();
          }
          else {
            this.frmTransaction.get(x.db_column_name).disable();
          }
          this.activeFieldList.forEach(section => {
            let f = section.field_details.find(a => a.db_column_name == x.db_column_name);
            if (f != undefined && f != null) {
              f.is_mandatory = x.is_mandatory;
              f.is_editable = x.is_editable;
              if (f.is_autocomplete == 1) {
                let auto_controls = this.dynamic_auto_complete["_results"];
                if (auto_controls != null && auto_controls != undefined) {
                  let current_control = auto_controls.filter((item) => item.field.db_column_name == x.db_column_name);
                  if (current_control != null && current_control.length > 0) {
                    current_control[0].myControl.setValue('');
                    if (x.is_editable == 0) {
                      current_control[0].myControl.disable();
                    }
                    else {
                      current_control[0].myControl.enable();
                    }
                    current_control[0].ngOnInit();
                  }
                }
              }
            }
          });
        }
      });
    }

  }

  async getLineLevelFieldValueBasedValidation(field: any, fieldValue: any) {

    let depedent_query_params = [];
    let params = {
      // project_id: this.transactionDetail.project_id,
      Projectid: this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.project_id),
      field_mapping_detail_id: field.FIELD_MAPPING_DETAIL_ID,
      db_column_name: field.DB_COLUMN_NAME,
      field_value: fieldValue.replace(/^0+/, ""),
      depedent_query_params: depedent_query_params,
    };

    let res_field_validation = await this.commonService.get_field_value_based_validation_settings(params);
    if (res_field_validation != undefined && res_field_validation != null && res_field_validation != "") {
      return res_field_validation;
    }

  }

  async getLineLevelBulkFieldValueBasedValidation(valuebasedValidationFields: any) {
    let res_field_validation = await this.commonService.get_bulk_field_value_based_validation_settings_async(valuebasedValidationFields);
    if (res_field_validation != undefined && res_field_validation != null && res_field_validation != "") {
      return res_field_validation;
    }
  }

  onchangeSelectAll_Checklist(checked_status: boolean) {
    this.chkSelectAllCheckList = checked_status;
    if (checked_status) {
      this.checklist.forEach((element) => {
        element['checked'] = true;
      });
    }
    else {
      this.checklist.forEach((element) => {
        element['checked'] = false;
      });
    }
  }

  onchange_checklistOption(event: any) {
    let selected_checkItem = this.checklist.filter(
      (option) => option.checked == true
    );
    if (selected_checkItem.length == this.checklist.length) {
      this.chkSelectAllCheckList = true;
    }
    else {
      this.chkSelectAllCheckList = false;
    }

  }

  omit_special_char(e, regExp) {
    // var k;
    // k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));

    //var regex = new RegExp("^[ A-Za-z0-9_@./#+-]*$");
    // VALID_INPUT_REGEXP = '^\d*(\.\d{0,2})?$'// for numberic    
    if (regExp == "" || regExp == null || regExp == undefined)
      return true;

    var regex = new RegExp(regExp);
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }

  omit_onPaste(e) {
    ///(paste)="onPaste($event)" add this line into html input.
    e.preventDefault();
    return false;
  }
  //Chaya 20-July-2022 Duplicate Soft/Hard stop -- Start
  continuewithoutDuplicateInvoice() {
    this.isDuplicate = true;
    this.IsContinueWithoutDuplicate = true;
    this.submitTransaction();
  }
  //Chaya 20-July-2022 Duplicate Soft/Hard stop -- end

  getSupportingDocuments() {
    this.supportDocFileSize = {};
    this.supportDocValidFileExtensions = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('document_type_id', this.transactionDetail.document_type_id);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.document_type_id));
    params = params.append('document_type', 'SUPPORTING_DOC');
    this.dataService
      .getData('upload-file-validation', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.supportDocFileSize = res.data[0] ?.file_size;
              this.supportDocValidFileExtensions = res.data[0] ?.file_type.split(',');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  advanceSearchCellClick(event: any) {
    if (event.columnName == 'action_radio_button') {
      this.advanceSeachSelectedRecord = event.rowData;
    }
  }

  SeachRealtimeData(field: any, action: any) {

    if (action != null) {

      let params = new HttpParams();
      params = params.append("project_id", this.commonService.selectedProject);
      params = params.append("document_type_id", 0);
      params = params.append("process_id", 0);
      params = params.append("api_name", action);

      this.dataService.getData("realtime_api_details", params).subscribe(res => {
        if (res != null && res.status) {
          if (res.data != null && res.data.length > 0) {

            let params = res.data[0].parameter;
            let apiID = res.data[0].api_id;

            if (params != null) {
              params = JSON.parse(params);
            }
            else {

              let searchColumns = {};
              searchColumns['PONUMBER'] = field;
              params = {

                sub_group_id: this.commonService.selectedSubgroup.toString(),
                search_columns: searchColumns,

              };
            }
            this.dataService.post_realTimeApi(apiID, params).subscribe((res) => {
              if (res != null && (res.error_message == null || res.error_message == "")) {
                if (res.status == true) {
                  res = JSON.parse(JSON.parse(res.data));
                  this.lstPOMaster = res.Result.data;
                  //this.strponumber=this.frmTransaction.get(field.db_column_name)?.value;
                  // this.showModal(this.RealtimeDataModal, 'xl');
                } else {
                  this.commonService.showMessageBox(res.error_message, 'Error');
                  return;
                }
              }
              else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                  this.router.navigateByUrl('/unauthorized');
                  return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                  this.commonService.showMessageBox("Internal error")
                }
              }
            },
              error => {
                if (error.includes("401")) {
                  this.router.navigateByUrl('/unauthorized');
                  return;
                }
              });
          } else {
            this.commonService.showMessageBox('Realtime API details not available for current selection', 'Alert');
          }
        }
      });

    }

  }

  submitAdvanceSearchResult() {
    if (this.advanceSeachSelectedRecord.hasOwnProperty('record_id')) {
      this.activeFieldList.forEach(section => {
        section.field_details.forEach((field) => {
          if (field.field_name == 'PO Number') {
            this.frmTransaction.get(field.db_column_name).setValue(this.advanceSeachSelectedRecord["po_number"]);
          }
          else if (field.field_name == 'Vendor No') {
            this.frmTransaction.get(field.db_column_name).setValue(this.advanceSeachSelectedRecord["record_id"]);
            this.getDependantFields(field.field_mapping_detail_id, this.frmTransaction.get(field.db_column_name).value);
          }
        });
      })
    }
    else {
      alert('Please select record');
    }

  }

  PullRealTimeData(field: any, action: any) {

    let pattern = /^.{5,}$/
    let input = field;
    let match = pattern.test(input);
    if (match) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: 'Are you sure want to pull realtime data?',
          buttonText: {
            ok: 'Yes',
            cancel: 'No',
          },
        },
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          if (action != null) {

            let params = new HttpParams();
            params = params.append("project_id", this.commonService.selectedProject);
            params = params.append("document_type_id", 0);
            params = params.append("process_id", 0);
            params = params.append("api_name", action);
            this.dataService.getDataPromise("realtime_api_details", params).then(res => {
              if (res != null && res.status) {
                if (res.data != null && res.data.length > 0) {

                  let params = res.data[0].parameter;
                  let apiID = res.data[0].api_id;

                  if (params != null) {
                    params = JSON.parse(params);
                  }
                  else {
                    let searchColumns = {};
                    searchColumns['PONUMBER'] = field;
                    params = {
                      sub_group_id: this.commonService.selectedSubgroup.toString(),
                      project_id: this.commonService.selectedProject.toString(),
                      process_id: this.transactionDetail.process_id.toString(),
                      search_columns: searchColumns,
                    };
                  }

                  this.dataService.post_realTimeApi(apiID, params).subscribe((res) => {
                    if (res != null && (res.error_message == null || res.error_message == "")) {
                      if (res.status == true) {
                        res = JSON.parse(JSON.parse(res.data));
                        if (res.Result.data != null) {
                          this.lstPOMaster = [];
                          res.Result.data.Table.forEach((x) => {
                            this.lstPOMaster.push(x);
                          });
                        }
                        else {
                          this.commonService.showMessageBox('Not able to find realtime details for current selection', 'Alert');
                        }
                      } else {
                        this.commonService.showMessageBox(res.error_message, 'Error');
                        return;
                      }
                    }
                    else {
                      if (res.errorCode != 0 && res.errorCode == 4000) {
                        this.router.navigateByUrl('/unauthorized');
                        return;
                      }
                      if (res.errorCode != 0 && res.errorCode == 3000) {
                        this.commonService.showMessageBox("Internal error")
                      }
                    }
                  },
                  error => {
                    if (error.includes("401")) {
                      this.router.navigateByUrl('/unauthorized');
                      return;
                    }
                  });
                } else {
                  this.commonService.showMessageBox('Realtime API details not available for current selection', 'Alert');
                }
              }
            });

          }

        }
      });
    }
    else {
      this.commonService.showMessageBox('Please enter minimum 5 characters for PO number realtime search', 'Alert');
    }
  }

  splitInvoiceFile() {

    let splitIndexes = '';
    if (this.splitFileBy == 'INTERVAL') {
      if (this.splitIntervalCount == 0 || this.splitIntervalCount.toString() == '') {
        this.commonService.showMessageBox('Please enter Page Interval to Split', 'alert');
        return;
      }
      splitIndexes = this.splitIntervalCount.toString();
    } else if (this.splitFileBy == 'ExtractPage') {
      if (this.splitStartIndex.toString() == '') {
        this.commonService.showMessageBox('Please enter Start Page Index to Split', 'alert');
        return;
      }
      if (this.splitEndIndex.toString() == '') {
        this.commonService.showMessageBox('Please enter End Page Index to Split', 'alert');
        return;
      }
      splitIndexes = this.splitStartIndex.toString() + ',' + this.splitEndIndex.toString();
    } else if (this.splitFileBy == 'ExtractPagenumbers') {
      if (this.splitExtractPageNumbers == '') {
        this.commonService.showMessageBox('Please enter extract page numbers by comma separated to Split', 'alert');
        return;
      }
      splitIndexes = this.splitExtractPageNumbers;
    }

    let params = new HttpParams();
    params = params.append('pdfFilePath', this.transactionDetail.invoice_file[0].invoice_file_name);
    params = params.append('Flag', this.splitFileBy);
    params = params.append('Indexes', splitIndexes);

    this.dataService.getData('PDFSpliter/pdf-spliter-text', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.status == true) {
          this.splittedFiles = res.data;
          this.commonService.showMessageBox('Invoice file splitted successfully.', 'success');
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  splitInvoiceGridCellClick(event: any) {
    if (event.columnName.toLowerCase() == 'action_icon_download') {
      this.commonService.openAttachment('', event.rowData.FilePath);
    }
  }

  //   getTooltip(e: any)
  //   {
  //    let s:any = window.getSelection();
  //    let oRange:any = s.getRangeAt(0);
  //    let oRect:any = oRange.getBoundingClientRect();


  //       e.stopPropagation();
  //       //let tar:any = e.target.getBoundingClientRect();
  //       $('#tooltipLocal').css({

  //       left:oRect.left+oRect.width,
  //       top:oRect.top

  //       }).show();


  //     let result = window.getSelection().toString().replace(/^\s+|\s+$/gm,'');
  //       if(result.length<=0) //check length if >0 then only proceed
  //       {
  //       e.stopPropagation();
  //        $('#tooltipLocal').hide();
  //       }

  //       this.dataTranslation=result;

  //   }

  // API_Call(text: any) {
  //   var myText = text;//this.dataTranslation;
  //   var lang = "en";
  //   //this.configServise.translate(myText, lang).subscribe((res:any)=> {
  //     //this.transalatedData = res.data.translations[0].translatedText;

  //  this.dataService.getDataFromExteralApi(url, null).subscribe((res) => {

  //     this.transalatedData = res['data'].translations[0].translatedText;
  //     // $('#translated').text(res['data'].translations[0].translatedText);
  //     // $('#languageDet').text(res['data'].translations[0].detectedSourceLanguage);
  //     this.displayStyle = "block";
  //   });

  // }

  PdfTranslator() {
    //   let params = {
    //     attachment_encoded: this.transactionDetail.invoice_file[0].invoice_file_encoded
    //   };
    //   this.dataService.postData('getpdftext', params).subscribe((res) => {
    //     if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
    //       if (res != null && res.success == true) {
    //         this.API_Call(res.data.m_StringValue);
    //       }
    //       else {
    //         this.commonService.showMessageBox("unable to translate");
    //       }
    //     }
    //     else {
    //       if (res.errorCode != 0 && res.errorCode == 4000) {
    //         this.router.navigateByUrl('/unauthorized');
    //         return;
    //       }
    //       if (res.errorCode != 0 && res.errorCode == 3000) {
    //         this.commonService.showMessageBox("Internal error")
    //       }
    //     }
    //   });
  }

  Tolerance_Limit_validation(forValidate) {
    let is_valid = true;
    let header_invoice_amount: number = parseFloat(this.invoiceAmount.toString());

    let line_item_Total_amount: number = parseFloat(this.totalPOLineItemAmount.toString());
    let lower_tolerance_limit = 0;
    let obj_Tolerance_limit = this.tolerance_limit_obj.length > 0 ? this.tolerance_limit_obj[0] : null;
    if (obj_Tolerance_limit != null) {
      if (obj_Tolerance_limit.tolerance_type == "PERCENTAGE") {
        let min_perc_tolerance = header_invoice_amount * (obj_Tolerance_limit.lower_limit_percentage / 100);
        let max_perc_tolerance = header_invoice_amount * (obj_Tolerance_limit.upper_limit_percentage / 100);
        lower_tolerance_limit = min_perc_tolerance < max_perc_tolerance ? min_perc_tolerance : max_perc_tolerance;
      }
      if (obj_Tolerance_limit.tolerance_type == "FIXED") {
        lower_tolerance_limit = obj_Tolerance_limit.lower_limit_fixed;
      }
      if (obj_Tolerance_limit.tolerance_type == "BOTH") {
        let percentage_tolerance = header_invoice_amount * (obj_Tolerance_limit.upper_limit_percentage / 100);
        let fixed_tolerance = obj_Tolerance_limit.upper_limit_fixed;
        lower_tolerance_limit = percentage_tolerance < fixed_tolerance ? percentage_tolerance : fixed_tolerance;
      }
      this.tolerance_calculated_Range = lower_tolerance_limit;
      let min_limit = header_invoice_amount - lower_tolerance_limit;
      let max_limit = header_invoice_amount + lower_tolerance_limit;
      if (this.invoiceAmount != this.totalPOLineItemAmount) {
        if (forValidate == "POLINEITEM") {
          if (line_item_Total_amount > max_limit) {
            return false;
          }
        }

        if (forValidate == "ONSUBMIT") {
          if (line_item_Total_amount < min_limit || line_item_Total_amount > max_limit) {
            return false;
          }
        }
      }

    }
    return is_valid;
  }
  getDateFieldValue(field: any) {
    return this.frmTransaction.get(field.db_column_name).value;
  }
  clearDateFieldValue(field: any) {
    this.frmTransaction.get(field.db_column_name).setValue('');
    //field.field_value='';
  }
  async startProgress(index, res) {

    this.isLoadProgress = true;
    let filteredFile = this.attachmentList.filter((u, index) => index === index)
      .pop();
    //  logic to fetch the percentage progress
    if (filteredFile != null) {
      let fileSize = this.commonService.getFileSize(this.file.size);
      let fileSizeInWords = this.commonService.getFileSizeUnit(this.file.size);
      if (this.commonService.isApiSetup) {
        if (res.status === 'progress') {
          let completedPercentage = parseFloat(res.message);
          filteredFile.FileProgessSize = `${(
            (fileSize * completedPercentage) /
            100
          ).toFixed(2)} ${fileSizeInWords}`;
          filteredFile.FileProgress = completedPercentage;
        } else if (res.status === 'completed') {
          filteredFile.Id = res.Id;
          filteredFile.FileProgessSize = fileSize + ' ' + fileSizeInWords;
          filteredFile.FileProgress = 100;
          this.isLoadProgress = false;
          this.commonService.showMessageBox('Attachment uploaded.', 'Success');
        }
      } else {
        for (
          var f = 0;
          f < fileSize + fileSize * 0.0001;
          f += fileSize * 0.01
        ) {
          filteredFile.FileProgessSize = f.toFixed(2) + ' ' + fileSizeInWords;
          var percentUploaded = Math.round((f / fileSize) * 100);
          filteredFile.FileProgress = percentUploaded;
          if (parseFloat(filteredFile.FileProgessSize.match(/[\d\.]+/)) !== fileSize) {
            await this.progressLoader(Math.floor(percentUploaded));
          }
          else {
            this.isLoadProgress = false;
            this.commonService.showMessageBox('Attachment uploaded.', 'Success');
          }
        }
      }
    }
  }
  progressLoader(ms: number) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }



}

